import * as i0 from '@angular/core';
import { inject, NgZone, input, output, viewChild, viewChildren, Component, Input, HostListener, Injectable, ApplicationRef, createComponent, Pipe, ViewEncapsulation, computed, forwardRef, ElementRef, HostBinding, RendererFactory2, TemplateRef, Injector, Directive, LOCALE_ID, ErrorHandler, NgModule } from '@angular/core';
import Selectable from 'selectable.js';
import { NgClass, NgTemplateOutlet, DatePipe, NgStyle, registerLocaleData } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, of, Observable, EMPTY, endWith, fromEvent, timer, race, zip, throwError } from 'rxjs';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as lodash from 'lodash';
import { get, isEqual, clone, merge, set, cloneDeep, uniq } from 'lodash';
import { takeUntil, filter, take, tap, switchMap, map, withLatestFrom, catchError } from 'rxjs/operators';
import { Chart, registerables, defaults } from 'chart.js';
import localeDEDE from '@angular/common/locales/de';
const _c0 = ["tableBody"];
const _c1 = ["heads"];
const _c2 = a0 => ({
  timeZone: a0,
  weekday: "short"
});
const _c3 = a0 => ({
  timeZone: a0
});
const _c4 = a0 => ({
  timeZone: a0,
  hour: "2-digit",
  minute: "2-digit"
});
const _c5 = (a0, a1, a2) => ({
  entry: a0,
  cellWidth: a1,
  cells: a2
});
const _forTrack0 = ($index, $item) => $item.name;
const _forTrack1 = ($index, $item) => $item.dayOrHour;
function CalendarComponent_Conditional_0_Conditional_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("colSpan", ctx_r2.months.get(month_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 2, month_r2 + "-01T00:00:00Z", "MMMM", "UTC+0"), " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 4);
    i0.ɵɵrepeaterCreate(2, CalendarComponent_Conditional_0_Conditional_2_For_3_Template, 3, 6, "th", 14, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.getMonths());
  }
}
function CalendarComponent_Conditional_0_For_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_For_15_Template_button_click_0_listener() {
      const group_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      ctx_r2.filterString = "gruppe:" + group_r5.name;
      return i0.ɵɵresetView(ctx_r2.saveFilter());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(group_r5.name);
  }
}
function CalendarComponent_Conditional_0_For_17_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayOrHour_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(dayOrHour_r7.dayOrHour.toLocaleDateString("de-DE", i0.ɵɵpureFunction1(2, _c2, ctx_r2.timeZone())));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", dayOrHour_r7.dayOrHour.toLocaleDateString("sv-SE", i0.ɵɵpureFunction1(4, _c3, ctx_r2.timeZone())).substring(8, 10), ".");
  }
}
function CalendarComponent_Conditional_0_For_17_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayOrHour_r7 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("\u2013 ", dayOrHour_r7.endTime.toLocaleTimeString("de-DE", i0.ɵɵpureFunction1(1, _c4, ctx_r2.timeZone())), "");
  }
}
function CalendarComponent_Conditional_0_For_17_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, CalendarComponent_Conditional_0_For_17_Conditional_3_Conditional_2_Template, 2, 3, "span", 17);
  }
  if (rf & 2) {
    const dayOrHour_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(dayOrHour_r7.dayOrHour.toLocaleTimeString("de-DE", i0.ɵɵpureFunction1(2, _c4, ctx_r2.timeZone())));
    i0.ɵɵadvance();
    i0.ɵɵconditional(dayOrHour_r7.endTime && dayOrHour_r7.endTime.getTime() - dayOrHour_r7.dayOrHour.getTime() > 3600000 ? 2 : -1);
  }
}
function CalendarComponent_Conditional_0_For_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 15, 1);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_For_17_Template_th_click_0_listener($event) {
      const dayOrHour_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickOnHeadCellEmitter.next({
        event: $event,
        timestamp: dayOrHour_r7.dayOrHour
      }));
    })("keydown.enter", function CalendarComponent_Conditional_0_For_17_Template_th_keydown_enter_0_listener($event) {
      const dayOrHour_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickOnHeadCellEmitter.next({
        event: $event,
        timestamp: dayOrHour_r7.dayOrHour
      }));
    })("keydown.space", function CalendarComponent_Conditional_0_For_17_Template_th_keydown_space_0_listener($event) {
      const dayOrHour_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickOnHeadCellEmitter.next({
        event: $event,
        timestamp: dayOrHour_r7.dayOrHour
      }));
    })("contextmenu", function CalendarComponent_Conditional_0_For_17_Template_th_contextmenu_0_listener($event) {
      const dayOrHour_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.contextMenuOnHeadCellEmitter.next({
        event: $event,
        timestamp: dayOrHour_r7.dayOrHour
      }));
    });
    i0.ɵɵtemplate(2, CalendarComponent_Conditional_0_For_17_Conditional_2_Template, 4, 6)(3, CalendarComponent_Conditional_0_For_17_Conditional_3_Template, 3, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayOrHour_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", dayOrHour_r7.className)("tabindex", ctx_r2.clickOnHeadCellEmitter.observed || ctx_r2.contextMenuOnHeadCellEmitter.observed ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.mode() === "DAY" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.mode() === "HOUR" ? 3 : -1);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 23);
    i0.ɵɵlistener("dblclick", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_6_Template_th_dblclick_0_listener($event) {
      const dayOrHour_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitDoubleClickOnCell($event, dayOrHour_r9.dayOrHour, null));
    })("contextmenu", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_6_Template_th_contextmenu_0_listener($event) {
      const dayOrHour_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitContextMenuOnCell($event, dayOrHour_r9.dayOrHour, null));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayOrHour_r9 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", dayOrHour_r9.className);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(row_r11.icon);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_For_2_Conditional_0_Template, 1, 0, "br");
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const part_r12 = ctx.$implicit;
    const ɵ$index_90_r13 = ctx.$index;
    i0.ɵɵconditional(ɵ$index_90_r13 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", part_r12, " ");
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵrepeaterCreate(1, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_For_2_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵstyleProp("font-size", ctx_r2.rowNameFontSize(), "px");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r11.name.split("\n"));
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 33);
  }
  if (rf & 2) {
    let tmp_38_0;
    const badge_r14 = ctx.$implicit;
    i0.ɵɵclassMap(badge_r14.colorClass + " " + badge_r14.icon);
    i0.ɵɵproperty("title", (tmp_38_0 = badge_r14.tooltip) !== null && tmp_38_0 !== undefined ? tmp_38_0 : "");
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵrepeaterCreate(1, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_5_For_2_Template, 1, 3, "i", 32, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r11.badges);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 40);
  }
  if (rf & 2) {
    let tmp_51_0;
    let tmp_52_0;
    let tmp_53_0;
    let tmp_54_0;
    const entry_r18 = i0.ɵɵnextContext(2).$implicit;
    const ɵ$index_101_r19 = i0.ɵɵnextContext().$index;
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵstyleProp("background-color", entry_r18.bufferColor)("margin-left", ctx_r2.cellWidth * ctx_r2.Math.min((tmp_51_0 = entry_r18.bufferStartUnits) !== null && tmp_51_0 !== undefined ? tmp_51_0 : 0, ɵ$index_101_r19) * -1 + 3, "px")("width", ctx_r2.cellWidth * (((tmp_52_0 = ctx_r2.cells.get(entry_r18)) !== null && tmp_52_0 !== undefined ? tmp_52_0 : 0) + ctx_r2.Math.min((tmp_52_0 = entry_r18.bufferStartUnits) !== null && tmp_52_0 !== undefined ? tmp_52_0 : 0, ɵ$index_101_r19) + ctx_r2.Math.min((tmp_52_0 = entry_r18.bufferEndUnits) !== null && tmp_52_0 !== undefined ? tmp_52_0 : 0, ctx_r2.daysOrHours.length - ((tmp_52_0 = ctx_r2.cells.get(entry_r18)) !== null && tmp_52_0 !== undefined ? tmp_52_0 : 0) - ɵ$index_101_r19)) - 7, "px");
    i0.ɵɵclassProp("overflow-left", ctx_r2.showOverflow() && ((tmp_53_0 = entry_r18.bufferStartUnits) !== null && tmp_53_0 !== undefined ? tmp_53_0 : 0) > ɵ$index_101_r19)("overflow-right", ctx_r2.showOverflow() && ((tmp_54_0 = entry_r18.bufferEndUnits) !== null && tmp_54_0 !== undefined ? tmp_54_0 : 0) > ctx_r2.daysOrHours.length - ((tmp_54_0 = ctx_r2.cells.get(entry_r18)) !== null && tmp_54_0 !== undefined ? tmp_54_0 : 0) - ɵ$index_101_r19);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Conditional_0_Template, 1, 10, "div", 36);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵlistener("keydown.enter", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template_div_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const entry_r18 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r18.onClick == null ? null : entry_r18.onClick($event));
    })("keydown.space", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template_div_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const entry_r18 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r18.onClick == null ? null : entry_r18.onClick($event));
    })("click", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const entry_r18 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r18.onClick == null ? null : entry_r18.onClick($event));
    })("contextmenu", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template_div_contextmenu_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const entry_r18 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r18.onContextMenu == null ? null : entry_r18.onContextMenu($event));
    });
    i0.ɵɵelementStart(2, "div", 38);
    i0.ɵɵelementContainer(3, 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_52_0;
    let tmp_56_0;
    const entry_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    const dayOrHour_r16 = ctx_r19.$implicit;
    const ɵ$index_101_r19 = ctx_r19.$index;
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵconditional(entry_r18.bufferColor ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background-color", entry_r18.color)("color", entry_r18.color)("width", ctx_r2.cellWidth * ((tmp_52_0 = ctx_r2.cells.get(entry_r18)) !== null && tmp_52_0 !== undefined ? tmp_52_0 : 0) - 7, "px");
    i0.ɵɵclassProp("overflow-left", ctx_r2.showOverflow() && ɵ$index_101_r19 === 0 && entry_r18.startTimestamp && dayOrHour_r16.dayOrHour && ctx_r2.newDate(entry_r18.startTimestamp) < dayOrHour_r16.dayOrHour)("overflow-right", ctx_r2.showOverflow() && entry_r18.endTimestamp && dayOrHour_r16.endTime && ctx_r2.newDate(entry_r18.endTimestamp) > ctx_r2.daysOrHours[ctx_r2.daysOrHours.length - 1].endTime);
    i0.ɵɵproperty("tabindex", entry_r18.onClick || entry_r18.onContextMenu ? 0 : -1)("title", (tmp_56_0 = entry_r18.toggleTitle) !== null && tmp_56_0 !== undefined ? tmp_56_0 : (tmp_56_0 = entry_r18.name) !== null && tmp_56_0 !== undefined ? tmp_56_0 : "");
    i0.ɵɵattribute("data-bs-toggle", entry_r18.toggle)("data-bs-content", entry_r18.toggleContent);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("color", entry_r18.fontColor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.entryTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(19, _c5, entry_r18, ctx_r2.cellWidth, ctx_r2.cells.get(entry_r18)));
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 35);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_0_Template, 4, 23)(1, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Conditional_1_Template, 1, 0, "div", 35);
  }
  if (rf & 2) {
    const entry_r18 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    const dayOrHour_r16 = ctx_r19.$implicit;
    const ɵ$index_101_r19 = ctx_r19.$index;
    const ctx_r2 = i0.ɵɵnextContext(6);
    i0.ɵɵconditional(entry_r18 && ctx_r2.startsAt(entry_r18, dayOrHour_r16, ɵ$index_101_r19) ? 0 : 1);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("dblclick", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template_td_dblclick_0_listener($event) {
      const dayOrHour_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const row_r11 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitDoubleClickOnCell($event, dayOrHour_r16.dayOrHour, row_r11));
    })("keydown.enter", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template_td_keydown_enter_0_listener($event) {
      const dayOrHour_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const row_r11 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitDoubleClickOnCell($event, dayOrHour_r16.dayOrHour, row_r11));
    })("keydown.space", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template_td_keydown_space_0_listener($event) {
      const dayOrHour_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const row_r11 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitDoubleClickOnCell($event, dayOrHour_r16.dayOrHour, row_r11));
    })("contextmenu", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template_td_contextmenu_0_listener($event) {
      const dayOrHour_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const row_r11 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.emitContextMenuOnCell($event, dayOrHour_r16.dayOrHour, row_r11));
    })("mousedown", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template_td_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r2.selectStart());
    });
    i0.ɵɵrepeaterCreate(1, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_For_2_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayOrHour_r16 = ctx.$implicit;
    const ɵ$index_101_r19 = ctx.$index;
    const ctx_r20 = i0.ɵɵnextContext(2);
    const row_r11 = ctx_r20.$implicit;
    const ɵ$index_74_r22 = ctx_r20.$index;
    const ɵ$index_60_r23 = i0.ɵɵnextContext(2).$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(dayOrHour_r16.className);
    i0.ɵɵclassProp("ui-selectable", !row_r11.notSelectable);
    i0.ɵɵproperty("tabindex", ctx_r2.doubleClickOnCellEmitter.observed || ctx_r2.contextMenuOnCellEmitter.observed ? 0 : -1);
    i0.ɵɵattribute("data-rbb-day-or-hour-index", ɵ$index_101_r19)("data-rbb-group-index", ɵ$index_60_r23)("data-rbb-row-index", ɵ$index_74_r22);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.entriesSorted[ɵ$index_60_r23] == null ? null : ctx_r2.entriesSorted[ɵ$index_60_r23][ɵ$index_74_r22] == null ? null : ctx_r2.entriesSorted[ɵ$index_60_r23][ɵ$index_74_r22][ɵ$index_101_r19]);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 24)(1, "td", 25);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Template_td_click_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const row_r11 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(row_r11.onClickRowName == null ? null : row_r11.onClickRowName($event));
    })("keydown.enter", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Template_td_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const row_r11 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(row_r11.onClickRowName == null ? null : row_r11.onClickRowName($event));
    })("keydown.space", function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Template_td_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const row_r11 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(row_r11.onClickRowName == null ? null : row_r11.onClickRowName($event));
    });
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵtemplate(3, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_3_Template, 2, 2, "div", 27)(4, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_4_Template, 3, 2, "div", 28)(5, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Conditional_5_Template, 3, 0, "div", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵrepeaterCreate(6, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_For_7_Template, 3, 8, "td", 30, _forTrack1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabindex", row_r11.onClickRowName ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(row_r11.icon ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(row_r11.name ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((row_r11.badges == null ? null : row_r11.badges.length) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.daysOrHours);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Conditional_0_Template, 8, 4, "tr", 24);
  }
  if (rf & 2) {
    const row_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵconditional(!ctx_r2.filterString || !row_r11.name || ctx_r2.filterString.length < 3 || ctx_r2.filterString.startsWith("gruppe:") || row_r11.name.trim().toLowerCase().replace("-", "").replace(" ", "").replace("\n", "").includes(ctx_r2.filterString.trim().toLowerCase().replace("-", "").replace(" ", "").replace("\n", "")) ? 0 : -1);
  }
}
function CalendarComponent_Conditional_0_For_21_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 18)(1, "th", 19)(2, "div", 20)(3, "h6", 21);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(5, CalendarComponent_Conditional_0_For_21_Conditional_0_For_6_Template, 1, 1, "th", 22, _forTrack1);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, CalendarComponent_Conditional_0_For_21_Conditional_0_For_8_Template, 1, 1, null, null, _forTrack0);
  }
  if (rf & 2) {
    const group_r24 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(group_r24.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.daysOrHours);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(group_r24.rows);
  }
}
function CalendarComponent_Conditional_0_For_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_For_21_Conditional_0_Template, 9, 1);
  }
  if (rf & 2) {
    const group_r24 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r2.filterString || !group_r24.name || !ctx_r2.filterString.startsWith("gruppe:") || ctx_r2.filterString.toLowerCase().replace("gruppe:", "") === group_r24.name.toLowerCase() ? 0 : -1);
  }
}
function CalendarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 3)(1, "thead");
    i0.ɵɵtemplate(2, CalendarComponent_Conditional_0_Conditional_2_Template, 4, 0, "tr");
    i0.ɵɵelementStart(3, "tr")(4, "th", 4)(5, "div", 5)(6, "input", 6);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_0_Template_input_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.filterString, $event) || (ctx_r2.filterString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_0_Template_input_ngModelChange_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveFilter());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "button", 7);
    i0.ɵɵelementStart(8, "div", 8)(9, "button", 9);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.filterString = "";
      return i0.ɵɵresetView(ctx_r2.saveFilter());
    });
    i0.ɵɵtext(10, "Alle");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "div", 10);
    i0.ɵɵelementStart(12, "h6", 11);
    i0.ɵɵtext(13, "Gruppen");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(14, CalendarComponent_Conditional_0_For_15_Template, 2, 1, "button", 12, _forTrack0);
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(16, CalendarComponent_Conditional_0_For_17_Template, 4, 4, "th", 13, _forTrack1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "tbody", null, 0);
    i0.ɵɵrepeaterCreate(20, CalendarComponent_Conditional_0_For_21_Template, 1, 1, null, null, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", ctx_r2.daysOrHours.length * (ctx_r2.mode() === "DAY" ? 35 : 42.5) + (ctx_r2.window.innerWidth > 992 ? 250 : 150) + "px");
    i0.ɵɵclassProp("select-mode", ctx_r2.selectMode());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.showMonth() && ctx_r2.mode() === "DAY" ? 2 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("min-width", "75px !important");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.filterString);
    i0.ɵɵadvance(8);
    i0.ɵɵrepeater(ctx_r2.data());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.daysOrHours);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r2.data());
  }
}
function BrowserMessagesComponent_For_2_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 3);
  }
}
function BrowserMessagesComponent_For_2_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
  }
}
function BrowserMessagesComponent_For_2_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function BrowserMessagesComponent_For_2_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 6);
  }
}
function BrowserMessagesComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, BrowserMessagesComponent_For_2_Case_2_Template, 1, 0, "i", 3)(3, BrowserMessagesComponent_For_2_Case_3_Template, 1, 0, "i", 4)(4, BrowserMessagesComponent_For_2_Case_4_Template, 1, 0, "i", 5)(5, BrowserMessagesComponent_For_2_Case_5_Template, 1, 0, "i", 6);
    i0.ɵɵelementStart(6, "strong", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "button", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_11_0;
    const message_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_11_0 = message_r1.type) === ctx_r1.BrowserMessageType.Info ? 2 : tmp_11_0 === ctx_r1.BrowserMessageType.Warning ? 3 : tmp_11_0 === ctx_r1.BrowserMessageType.Error ? 4 : tmp_11_0 === ctx_r1.BrowserMessageType.Success ? 5 : -1);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(message_r1.headline);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", message_r1.text, " ");
  }
}
const _c6 = (a0, a1, a2) => ({
  "active": a0,
  "sm": a1,
  "lg": a2
});
const _c7 = a0 => ({
  "mt-3": a0
});
function SideMenuHeadlineComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description());
  }
}
function SideMenuHeadlineComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "a", 7);
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵtext(3, "FAQ ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.faqLink(), i0.ɵɵsanitizeUrl);
  }
}
const _c8 = () => [];
const _forTrack2 = ($index, $item) => $item.id;
function FaqComponent_Conditional_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "h2", 7)(2, "button", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const faq_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "heading", faq_r1.id, "");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-bs-target", "#collapse", faq_r1.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", faq_r1.questions, " ");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-labelledby", "heading", faq_r1.id, "");
    i0.ɵɵpropertyInterpolate1("id", "collapse", faq_r1.id, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", faq_r1.answer, i0.ɵɵsanitizeHtml);
  }
}
function FaqComponent_Conditional_3_ForEmpty_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Keine passenden FAQs gefunden.");
    i0.ɵɵelementEnd();
  }
}
function FaqComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 4);
    i0.ɵɵtext(1, "Suchergebnis");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵrepeaterCreate(3, FaqComponent_Conditional_3_For_4_Template, 6, 10, "div", 6, _forTrack2, false, FaqComponent_Conditional_3_ForEmpty_5_Template, 2, 0, "p");
    i0.ɵɵpipe(6, "rbbObjectSearch");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "hr");
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(i0.ɵɵpipeBind3(6, 1, ((tmp_1_0 = ctx_r1.faqGroups) !== null && tmp_1_0 !== undefined ? tmp_1_0 : i0.ɵɵpureFunction0(5, _c8)).flatMap(ctx_r1.searchFlatMap), ctx_r1.searchConfig, ctx_r1.search));
  }
}
function FaqComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "rbb-loader");
    i0.ɵɵelementEnd();
  }
}
function FaqComponent_Conditional_5_Conditional_0_For_1_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "h2", 7)(2, "button", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const faq_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "heading", faq_r3.id, "");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-bs-target", "#collapse", faq_r3.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", faq_r3.questions, " ");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-labelledby", "heading", faq_r3.id, "");
    i0.ɵɵpropertyInterpolate1("id", "collapse", faq_r3.id, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", faq_r3.answer, i0.ɵɵsanitizeHtml);
  }
}
function FaqComponent_Conditional_5_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵrepeaterCreate(3, FaqComponent_Conditional_5_Conditional_0_For_1_For_4_Template, 6, 10, "div", 6, _forTrack2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const faqGroup_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(faqGroup_r4.groupLabel);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "accordion", faqGroup_r4.id, "");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(faqGroup_r4.faqList);
  }
}
function FaqComponent_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FaqComponent_Conditional_5_Conditional_0_For_1_Template, 5, 3, null, null, _forTrack2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.faqGroups);
  }
}
function FaqComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, " Aktuell sind keine FAQs verf\xFCgbar. ");
    i0.ɵɵelementEnd();
  }
}
function FaqComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FaqComponent_Conditional_5_Conditional_0_Template, 2, 0)(1, FaqComponent_Conditional_5_Conditional_1_Template, 2, 0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.faqGroups && ctx_r1.faqGroups.length ? 0 : 1);
  }
}
const _c9 = ["searchInput"];
const _c10 = ["autocompleteList"];
const _c11 = ["autocompleteItems"];
const _c12 = (a0, a1) => ({
  "input-group-sm": a0,
  "input-group-lg": a1
});
const _c13 = a0 => ({
  "d-none": a0
});
const _c14 = a0 => ({
  "border border-secondary": a0
});
const _c15 = a0 => ({
  value: a0
});
const _c16 = a0 => ({
  "hover": a0
});
function MultiSelectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r2.uuid);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.prependIcon);
  }
}
function MultiSelectComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementContainer(1, 13);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵlistener("click", function MultiSelectComponent_For_5_Template_span_click_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    })("keydown.space", function MultiSelectComponent_For_5_Template_span_keydown_space_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    })("keydown.enter", function MultiSelectComponent_For_5_Template_span_keydown_enter_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    });
    i0.ɵɵtext(3, " \xA0");
    i0.ɵɵelement(4, "i", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const value_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c14, ctx_r2.max() !== 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate())("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c15, value_r6));
  }
}
function MultiSelectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 16);
    i0.ɵɵelement(2, "rbb-loader");
    i0.ɵɵelementEnd()();
  }
}
function MultiSelectComponent_For_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 17, 2);
    i0.ɵɵlistener("click", function MultiSelectComponent_For_13_Template_span_click_0_listener() {
      const value_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectValue(value_r8));
    })("mouseover", function MultiSelectComponent_For_13_Template_span_mouseover_0_listener() {
      const ɵ$index_35_r9 = i0.ɵɵrestoreView(_r7).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.searchValueSelectIndex = ɵ$index_35_r9);
    })("mouseenter", function MultiSelectComponent_For_13_Template_span_mouseenter_0_listener() {
      const ɵ$index_35_r9 = i0.ɵɵrestoreView(_r7).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.searchValueSelectIndex = ɵ$index_35_r9);
    });
    i0.ɵɵelementContainer(2, 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r8 = ctx.$implicit;
    const ɵ$index_35_r9 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r2.uuid + "-autocomplete-" + ctx_r2.searchValueSelectIndex)("ngClass", i0.ɵɵpureFunction1(5, _c16, ɵ$index_35_r9 === ctx_r2.searchValueSelectIndex));
    i0.ɵɵattribute("aria-selected", ɵ$index_35_r9 === ctx_r2.searchValueSelectIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate())("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c15, value_r8));
  }
}
const _c17 = () => ["lastName", "firstName", "username"];
function GroupPickerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r2 = ctx.value;
    i0.ɵɵtextInterpolate1(" ", value_r2.name, "\n");
  }
}
const _c18 = ["inputElement"];
function MultiValueInputComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r2.uuid);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.prependIcon);
  }
}
function MultiValueInputComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵlistener("click", function MultiValueInputComponent_For_5_Template_span_click_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    })("keydown.space", function MultiValueInputComponent_For_5_Template_span_keydown_space_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    })("keydown.enter", function MultiValueInputComponent_For_5_Template_span_keydown_enter_2_listener($event) {
      const ɵ$index_12_r5 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeValueWithEvent($event, ɵ$index_12_r5));
    });
    i0.ɵɵtext(3, " \xA0");
    i0.ɵɵelement(4, "i", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const value_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c14, ctx_r2.max() !== 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", value_r6, " ");
  }
}
function NavbarComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
}
function NavbarComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 3);
  }
}
function NavbarComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" \u2013 ", ctx_r1.config.subtitle == null ? null : ctx_r1.config.subtitle(), " ");
  }
}
function NavbarComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r1.config.instance, ")");
  }
}
function NavbarComponent_Conditional_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavbarComponent_Conditional_0_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavbarComponent_Conditional_0_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "img", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    i0.ɵɵnextContext();
    const initials_r3 = i0.ɵɵreadContextLet(17);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(initials_r3);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.config.userInfo == null ? null : ctx_r1.config.userInfo.getOrganisation == null ? null : (tmp_6_0 = ctx_r1.config.userInfo.getOrganisation()) == null ? null : tmp_6_0.toLowerCase());
    i0.ɵɵproperty("src", ctx_r1.getOrganisationImageUrl(ctx_r1.config.userInfo == null ? null : ctx_r1.config.userInfo.getOrganisation == null ? null : ctx_r1.config.userInfo.getOrganisation()), i0.ɵɵsanitizeUrl)("alt", ctx_r1.getOrganisationName(ctx_r1.config.userInfo == null ? null : ctx_r1.config.userInfo.getOrganisation == null ? null : ctx_r1.config.userInfo.getOrganisation()));
  }
}
function NavbarComponent_Conditional_0_Conditional_24_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const initials_r3 = i0.ɵɵreadContextLet(17);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(initials_r3);
  }
}
function NavbarComponent_Conditional_0_Conditional_24_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 37);
  }
}
function NavbarComponent_Conditional_0_Conditional_24_Conditional_15_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const role_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(role_r4);
  }
}
function NavbarComponent_Conditional_0_Conditional_24_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 41);
    i0.ɵɵelement(1, "br");
    i0.ɵɵtext(2, "Rolle: ");
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵrepeaterCreate(4, NavbarComponent_Conditional_0_Conditional_24_Conditional_15_For_5_Template, 2, 1, "span", 43, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.getRoles());
  }
}
function NavbarComponent_Conditional_0_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "div", 34)(2, "div", 35);
    i0.ɵɵtemplate(3, NavbarComponent_Conditional_0_Conditional_24_Conditional_3_Template, 3, 1, "div", 36)(4, NavbarComponent_Conditional_0_Conditional_24_Conditional_4_Template, 1, 0, "i", 37);
    i0.ɵɵelementStart(5, "div", 38);
    i0.ɵɵelement(6, "img", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 40)(8, "strong");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "small", 41);
    i0.ɵɵelement(11, "br");
    i0.ɵɵtext(12, "Anmeldename: ");
    i0.ɵɵelementStart(13, "strong");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(15, NavbarComponent_Conditional_0_Conditional_24_Conditional_15_Template, 6, 0, "small", 41);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(16, "div", 23);
  }
  if (rf & 2) {
    let tmp_6_0;
    i0.ɵɵnextContext();
    const firstName_r5 = i0.ɵɵreadContextLet(15);
    const lastName_r6 = i0.ɵɵreadContextLet(16);
    const initials_r3 = i0.ɵɵreadContextLet(17);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(initials_r3 ? 3 : 4);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap((tmp_6_0 = ctx_r1.config.userInfo.getOrganisation()) == null ? null : tmp_6_0.toLowerCase());
    i0.ɵɵproperty("src", ctx_r1.getOrganisationImageUrl(ctx_r1.config.userInfo.getOrganisation()), i0.ɵɵsanitizeUrl)("alt", ctx_r1.getOrganisationName(ctx_r1.config.userInfo.getOrganisation()));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", firstName_r5, " ", lastName_r6, "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.config.userInfo.getUsername());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getRoles().length ? 15 : -1);
  }
}
function NavbarComponent_Conditional_0_For_26_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", link_r7.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(link_r7.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", link_r7.name, " ");
  }
}
function NavbarComponent_Conditional_0_For_26_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", link_r7.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(link_r7.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", link_r7.name, " ");
  }
}
function NavbarComponent_Conditional_0_For_26_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NavbarComponent_Conditional_0_For_26_For_3_Conditional_0_Template, 3, 4, "a", 20)(1, NavbarComponent_Conditional_0_For_26_For_3_Conditional_1_Template, 3, 4, "a", 21);
  }
  if (rf & 2) {
    const link_r7 = ctx.$implicit;
    i0.ɵɵconditional(link_r7.link ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(link_r7.routerLink ? 1 : -1);
  }
}
function NavbarComponent_Conditional_0_For_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(2, NavbarComponent_Conditional_0_For_26_For_3_Template, 2, 2, null, null, _forTrack0);
    i0.ɵɵelement(4, "div", 23);
  }
  if (rf & 2) {
    const linkGroup_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(linkGroup_r8.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(linkGroup_r8.links);
  }
}
function NavbarComponent_Conditional_0_Conditional_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵelement(1, "i", 45);
    i0.ɵɵtext(2, "Feedback ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("href", "https://tools.rbb-online.de/feedback/", ctx_r1.config.feedbackAppName, "", i0.ɵɵsanitizeUrl);
  }
}
function NavbarComponent_Conditional_0_Conditional_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵelement(1, "i", 46);
    i0.ɵɵtext(2, "FAQ ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r1.config.faqRouterLink);
  }
}
function NavbarComponent_Conditional_0_Conditional_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵelement(1, "i", 46);
    i0.ɵɵtext(2, "FAQ ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.config.faqLink, i0.ɵɵsanitizeUrl);
  }
}
function NavbarComponent_Conditional_0_Conditional_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵelement(1, "i", 47);
    i0.ɵɵtext(2, "Datenschutz ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r1.config.privacyPolicyRouterLink);
  }
}
function NavbarComponent_Conditional_0_Conditional_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵelement(1, "i", 47);
    i0.ɵɵtext(2, "Datenschutz ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.config.privacyPolicyLink, i0.ɵɵsanitizeUrl);
  }
}
function NavbarComponent_Conditional_0_Conditional_37_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 48);
    i0.ɵɵelement(1, "i", 53);
    i0.ɵɵtext(2, "Tools ");
    i0.ɵɵelementEnd();
  }
}
function NavbarComponent_Conditional_0_Conditional_37_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 51);
    i0.ɵɵelement(1, "i", 54);
    i0.ɵɵtext(2, "rbb Forms ");
    i0.ɵɵelementEnd();
  }
}
function NavbarComponent_Conditional_0_Conditional_37_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 52);
    i0.ɵɵelement(1, "i", 55);
    i0.ɵɵtext(2, "MIT-Serviceportal ");
    i0.ɵɵelementEnd();
  }
}
function NavbarComponent_Conditional_0_Conditional_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
    i0.ɵɵelementStart(1, "h6", 17);
    i0.ɵɵtext(2, "Weitere Apps");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NavbarComponent_Conditional_0_Conditional_37_Conditional_3_Template, 3, 0, "a", 48);
    i0.ɵɵelementStart(4, "a", 49);
    i0.ɵɵelement(5, "i", 50);
    i0.ɵɵtext(6, "Intranet ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, NavbarComponent_Conditional_0_Conditional_37_Conditional_7_Template, 3, 0, "a", 51)(8, NavbarComponent_Conditional_0_Conditional_37_Conditional_8_Template, 3, 0, "a", 52);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!ctx_r1.isCurrentApplication("/home") ? 3 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!ctx_r1.isCurrentApplication("/forms") ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isCurrentApplication("/mit-service") ? 8 : -1);
  }
}
function NavbarComponent_Conditional_0_Conditional_49_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " \u2212\u2002");
    i0.ɵɵelementStart(1, "a", 56);
    i0.ɵɵtext(2, "Verlauf");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", ctx_r1.config.versionHistoryRouterLink);
  }
}
function NavbarComponent_Conditional_0_Conditional_49_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, NavbarComponent_Conditional_0_Conditional_49_Conditional_2_Template, 3, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Version:\u2002", ctx_r1.config.getVersion == null ? null : ctx_r1.config.getVersion(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.versionHistoryRouterLink ? 2 : -1);
  }
}
function NavbarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 0)(1, "a", 1);
    i0.ɵɵtemplate(2, NavbarComponent_Conditional_0_Conditional_2_Template, 1, 0, "img", 2)(3, NavbarComponent_Conditional_0_Conditional_3_Template, 1, 0, "img", 3);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, NavbarComponent_Conditional_0_Conditional_5_Template, 1, 1)(6, NavbarComponent_Conditional_0_Conditional_6_Template, 2, 1, "span", 4);
    i0.ɵɵelement(7, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 6);
    i0.ɵɵelement(9, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NavbarComponent_Conditional_0_ng_container_10_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementStart(11, "div", 9)(12, "ul", 10);
    i0.ɵɵtemplate(13, NavbarComponent_Conditional_0_ng_container_13_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementStart(14, "li", 11);
    i0.ɵɵdeclareLet(15)(16)(17);
    i0.ɵɵelementStart(18, "a", 12);
    i0.ɵɵelement(19, "i", 13);
    i0.ɵɵtemplate(20, NavbarComponent_Conditional_0_Conditional_20_Template, 4, 5, "div", 14);
    i0.ɵɵelementStart(21, "span", 15);
    i0.ɵɵtext(22, "\u2002Info");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 16);
    i0.ɵɵtemplate(24, NavbarComponent_Conditional_0_Conditional_24_Template, 17, 9);
    i0.ɵɵrepeaterCreate(25, NavbarComponent_Conditional_0_For_26_Template, 5, 1, null, null, _forTrack0);
    i0.ɵɵelementStart(27, "h6", 17);
    i0.ɵɵtext(28, "Support");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "a", 18);
    i0.ɵɵelement(30, "i", 19);
    i0.ɵɵtext(31, "E-Mail ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, NavbarComponent_Conditional_0_Conditional_32_Template, 3, 2, "a", 20)(33, NavbarComponent_Conditional_0_Conditional_33_Template, 3, 1, "a", 21)(34, NavbarComponent_Conditional_0_Conditional_34_Template, 3, 1, "a", 22)(35, NavbarComponent_Conditional_0_Conditional_35_Template, 3, 1, "a", 21)(36, NavbarComponent_Conditional_0_Conditional_36_Template, 3, 1, "a", 22)(37, NavbarComponent_Conditional_0_Conditional_37_Template, 9, 3);
    i0.ɵɵelement(38, "div", 23);
    i0.ɵɵelementStart(39, "h6", 17);
    i0.ɵɵtext(40, "Design");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 24)(42, "div", 25)(43, "div", 26)(44, "button", 27);
    i0.ɵɵlistener("click", function NavbarComponent_Conditional_0_Template_button_click_44_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setThemeMode("system", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 26)(46, "button", 28);
    i0.ɵɵlistener("click", function NavbarComponent_Conditional_0_Template_button_click_46_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setThemeMode("light", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(47, "div", 26)(48, "button", 29);
    i0.ɵɵlistener("click", function NavbarComponent_Conditional_0_Template_button_click_48_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setThemeMode("dark", $event));
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(49, NavbarComponent_Conditional_0_Conditional_49_Template, 3, 2, "div", 30);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.ard() ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.config.subtitle == null ? null : ctx_r1.config.subtitle()) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.instance ? 6 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.searchTemplate());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.navigationTemplate());
    i0.ɵɵadvance(2);
    const firstName_r9 = i0.ɵɵstoreLet(ctx_r1.config.userInfo == null ? null : ctx_r1.config.userInfo.getFirstName == null ? null : ctx_r1.config.userInfo.getFirstName());
    i0.ɵɵadvance();
    const lastName_r10 = i0.ɵɵstoreLet(ctx_r1.config.userInfo == null ? null : ctx_r1.config.userInfo.getLastName == null ? null : ctx_r1.config.userInfo.getLastName());
    i0.ɵɵadvance();
    const initials_r11 = i0.ɵɵstoreLet(((tmp_9_0 = firstName_r9 == null ? null : (tmp_9_0 = firstName_r9.substring(0, 1)) == null ? null : tmp_9_0.toUpperCase()) !== null && tmp_9_0 !== undefined ? tmp_9_0 : "") + ((tmp_9_0 = lastName_r10 == null ? null : (tmp_9_0 = lastName_r10.substring(0, 1)) == null ? null : tmp_9_0.toUpperCase()) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("d-xl-none", initials_r11);
    i0.ɵɵadvance();
    i0.ɵɵconditional(initials_r11 ? 20 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("min-width", 191, "px");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.userInfo ? 24 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.config.linkGroups);
    i0.ɵɵadvance(7);
    i0.ɵɵconditional(ctx_r1.config.feedbackAppName ? 32 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.faqRouterLink ? 33 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.faqLink ? 34 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.privacyPolicyRouterLink ? 35 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.config.privacyPolicyLink ? 36 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.ard() ? 37 : -1);
    i0.ɵɵadvance(12);
    i0.ɵɵconditional((ctx_r1.config.getVersion == null ? null : ctx_r1.config.getVersion()) ? 49 : -1);
  }
}
const _c19 = (a0, a1) => ({
  "justify-content-center": a0,
  "justify-content-end": a1
});
const _c20 = (a0, a1) => ({
  "active": a0,
  "disabled": a1
});
function PaginatorComponent_Conditional_0_For_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function PaginatorComponent_Conditional_0_For_7_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const item_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectPage(item_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4);
  }
}
function PaginatorComponent_Conditional_0_For_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
  }
}
function PaginatorComponent_Conditional_0_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6);
    i0.ɵɵtemplate(1, PaginatorComponent_Conditional_0_For_7_Conditional_1_Template, 2, 1, "button", 8)(2, PaginatorComponent_Conditional_0_For_7_Conditional_2_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c20, item_r4 === ctx_r1.currentPage, item_r4 === 0));
    i0.ɵɵattribute("aria-controls", ctx_r1.ariaControls())("aria-hidden", item_r4 === 0 ? true : undefined)("aria-current", item_r4 === ctx_r1.currentPage ? true : undefined);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r4 !== 0 ? 1 : 2);
  }
}
function PaginatorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 1);
    i0.ɵɵlistener("keydown.arrowLeft", function PaginatorComponent_Conditional_0_Template_nav_keydown_arrowLeft_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.previous();
      return i0.ɵɵresetView(ctx_r1.focusCurrent());
    })("keydown.arrowRight", function PaginatorComponent_Conditional_0_Template_nav_keydown_arrowRight_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.next();
      return i0.ɵɵresetView(ctx_r1.focusCurrent());
    });
    i0.ɵɵelementStart(1, "ul", 2)(2, "li", 3)(3, "button", 4);
    i0.ɵɵlistener("click", function PaginatorComponent_Conditional_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previous());
    });
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5, "\xAB");
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(6, PaginatorComponent_Conditional_0_For_7_Template, 3, 8, "li", 6, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(8, "li", 3)(9, "button", 7);
    i0.ɵɵlistener("click", function PaginatorComponent_Conditional_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵelementStart(10, "span", 5);
    i0.ɵɵtext(11, "\xBB");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c19, ctx_r1.position() === "center", ctx_r1.position() === "right"));
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.getPageItems());
  }
}
const _forTrack3 = ($index, $item) => $item.version;
function PatchNotesComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "rbb-loader");
    i0.ɵɵelementEnd();
  }
}
function PatchNotesComponent_Conditional_3_Conditional_0_For_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 9);
  }
}
function PatchNotesComponent_Conditional_3_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "h6", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "small", 7);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 8);
    i0.ɵɵtemplate(7, PatchNotesComponent_Conditional_3_Conditional_0_For_2_Conditional_7_Template, 1, 0, "hr", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const note_r1 = ctx.$implicit;
    const ɵ$index_14_r2 = ctx.$index;
    const ɵ$count_14_r3 = ctx.$count;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Version: ", note_r1.version, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Update am: ", i0.ɵɵpipeBind2(5, 4, note_r1.releaseDate, "dd.MM.yyyy"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", note_r1.content, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_14_r2 === ɵ$count_14_r3 - 1) ? 7 : -1);
  }
}
function PatchNotesComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵrepeaterCreate(1, PatchNotesComponent_Conditional_3_Conditional_0_For_2_Template, 8, 7, "div", 5, _forTrack3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.notes);
  }
}
function PatchNotesComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, " Aktuell sind keine Versionshinweise verf\xFCgbar. ");
    i0.ɵɵelementEnd();
  }
}
function PatchNotesComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PatchNotesComponent_Conditional_3_Conditional_0_Template, 3, 0, "div", 3)(1, PatchNotesComponent_Conditional_3_Conditional_1_Template, 2, 0, "div", 4);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r3.notes == null ? null : ctx_r3.notes.length) ? 0 : 1);
  }
}
function PeoplePickerComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 3);
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().value;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(value_r2.organisation.toLowerCase());
    i0.ɵɵproperty("src", ctx_r2.getOrganisationImageUrl(value_r2.organisation), i0.ɵɵsanitizeUrl)("alt", ctx_r2.getOrganisationName(value_r2.organisation));
  }
}
function PeoplePickerComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().value;
    i0.ɵɵtextInterpolate1(" (", value_r2.username, ") ");
  }
}
function PeoplePickerComponent_ng_template_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().value;
    i0.ɵɵtextInterpolate1(" (", value_r2.emailAddress, ") ");
  }
}
function PeoplePickerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PeoplePickerComponent_ng_template_1_Conditional_0_Template, 1, 4, "img", 2);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PeoplePickerComponent_ng_template_1_Conditional_2_Template, 1, 1)(3, PeoplePickerComponent_ng_template_1_Conditional_3_Template, 1, 1);
  }
  if (rf & 2) {
    const value_r2 = ctx.value;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.showOrganisation() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", value_r2.firstName, " ", value_r2.lastName, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showUsername() ? 2 : ctx_r2.showEmailAddress() ? 3 : -1);
  }
}
const _c21 = ["progressBar"];
function SearchInputComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 10);
    i0.ɵɵelement(2, "i", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u2002", ctx_r1.warnMessage, " ");
  }
}
function SearchInputComponent_Conditional_7_For_3_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const s_r7 = ctx.$implicit;
    const ɵ$index_25_r8 = ctx.$index;
    i0.ɵɵclassProp("fw-bold", ɵ$index_25_r8 % 2 === 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(s_r7);
  }
}
function SearchInputComponent_Conditional_7_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 2);
    i0.ɵɵlistener("click", function SearchInputComponent_Conditional_7_For_3_Template_div_click_0_listener() {
      const value_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectValue(value_r5));
    })("mouseover", function SearchInputComponent_Conditional_7_For_3_Template_div_mouseover_0_listener() {
      const ɵ$index_22_r6 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchValueSelectIndex = ɵ$index_22_r6);
    })("mouseenter", function SearchInputComponent_Conditional_7_For_3_Template_div_mouseenter_0_listener() {
      const ɵ$index_22_r6 = i0.ɵɵrestoreView(_r4).$index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchValueSelectIndex = ɵ$index_22_r6);
    });
    i0.ɵɵrepeaterCreate(2, SearchInputComponent_Conditional_7_For_3_For_3_Template, 2, 3, "span", 15, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r5 = ctx.$implicit;
    const ɵ$index_22_r6 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r1.uuid + "-autocomplete-" + ɵ$index_22_r6);
    i0.ɵɵattribute("aria-selected", ɵ$index_22_r6 === ctx_r1.searchValueSelectIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.formatSplit(value_r5));
  }
}
function SearchInputComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 1);
    i0.ɵɵlistener("mouseover", function SearchInputComponent_Conditional_7_Template_div_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.autocompleteHovered = true);
    })("mouseenter", function SearchInputComponent_Conditional_7_Template_div_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.autocompleteHovered = true);
    })("mouseout", function SearchInputComponent_Conditional_7_Template_div_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.autocompleteHovered = false);
    })("mouseleave", function SearchInputComponent_Conditional_7_Template_div_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.autocompleteHovered = false);
    });
    i0.ɵɵrepeaterCreate(2, SearchInputComponent_Conditional_7_For_3_Template, 4, 2, "div", 13, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵpipe(4, "searchInput");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.searching)("id", ctx_r1.uuid + "-autocomplete");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.prepareSearchList(i0.ɵɵpipeBind2(4, 2, ctx_r1.values, ctx_r1.searchQuery)));
  }
}
const _c22 = ["dialog"];
const _c23 = ["*"];
const _c24 = a0 => ({
  "fa-solid fa-check": a0
});
const _c25 = a0 => ({
  "pointer": a0
});
const _c26 = (a0, a1) => ({
  column: a0,
  value: a1
});
function TableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("lh-1 ", ctx_r0.titleClass(), "");
    i0.ɵɵproperty("id", ctx_r0.id + "-heading");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function TableComponent_Conditional_3_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageSize_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", pageSize_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pageSize_r3 > 0 ? pageSize_r3 : "Alle");
  }
}
function TableComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 16)(2, "label", 17);
    i0.ɵɵtext(3, "Eintr\xE4ge");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "select", 18);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_3_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.selectedPageSize, $event) || (ctx_r0.selectedPageSize = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(5, TableComponent_Conditional_3_For_6_Template, 2, 2, "option", 19, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", ctx_r0.id + "inputGroupSelect01");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.id + "inputGroupSelect01");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.selectedPageSize);
    i0.ɵɵattribute("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.pageSizes);
  }
}
function TableComponent_Conditional_4_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "input", 24);
    i0.ɵɵlistener("change", function TableComponent_Conditional_4_For_6_Template_input_change_1_listener() {
      const column_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.hideColumn(column_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "hidecolumn" + column_r5)("checked", !ctx_r0.hiddenColumns.includes(column_r5));
    i0.ɵɵattribute("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.id + "hidecolumn" + column_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r5, " ");
  }
}
function TableComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 20);
    i0.ɵɵelement(2, "i", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵrepeaterCreate(5, TableComponent_Conditional_4_For_6_Template, 4, 5, "div", 23, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "dropdownHideColumnsButton");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("\u2002", ctx_r0.getHideableColumns().length - ctx_r0.getHiddenColumns().length, " von ", ctx_r0.getHideableColumns().length, " Spalten ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id + "dropdownHideColumnsButton");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.getHideableColumns());
  }
}
function TableComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 26);
    i0.ɵɵelement(2, "i", 27);
    i0.ɵɵtext(3, "\u2002Daten exportieren ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 28)(5, "li")(6, "button", 29);
    i0.ɵɵlistener("click", function TableComponent_Conditional_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportCSV());
    });
    i0.ɵɵelement(7, "i", 30);
    i0.ɵɵtext(8, "\u2002CSV");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li")(10, "button", 29);
    i0.ɵɵlistener("click", function TableComponent_Conditional_5_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportCsvForExcel());
    });
    i0.ɵɵelement(11, "i", 30);
    i0.ɵɵtext(12, "\u2002CSV f\xFCr Excel");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "li")(14, "button", 29);
    i0.ɵɵlistener("click", function TableComponent_Conditional_5_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportJson());
    });
    i0.ɵɵelement(15, "i", 31);
    i0.ɵɵtext(16, "\u2002JSON");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "li")(18, "button", 29);
    i0.ɵɵlistener("click", function TableComponent_Conditional_5_Template_button_click_18_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.exportPrint());
    });
    i0.ɵɵelement(19, "i", 32);
    i0.ɵɵtext(20, "\u2002Drucken/PDF");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "dropdownExportButton");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id + "dropdownExportButton");
  }
}
function TableComponent_Conditional_6_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_For_8_Template_button_click_0_listener() {
      const filterName_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.loadFilter(filterName_r9));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "i", 44);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_For_8_Template_i_click_2_listener() {
      const filterName_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.deleteFilter(filterName_r9));
    })("keydown.enter", function TableComponent_Conditional_6_For_8_Template_i_keydown_enter_2_listener() {
      const filterName_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.deleteFilter(filterName_r9));
    })("keydown.space", function TableComponent_Conditional_6_For_8_Template_i_keydown_space_2_listener() {
      const filterName_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.deleteFilter(filterName_r9));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filterName_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", filterName_r9, "\u2002");
  }
}
function TableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 20);
    i0.ɵɵelement(2, "i", 33);
    i0.ɵɵtext(3, "\u2002Filter ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 28)(5, "h6", 34);
    i0.ɵɵtext(6, "Filter");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, TableComponent_Conditional_6_For_8_Template, 3, 1, "button", 35, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(9, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.resetFilter();
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵtext(10, "Filter zur\xFCcksetzen");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "hr", 37);
    i0.ɵɵelementStart(12, "h6", 34);
    i0.ɵɵtext(13, "Aktuelle Filtereinstellung speichern");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 38)(15, "input", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_6_Template_input_ngModelChange_15_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.newFilterName, $event) || (ctx_r0.newFilterName = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 40);
    i0.ɵɵlistener("click", function TableComponent_Conditional_6_Template_button_click_16_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.saveFilter());
    });
    i0.ɵɵelement(17, "i", 41);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 42);
    i0.ɵɵelement(19, "i", 43);
    i0.ɵɵelementStart(20, "span");
    i0.ɵɵtext(21, "Filter werden nur lokal im Browser gespeichert");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "dropdownFilterButton");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id + "dropdownFilterButton");
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r0.loadAvailableFilter());
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("id", ctx_r0.id + "filterSave");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.newFilterName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r0.newFilterName);
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "filter-description");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.id + "filter-description");
  }
}
function TableComponent_For_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 47);
  }
  if (rf & 2) {
    const button_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(button_r11.icon);
  }
}
function TableComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 45);
    i0.ɵɵlistener("click", function TableComponent_For_8_Template_button_click_1_listener() {
      const button_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      return i0.ɵɵresetView(button_r11.click());
    });
    i0.ɵɵtemplate(2, TableComponent_For_8_Conditional_2_Template, 1, 2, "i", 46);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r11 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(button_r11.class);
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r11.icon ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", button_r11.name, " ");
  }
}
function TableComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 17);
    i0.ɵɵelement(2, "i", 48);
    i0.ɵɵtext(3, "\u2002Suche");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 49);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_9_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.generalSearchInput, $event) || (ctx_r0.generalSearchInput = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function TableComponent_Conditional_9_Template_input_ngModelChange_4_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.id + "generalSearch");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", ctx_r0.id + "generalSearch");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.generalSearchInput);
    i0.ɵɵattribute("aria-controls", ctx_r0.id);
  }
}
function TableComponent_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-paginator", 50);
    i0.ɵɵlistener("pageChange", function TableComponent_Conditional_10_Conditional_1_Template_rbb_paginator_pageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.pageChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("currentPage", ctx_r0.currentPage)("pages", ctx_r0.getPageNumber())("ariaControls", ctx_r0.id);
  }
}
function TableComponent_Conditional_10_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.currentPage - 1) * ctx_r0.selectedPageSize + 1, ". - ", ctx_r0.Math.min(ctx_r0.currentPage * ctx_r0.selectedPageSize, ctx_r0.outputValues.length), ". von ");
  }
}
function TableComponent_Conditional_10_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, TableComponent_Conditional_10_Conditional_2_Conditional_1_Template, 1, 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectedPageSize && ctx_r0.currentPage && ctx_r0.outputValues.length ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.outputValues.length, " Eintr\xE4ge ");
  }
}
function TableComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, TableComponent_Conditional_10_Conditional_1_Template, 1, 3, "rbb-paginator", 12)(2, TableComponent_Conditional_10_Conditional_2_Template, 3, 2, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectedPageSize && ctx_r0.currentPage ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.resultNumbers() ? 2 : -1);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_For_7_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const option_r17 = i0.ɵɵnextContext().$implicit;
      const column_r15 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.changeFilterOption(column_r15, option_r17.value);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelement(1, "i", 57);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r17 = i0.ɵɵnextContext().$implicit;
    const column_r15 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate3("aria-label", "Eintr\xE4ge die den Wert ", option_r17.name, " in der Spalte ", column_r15.name, " besitzen ", ctx_r0.searchInputs[column_r15.name].split(";").includes(option_r17.value) ? "entfernen" : "hinzuf\xFCgen", "");
    i0.ɵɵattribute("aria-selected", ctx_r0.searchInputs[column_r15.name].split(";").includes(option_r17.value) ? true : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c24, ctx_r0.searchInputs[column_r15.name].split(";").includes(option_r17.value)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("\u2002", option_r17.name, " ");
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_For_7_Conditional_0_Template, 3, 9, "button", 35);
  }
  if (rf & 2) {
    const option_r17 = ctx.$implicit;
    i0.ɵɵconditional(!option_r17.value.includes(";") ? 0 : -1);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 56)(3, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r14);
      const column_r15 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.searchInputs[column_r15.name] = "";
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelement(4, "i", 57);
    i0.ɵɵtext(5, "\u2002-- Alle -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(6, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_For_7_Template, 1, 1, null, null, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.id + "multiSelection-" + ctx_r0.getUniqueTableId() + "-" + column_r15.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !ctx_r0.searchInputs[column_r15.name] ? "-- Alle --" : ctx_r0.searchInputs[column_r15.name].split(";").length + " ausgew\xE4hlt", " ");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-labelledby", "multiSelection-", ctx_r0.getUniqueTableId(), "-", column_r15.name, "");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Alle Werte der Spalte ", column_r15.name, " anzeigen.");
    i0.ɵɵattribute("aria-selected", !ctx_r0.searchInputs[column_r15.name] ? true : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c24, !ctx_r0.searchInputs[column_r15.name]));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(column_r15.selections);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r19 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r19.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r19.name);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_3_For_1_Template, 2, 2, "option", 19, _forTrack0);
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵrepeater(column_r15.selections);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1, "Ja");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "option", 19);
    i0.ɵɵtext(3, "Nein");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngValue", "true");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngValue", "false");
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 58);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const column_r15 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.searchInputs[column_r15.name], $event) || (ctx_r0.searchInputs[column_r15.name] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Template_select_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r0 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "-- Alle --");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_3_Template, 2, 0)(4, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Conditional_4_Template, 4, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("aria-label", "Filter f\xFCr die Spalte ", column_r15.name, "");
    i0.ɵɵproperty("id", ctx_r0.id + column_r15.name)("name", column_r15.name);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.searchInputs[column_r15.name]);
    i0.ɵɵattribute("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", "");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(column_r15.selections ? 3 : 4);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "label", 53);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_3_Template, 8, 11)(4, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Conditional_4_Template, 5, 8, "select", 54);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.id + column_r15.name);
    i0.ɵɵattribute("data-prepend-width-group", ctx_r0.getUniqueTableId());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r15.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r15.selections && column_r15.multipleSelections ? 3 : 4);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 61);
  }
  if (rf & 2) {
    const s_r21 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r21);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "datalist", 15);
    i0.ɵɵrepeaterCreate(1, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_4_For_2_Template, 1, 1, "option", 61, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.id + column_r15.name + "Complete");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(column_r15.searchComplete);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 60);
    i0.ɵɵelement(1, "i", 62);
    i0.ɵɵelementEnd();
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "label", 53);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 59);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const column_r15 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.searchInputs[column_r15.name], $event) || (ctx_r0.searchInputs[column_r15.name] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Template_input_ngModelChange_3_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_4_Template, 3, 1, "datalist", 15)(5, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Conditional_5_Template, 2, 0, "span", 60);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    const column_r15 = ctx_r21.$implicit;
    const ɵ$index_158_r23 = ctx_r21.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.id + column_r15.name);
    i0.ɵɵattribute("data-prepend-width-group", ctx_r0.getUniqueTableId());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r15.name);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Filter f\xFCr die Spalte ", column_r15.name, "");
    i0.ɵɵproperty("id", ctx_r0.id + column_r15.name)("name", column_r15.name);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.searchInputs[column_r15.name]);
    i0.ɵɵattribute("aria-labelledby", "th-" + column_r15.field + "-" + ɵ$index_158_r23)("list", column_r15.name + "Complete")("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵconditional((column_r15.searchComplete == null ? null : column_r15.searchComplete.length) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r15.type === "short-string" ? 5 : -1);
  }
}
function TableComponent_Conditional_11_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtemplate(1, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_1_Template, 5, 4, "div", 16)(2, TableComponent_Conditional_11_For_4_Conditional_1_Conditional_2_Template, 6, 13, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r15.selections || column_r15.type === "boolean" ? 1 : 2);
  }
}
function TableComponent_Conditional_11_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, TableComponent_Conditional_11_For_4_Conditional_1_Template, 3, 1, "div", 52);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r15 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r15.type && column_r15.name ? 1 : -1);
  }
}
function TableComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "small", 51);
    i0.ɵɵtext(2, "Filter");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, TableComponent_Conditional_11_For_4_Template, 2, 1, "div", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "d-" + ctx_r0.responsiveBreakpoint + "-none");
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r0.getVisibleColumns());
  }
}
function TableComponent_Conditional_13_For_6_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 68);
  }
}
function TableComponent_Conditional_13_For_6_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 69);
  }
  if (rf & 2) {
    const column_r25 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("aria-label", "Die Tabelle wird nach der Spalte ", column_r25.name, " in absteigender Reihenfolge sortiert.");
    i0.ɵɵproperty("ngClass", ctx_r0.desc ? "fa-sort-down" : "fa-sort-up");
  }
}
function TableComponent_Conditional_13_For_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableComponent_Conditional_13_For_6_Conditional_3_Conditional_0_Template, 1, 0, "i", 68)(1, TableComponent_Conditional_13_For_6_Conditional_3_Conditional_1_Template, 1, 3, "i", 69);
  }
  if (rf & 2) {
    const column_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.sortField !== column_r25.field ? 0 : 1);
  }
}
function TableComponent_Conditional_13_For_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 67);
  }
  if (rf & 2) {
    const column_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("title", column_r25.headerHint);
  }
}
function TableComponent_Conditional_13_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵdeclareLet(0);
    i0.ɵɵelementStart(1, "th", 66);
    i0.ɵɵlistener("click", function TableComponent_Conditional_13_For_6_Template_th_click_1_listener($event) {
      const column_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const sortableField_r26 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(sortableField_r26 ? ctx_r0.setSortField($event, column_r25) : null);
    })("keydown.space", function TableComponent_Conditional_13_For_6_Template_th_keydown_space_1_listener($event) {
      const column_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const sortableField_r26 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(sortableField_r26 ? ctx_r0.setSortField($event, column_r25) : null);
    })("keydown.enter", function TableComponent_Conditional_13_For_6_Template_th_keydown_enter_1_listener($event) {
      const column_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const sortableField_r26 = i0.ɵɵreadContextLet(0);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(sortableField_r26 ? ctx_r0.setSortField($event, column_r25) : null);
    });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, TableComponent_Conditional_13_For_6_Conditional_3_Template, 2, 1)(4, TableComponent_Conditional_13_For_6_Conditional_4_Template, 1, 1, "i", 67);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r25 = ctx.$implicit;
    const ɵ$index_234_r27 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstoreLet(ctx_r0.sort() && column_r25.type && !column_r25.type.endsWith("[]"));
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", column_r25.fixedWidth, "px");
    i0.ɵɵproperty("id", ctx_r0.id + "th-" + column_r25.field + "-" + ɵ$index_234_r27)("ngClass", i0.ɵɵpureFunction1(10, _c25, ctx_r0.sort() && column_r25.type && !column_r25.type.endsWith("[]")))("tabindex", column_r25.type && !column_r25.type.endsWith("[]") && ctx_r0.sort() ? 0 : -1);
    i0.ɵɵattribute("aria-hidden", !column_r25.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", column_r25.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r25.type && !column_r25.type.endsWith("[]") && ctx_r0.sort() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r25.headerHint ? 4 : -1);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_For_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_For_8_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r30);
      const option_r31 = i0.ɵɵnextContext().$implicit;
      const column_r29 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      ctx_r0.changeFilterOption(column_r29, option_r31.value);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelement(1, "i", 57);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r31 = i0.ɵɵnextContext().$implicit;
    const column_r29 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate3("aria-label", "Eintr\xE4ge die den Wert ", option_r31.name, " in der Spalte ", column_r29.name, " besitzen ", ctx_r0.searchInputs[column_r29.name].split(";").includes(option_r31.value) ? "entfernen" : "hinzuf\xFCgen", "");
    i0.ɵɵattribute("aria-selected", ctx_r0.searchInputs[column_r29.name].split(";").includes(option_r31.value) ? true : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c24, ctx_r0.searchInputs[column_r29.name].split(";").includes(option_r31.value)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("\u2002", option_r31.name, " ");
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_For_8_Conditional_0_Template, 3, 9, "button", 35);
  }
  if (rf & 2) {
    const option_r31 = ctx.$implicit;
    i0.ɵɵconditional(!option_r31.value.includes(";") ? 0 : -1);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 71)(1, "button", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 56)(4, "button", 36);
    i0.ɵɵlistener("click", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r28);
      const column_r29 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      ctx_r0.searchInputs[column_r29.name] = "";
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelement(5, "i", 57);
    i0.ɵɵtext(6, "\u2002-- Alle -- ");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_For_8_Template, 1, 1, null, null, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r29 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "multiSelection-" + ctx_r0.getUniqueTableId() + "-" + column_r29.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !ctx_r0.searchInputs[column_r29.name] ? "-- Alle --" : ctx_r0.searchInputs[column_r29.name].split(";").length + " ausgew\xE4hlt", " ");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-labelledby", "multiSelection-", ctx_r0.getUniqueTableId(), "-", column_r29.name, "");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Alle Werte der Spalte ", column_r29.name, " anzeigen.");
    i0.ɵɵattribute("aria-selected", !ctx_r0.searchInputs[column_r29.name] ? true : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c24, !ctx_r0.searchInputs[column_r29.name]));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(column_r29.selections);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r33 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r33.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r33.name);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_3_For_1_Template, 2, 2, "option", 19, _forTrack0);
  }
  if (rf & 2) {
    const column_r29 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵrepeater(column_r29.selections);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1, "Ja");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "option", 19);
    i0.ɵɵtext(3, "Nein");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngValue", "true");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngValue", "false");
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 58);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r32);
      const column_r29 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.searchInputs[column_r29.name], $event) || (ctx_r0.searchInputs[column_r29.name] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Template_select_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r32);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2, "-- Alle --");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_3_Template, 2, 0)(4, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Conditional_4_Template, 4, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    const column_r29 = ctx_r33.$implicit;
    const ɵ$index_252_r35 = ctx_r33.$index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("min-width", "50px !important");
    i0.ɵɵattributeInterpolate1("aria-label", "Filter f\xFCr die Spalte ", column_r29.name, "");
    i0.ɵɵproperty("id", ctx_r0.id + column_r29.name)("name", column_r29.name);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.searchInputs[column_r29.name]);
    i0.ɵɵattribute("aria-labelledby", "th-" + column_r29.field + "-" + ɵ$index_252_r35)("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", "");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(column_r29.selections ? 3 : 4);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_0_Template, 9, 11, "div", 71)(1, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Conditional_1_Template, 5, 11, "select", 72);
  }
  if (rf & 2) {
    const column_r29 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵconditional(column_r29.selections && column_r29.multipleSelections ? 0 : 1);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 60);
    i0.ɵɵelement(1, "i", 62);
    i0.ɵɵelementEnd();
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 61);
  }
  if (rf & 2) {
    const s_r37 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r37);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "datalist", 15);
    i0.ɵɵrepeaterCreate(1, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_3_For_2_Template, 1, 1, "option", 61, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r29 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r0.id + column_r29.name + "Complete");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(column_r29.searchComplete);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "input", 73);
    i0.ɵɵtwoWayListener("ngModelChange", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const column_r29 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.searchInputs[column_r29.name], $event) || (ctx_r0.searchInputs[column_r29.name] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r0 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r0.refreshOutputValues());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_2_Template, 2, 0, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Conditional_3_Template, 3, 1, "datalist", 15);
  }
  if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    const column_r29 = ctx_r33.$implicit;
    const ɵ$index_252_r35 = ctx_r33.$index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("min-width", (column_r29.type === "number" ? "50" : "75") + "px !important");
    i0.ɵɵattributeInterpolate1("aria-label", "Filter f\xFCr die Spalte ", column_r29.name, "");
    i0.ɵɵproperty("id", ctx_r0.id + column_r29.name)("name", column_r29.name);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.searchInputs[column_r29.name]);
    i0.ɵɵattribute("aria-labelledby", "th-" + column_r29.field + "-" + ɵ$index_252_r35)("list", column_r29.name + "Complete")("aria-controls", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r29.type === "short-string" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((column_r29.searchComplete == null ? null : column_r29.searchComplete.length) ? 3 : -1);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtemplate(1, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_1_Template, 2, 1)(2, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Conditional_2_Template, 4, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r29.selections || column_r29.type === "boolean" ? 1 : 2);
  }
}
function TableComponent_Conditional_13_Conditional_7_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtemplate(1, TableComponent_Conditional_13_Conditional_7_For_2_Conditional_1_Template, 3, 1, "div", 52);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r29 = ctx.$implicit;
    i0.ɵɵstyleProp("width", column_r29.fixedWidth, "px");
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r29.type && column_r29.name ? 1 : -1);
  }
}
function TableComponent_Conditional_13_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 64);
    i0.ɵɵrepeaterCreate(1, TableComponent_Conditional_13_Conditional_7_For_2_Template, 2, 3, "th", 70, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.getVisibleColumns());
  }
}
function TableComponent_Conditional_13_For_10_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 75);
  }
  if (rf & 2) {
    const column_r40 = ctx.$implicit;
    const value_r39 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tableData())("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c26, column_r40, value_r39));
  }
}
function TableComponent_Conditional_13_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 74);
    i0.ɵɵlistener("keydown.enter", function TableComponent_Conditional_13_For_10_Template_tr_keydown_enter_0_listener() {
      const value_r39 = i0.ɵɵrestoreView(_r38).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.trClickEmitter.observed ? ctx_r0.trClickEmitter.next(value_r39) : null);
    })("mousedown", function TableComponent_Conditional_13_For_10_Template_tr_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r38);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.trAuxClickEmitter.observed && $event.button === 1 ? $event.preventDefault() : null);
    })("click", function TableComponent_Conditional_13_For_10_Template_tr_click_0_listener() {
      const value_r39 = i0.ɵɵrestoreView(_r38).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.trClickEmitter.observed ? ctx_r0.trClickEmitter.next(value_r39) : null);
    })("auxclick", function TableComponent_Conditional_13_For_10_Template_tr_auxclick_0_listener() {
      const value_r39 = i0.ɵɵrestoreView(_r38).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.trAuxClickEmitter.observed ? ctx_r0.trAuxClickEmitter.next(value_r39) : null);
    });
    i0.ɵɵrepeaterCreate(1, TableComponent_Conditional_13_For_10_For_2_Template, 1, 5, "ng-container", 75, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.trClass());
    i0.ɵɵproperty("tabIndex", ctx_r0.trClickEmitter.observed ? 0 : null);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.getVisibleColumns());
  }
}
function TableComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 10, 0)(2, "thead", null, 1)(4, "tr");
    i0.ɵɵrepeaterCreate(5, TableComponent_Conditional_13_For_6_Template, 5, 12, "th", 63, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, TableComponent_Conditional_13_Conditional_7_Template, 3, 0, "tr", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵrepeaterCreate(9, TableComponent_Conditional_13_For_10_Template, 3, 3, "tr", 65, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵpipe(11, "tablePage");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id)("ngClass", (ctx_r0.responsiveBreakpoint ? "rbb-table-responsive-" + ctx_r0.responsiveBreakpoint : "") + " " + ctx_r0.tableClass());
    i0.ɵɵattribute("aria-labelledby", ctx_r0.title ? ctx_r0.id + "-heading" : undefined);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r0.getVisibleColumns());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.search() && ctx_r0.searchType() === "SEPARATE" ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("d-none", ctx_r0.loading());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind3(11, 6, ctx_r0.outputValues, ctx_r0.selectedPageSize, ctx_r0.currentPage));
  }
}
function TableComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "rbb-loader");
    i0.ɵɵelementEnd();
  }
}
function TableComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, " Keine Eintr\xE4ge gefunden. ");
    i0.ɵɵelementEnd();
  }
}
function TableComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-paginator", 50);
    i0.ɵɵlistener("pageChange", function TableComponent_Conditional_17_Template_rbb_paginator_pageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r41);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.pageChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("currentPage", ctx_r0.currentPage)("pages", ctx_r0.getPageNumber())("ariaControls", ctx_r0.id);
  }
}
function TableComponent_Conditional_18_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.currentPage - 1) * ctx_r0.selectedPageSize + 1, ". - ", ctx_r0.Math.min(ctx_r0.currentPage * ctx_r0.selectedPageSize, ctx_r0.outputValues.length), ". von ");
  }
}
function TableComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, TableComponent_Conditional_18_Conditional_1_Template, 1, 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectedPageSize && ctx_r0.currentPage && ctx_r0.outputValues.length ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.outputValues.length, " Eintr\xE4ge ");
  }
}
function TableComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "iframe", 76);
  }
}
const _c27 = ["settingModal"];
const _c28 = () => [0];
const _c29 = (a0, a1) => ({
  "small text-secondary": a0,
  "fw-bold": a1
});
const _c30 = (a0, a1) => ({
  value: a0,
  config: a1
});
function SettingComponent_For_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " (test) ");
  }
}
function SettingComponent_For_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " (stage) ");
  }
}
function SettingComponent_For_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " (prod) ");
  }
}
function SettingComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SettingComponent_For_7_Conditional_2_Template, 1, 0)(3, SettingComponent_For_7_Conditional_3_Template, 1, 0)(4, SettingComponent_For_7_Conditional_4_Template, 1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const serviceUrl_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", serviceUrl_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", serviceUrl_r2.split("/").reverse()[0].replace("-service", ""), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(serviceUrl_r2.includes("tools-t") || serviceUrl_r2.includes("webapp-t") ? 2 : serviceUrl_r2.includes("tools-s") || serviceUrl_r2.includes("webapp-s") ? 3 : 4);
  }
}
function SettingComponent_For_10_ng_template_7_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
  }
  if (rf & 2) {
    const value_r5 = i0.ɵɵnextContext().value;
    i0.ɵɵnextContext(2);
    const settingValue_r6 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", settingValue_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c30, value_r5.value, value_r5.config));
  }
}
function SettingComponent_For_10_ng_template_7_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
  }
  if (rf & 2) {
    const value_r5 = i0.ɵɵnextContext().value;
    i0.ɵɵnextContext(2);
    const settingValue_r6 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", settingValue_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c30, value_r5.config.defaultValue, value_r5.config));
  }
}
function SettingComponent_For_10_ng_template_7_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const column_r8 = ctx_r6.column;
    const value_r5 = ctx_r6.value;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.get(value_r5, column_r8.field), " ");
  }
}
function SettingComponent_For_10_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 17);
    i0.ɵɵtemplate(1, SettingComponent_For_10_ng_template_7_Case_1_Template, 1, 5, "ng-container", 18)(2, SettingComponent_For_10_ng_template_7_Case_2_Template, 1, 5, "ng-container", 18)(3, SettingComponent_For_10_ng_template_7_Case_3_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_18_0;
    const column_r8 = ctx.column;
    const value_r5 = ctx.value;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c29, column_r8.field === "value" && ctx_r3.isEqual(value_r5.value, value_r5.config.defaultValue) || value_r5.disabled, column_r8.field === "value" && !ctx_r3.isEqual(value_r5.value, value_r5.config.defaultValue)));
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_18_0 = column_r8.field) === "value" ? 1 : tmp_18_0 === "config.defaultValue" ? 2 : 3);
  }
}
function SettingComponent_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "h2", 12)(2, "button", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 14)(5, "div", 15)(6, "rbb-table", 16);
    i0.ɵɵlistener("trClick", function SettingComponent_For_10_Template_rbb_table_trClick_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.openModal($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SettingComponent_For_10_ng_template_7_Template, 4, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const category_r9 = ctx.$implicit;
    const ɵ$index_24_r10 = ctx.$index;
    const tableData_r11 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", category_r9, "-settings");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-bs-target", "#collapse-category-", ɵ$index_24_r10, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r9, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("show", ctx_r3.initShow);
    i0.ɵɵattributeInterpolate1("aria-labelledby", "", category_r9, "-settings");
    i0.ɵɵpropertyInterpolate1("id", "collapse-category-", ɵ$index_24_r10, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("columns", ctx_r3.settingListColumns)("values", ctx_r3.getSettingsByCategory(category_r9))("tableData", tableData_r11)("pageSizes", i0.ɵɵpureFunction0(20, _c28))("selectedPageSize", 0)("resultNumbers", false)("search", false)("sort", false)("export", false);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtext(2, "Der Wert darf f\xFCr diese Instanz nicht ver\xE4ndert werden.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    const settingValue_r6 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", settingValue_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c30, ctx_r3.selectedSetting.value, ctx_r3.selectedSetting.config));
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 37);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_0_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(1, "option", 38);
    i0.ɵɵtext(2, "true");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 38);
    i0.ɵɵtext(4, "false");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngValue", false);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("step", 1)("min", -9223372036854776000)("max", 9223372036854776000);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 40);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_2_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r17);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r17);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 37);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_3_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(1, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_3_For_2_Template, 2, 2, "option", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.selectedSetting.config.optionList);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-multi-value-input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_4_Template_rbb_multi_value_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r20 = ctx.value;
    i0.ɵɵtextInterpolate1(" ", value_r20, " ");
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-multi-select", 42);
    i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_5_Template_rbb_multi_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r3 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedSetting.value, $event) || (ctx_r3.selectedSetting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_5_ng_template_1_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const optionListTemplate_r21 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedSetting.value);
    i0.ɵɵproperty("values", ctx_r3.selectedSetting.config.optionList)("itemTemplate", optionListTemplate_r21);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_0_Template, 5, 3, "select", 33)(1, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_1_Template, 1, 4, "input", 34)(2, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_2_Template, 1, 1, "input", 35)(3, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_3_Template, 3, 1, "select", 33)(4, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_4_Template, 1, 1, "rbb-multi-value-input", 36)(5, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Case_5_Template, 3, 3);
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional((tmp_5_0 = ctx_r3.selectedSetting.config == null ? null : ctx_r3.selectedSetting.config.type) === "BOOLEAN" ? 0 : tmp_5_0 === "LONG" ? 1 : tmp_5_0 === "STRING" ? 2 : tmp_5_0 === "OPTION" ? 3 : tmp_5_0 === "STRING_LIST" ? 4 : tmp_5_0 === "OPTION_LIST" ? 5 : -1);
  }
}
function SettingComponent_ng_template_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 28)(2, "span", 29);
    i0.ɵɵtext(3, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 28)(7, "span", 29);
    i0.ɵɵtext(8, "Standardwert");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelementContainer(10, 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 30)(12, "span", 29);
    i0.ɵɵtext(13, "Beschreibung");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 30)(17, "label", 31);
    i0.ɵɵtext(18, "Wert");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div");
    i0.ɵɵtemplate(20, SettingComponent_ng_template_11_Conditional_5_Conditional_20_Template, 3, 5)(21, SettingComponent_ng_template_11_Conditional_5_Conditional_21_Template, 6, 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const settingValue_r6 = i0.ɵɵreference(14);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedSetting.name, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngTemplateOutlet", settingValue_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c30, ctx_r3.selectedSetting.config == null ? null : ctx_r3.selectedSetting.config.defaultValue, ctx_r3.selectedSetting.config));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedSetting.description, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r3.selectedSetting.disabled ? 20 : 21);
  }
}
function SettingComponent_ng_template_11_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function SettingComponent_ng_template_11_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.updateSetting());
    });
    i0.ɵɵtext(1, "Aktualisieren");
    i0.ɵɵelementEnd();
  }
}
function SettingComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "h5", 20);
    i0.ɵɵtext(2, "Setting:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵlistener("click", function SettingComponent_ng_template_11_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.closeModal());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵtemplate(5, SettingComponent_ng_template_11_Conditional_5_Template, 22, 8, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 24);
    i0.ɵɵtemplate(7, SettingComponent_ng_template_11_Conditional_7_Template, 2, 0, "button", 25);
    i0.ɵɵelementStart(8, "button", 26);
    i0.ɵɵlistener("click", function SettingComponent_ng_template_11_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.setSettingToDefault());
    });
    i0.ɵɵtext(9, "Auf Standardwert setzen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 27);
    i0.ɵɵlistener("click", function SettingComponent_ng_template_11_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.closeModal());
    });
    i0.ɵɵtext(11, "Schlie\xDFen");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r3.selectedSetting ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ctx_r3.selectedSetting == null ? null : ctx_r3.selectedSetting.disabled) ? 7 : -1);
  }
}
function SettingComponent_ng_template_13_Case_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 44);
    i0.ɵɵtext(1, " true ");
  }
}
function SettingComponent_ng_template_13_Case_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 45);
    i0.ɵɵtext(1, " false ");
  }
}
function SettingComponent_ng_template_13_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SettingComponent_ng_template_13_Case_0_Conditional_0_Template, 2, 0)(1, SettingComponent_ng_template_13_Case_0_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const value_r23 = i0.ɵɵnextContext().value;
    i0.ɵɵconditional(value_r23 === true ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(value_r23 === false ? 1 : -1);
  }
}
function SettingComponent_ng_template_13_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r23 = i0.ɵɵnextContext().value;
    i0.ɵɵtextInterpolate1(" ", value_r23 == null ? null : value_r23.join(", "), " ");
  }
}
function SettingComponent_ng_template_13_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r23 = i0.ɵɵnextContext().value;
    i0.ɵɵtextInterpolate1(" ", value_r23 == null ? null : value_r23.join(", "), " ");
  }
}
function SettingComponent_ng_template_13_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const value_r23 = i0.ɵɵnextContext().value;
    i0.ɵɵtextInterpolate1(" ", value_r23, " ");
  }
}
function SettingComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SettingComponent_ng_template_13_Case_0_Template, 2, 2)(1, SettingComponent_ng_template_13_Case_1_Template, 1, 1)(2, SettingComponent_ng_template_13_Case_2_Template, 1, 1)(3, SettingComponent_ng_template_13_Case_3_Template, 1, 1);
  }
  if (rf & 2) {
    let tmp_5_0;
    const config_r24 = ctx.config;
    i0.ɵɵconditional((tmp_5_0 = config_r24.type) === "BOOLEAN" ? 0 : tmp_5_0 === "STRING_LIST" ? 1 : tmp_5_0 === "OPTION_LIST" ? 2 : 3);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3)(1, "span", 6);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", entry_r1.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(entry_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(entry_r1.name);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_1_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10)(1, "span", 6);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const subEntry_r2 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", subEntry_r2.routerLink);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(subEntry_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(subEntry_r2.name);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵrepeaterCreate(1, SideMenuComponent_For_3_For_3_Conditional_1_Conditional_5_For_2_Template, 5, 4, "a", 10, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(entry_r1.sub);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8)(1, "span", 6);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, SideMenuComponent_For_3_For_3_Conditional_1_Conditional_5_Template, 3, 0, "span", 9);
  }
  if (rf & 2) {
    const entry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", entry_r1.routerLink);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(entry_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(entry_r1.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r1.sub ? 5 : -1);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function SideMenuComponent_For_3_For_3_Conditional_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const entry_r1 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r1.func());
    })("keydown.enter", function SideMenuComponent_For_3_For_3_Conditional_2_Template_a_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const entry_r1 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r1.func());
    })("keydown.space", function SideMenuComponent_For_3_For_3_Conditional_2_Template_a_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const entry_r1 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(entry_r1.func());
    });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(entry_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(entry_r1.name);
  }
}
function SideMenuComponent_For_3_For_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3)(1, "span", 6);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassProp("disabled", entry_r1.disabled);
    i0.ɵɵproperty("href", entry_r1.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(entry_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(entry_r1.name);
  }
}
function SideMenuComponent_For_3_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SideMenuComponent_For_3_For_3_Conditional_0_Template, 5, 4, "a", 3)(1, SideMenuComponent_For_3_For_3_Conditional_1_Template, 6, 5)(2, SideMenuComponent_For_3_For_3_Conditional_2_Template, 5, 3, "a", 4)(3, SideMenuComponent_For_3_For_3_Conditional_3_Template, 5, 6, "a", 5);
  }
  if (rf & 2) {
    const entry_r1 = ctx.$implicit;
    i0.ɵɵconditional(entry_r1.href ? 0 : entry_r1.routerLink ? 1 : entry_r1.func ? 2 : 3);
  }
}
function SideMenuComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(2, SideMenuComponent_For_3_For_3_Template, 4, 1, null, null, _forTrack0);
  }
  if (rf & 2) {
    const group_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(group_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(group_r4.entries);
  }
}
const _c31 = (a0, a1, a2) => ({
  "active": a0,
  "old": a1,
  "disabled": a2
});
function StepsComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "button", 2);
    i0.ɵɵlistener("click", function StepsComponent_For_3_Template_button_click_1_listener() {
      const step_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clickStep(step_r2));
    });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const ɵ$index_5_r4 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c31, !step_r2.disabled && ɵ$index_5_r4 + 1 === ctx_r2.current(), !step_r2.disabled && ɵ$index_5_r4 + 1 < ctx_r2.current(), step_r2.disabled));
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-label", "", ɵ$index_5_r4 + 1, ". ", step_r2.name, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c25, !step_r2.disabled && step_r2.func))("tabindex", 0)("disabled", step_r2.disabled);
    i0.ɵɵattribute("aria-current", ɵ$index_5_r4 + 1 === ctx_r2.current() ? "step" : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ɵ$index_5_r4 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r2.name);
  }
}
const _c32 = ["treeItemElement"];
const _c33 = a0 => ({
  "fw-bold": a0
});
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const s_r3 = ctx.$implicit;
    const ɵ$index_10_r4 = ctx.$index;
    i0.ɵɵclassProp("bg-warning", ɵ$index_10_r4 % 2 === 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(s_r3);
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "i", 3);
    i0.ɵɵlistener("click", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_i_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectObject(ctx_r1.treeItem.object));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 4, 0);
    i0.ɵɵlistener("click", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectTreeItem(ctx_r1.treeItem));
    })("keydown.enter", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_enter_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectTreeItem(ctx_r1.treeItem));
    })("keydown.arrowLeft", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_arrowLeft_2_listener($event) {
      let tmp_5_0;
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      (tmp_5_0 = ctx_r1.parentElement()) == null ? null : tmp_5_0.nativeElement == null ? null : tmp_5_0.nativeElement.focus();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowDown", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_arrowDown_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToNextNode();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowUp", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_arrowUp_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToPreviousNode();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.home", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_home_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToStart();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.end", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template_span_keydown_end_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToEnd();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵrepeaterCreate(4, TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_For_5_Template, 2, 3, "span", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.itemIcon());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c33, ctx_r1.isEqual(ctx_r1.treeItem.object, ctx_r1.selected)));
    i0.ɵɵattribute("aria-selected", ctx_r1.isEqual(ctx_r1.treeItem.object, ctx_r1.selected));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.formatSplit(ctx_r1.treeItem.name));
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 3);
    i0.ɵɵlistener("click", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.fold());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.unfoldedIcon());
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 3);
    i0.ɵɵlistener("click", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.unfold());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.foldedIcon());
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const s_r8 = ctx.$implicit;
    const ɵ$index_25_r9 = ctx.$index;
    i0.ɵɵclassProp("bg-warning", ɵ$index_25_r9 % 2 === 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(s_r8);
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template, 1, 2, "i", 6)(2, TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template, 1, 2, "i", 6);
    i0.ɵɵelementStart(3, "span", 7, 0);
    i0.ɵɵlistener("click", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_click_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.unfolded ? ctx_r1.fold() : ctx_r1.unfold();
      return i0.ɵɵresetView(ctx_r1.selectTreeItem(ctx_r1.treeItem));
    })("keydown.enter", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.unfolded ? ctx_r1.fold() : ctx_r1.unfold();
      return i0.ɵɵresetView(ctx_r1.selectTreeItem(ctx_r1.treeItem));
    })("keydown.arrowRight", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_arrowRight_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      !ctx_r1.unfolded ? ctx_r1.unfold() : (ctx_r1.treeItem.children == null ? null : ctx_r1.treeItem.children.length) && ctx_r1.focusToNextNode();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowLeft", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_arrowLeft_3_listener($event) {
      let tmp_5_0;
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.unfolded ? ctx_r1.fold() : (tmp_5_0 = ctx_r1.parentElement()) == null ? null : tmp_5_0.nativeElement == null ? null : tmp_5_0.nativeElement.focus();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowDown", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_arrowDown_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToNextNode();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowUp", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_arrowUp_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToPreviousNode();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.home", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_home_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToStart();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.end", function TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template_span_keydown_end_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.focusToEnd();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵrepeaterCreate(5, TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_For_6_Template, 2, 3, "span", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-expanded", ctx_r1.unfolded)("aria-owns", "tree-group-" + ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.unfolded ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c33, ctx_r1.isEqual(ctx_r1.treeItem.object, ctx_r1.selected)));
    i0.ɵɵattribute("aria-selected", ctx_r1.isEqual(ctx_r1.treeItem.object, ctx_r1.selected));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.formatSplit(ctx_r1.treeItem.name));
  }
}
function TreeItemComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TreeItemComponent_Conditional_0_Conditional_0_Conditional_0_Template, 6, 6, "div", 2)(1, TreeItemComponent_Conditional_0_Conditional_0_Conditional_1_Template, 7, 7, "div", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.treeItem.item ? 0 : 1);
  }
}
function TreeItemComponent_Conditional_0_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-tree-item", 9);
    i0.ɵɵlistener("itemSelect", function TreeItemComponent_Conditional_0_Conditional_1_For_2_Template_rbb_tree_item_itemSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectObject($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("treeItem", child_r11)("search", ctx_r1.search())("subTree", true)("selected", ctx_r1.selected)("foldedIcon", ctx_r1.foldedIcon())("unfoldedIcon", ctx_r1.unfoldedIcon())("itemIcon", ctx_r1.itemIcon())("selectOnlyItems", ctx_r1.selectOnlyItems())("parentElement", ctx_r1.treeItemElement());
  }
}
function TreeItemComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵrepeaterCreate(1, TreeItemComponent_Conditional_0_Conditional_1_For_2_Template, 1, 9, "rbb-tree-item", 8, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", "tree-group-" + ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.treeItem.children);
  }
}
function TreeItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TreeItemComponent_Conditional_0_Conditional_0_Template, 2, 1)(1, TreeItemComponent_Conditional_0_Conditional_1_Template, 3, 1, "div", 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.treeItem.name ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.treeItem.item && ctx_r1.unfolded ? 1 : -1);
  }
}
function TreeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function TreeComponent_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.search, $event) || (ctx_r1.search = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.search);
  }
}
const _c34 = ["contextMenuElement"];
const _c35 = (a0, a1, a2) => ({
  "top": a0,
  "left": a1,
  "right": a2
});
const _c36 = (a0, a1) => ({
  "pointer": a0,
  "opened": a1
});
function ContextMenuComponent_For_3_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", item_r2.icon);
  }
}
function ContextMenuComponent_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 4);
    i0.ɵɵtemplate(1, ContextMenuComponent_For_3_Conditional_0_Conditional_1_Template, 1, 1, "i", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r2.icon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
  }
}
function ContextMenuComponent_For_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", item_r2.icon);
  }
}
function ContextMenuComponent_For_3_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 9);
  }
}
function ContextMenuComponent_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8, 1);
    i0.ɵɵlistener("mouseenter", function ContextMenuComponent_For_3_Conditional_1_Template_a_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemElement_r4 = i0.ɵɵreference(1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.openSubMenu(itemElement_r4, item_r2));
    })("keydown.arrowRight", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_arrowRight_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemElement_r4 = i0.ɵɵreference(1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.openSubMenu(itemElement_r4, item_r2));
    })("keydown.enter", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemElement_r4 = i0.ɵɵreference(1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick(itemElement_r4, item_r2));
    })("keydown.space", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemElement_r4 = i0.ɵɵreference(1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick(itemElement_r4, item_r2));
    })("keydown.arrowDown", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_arrowDown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ɵ$index_3_r6 = i0.ɵɵnextContext().$index;
      const ctx_r4 = i0.ɵɵnextContext();
      ctx_r4.focusToNextNode(ɵ$index_3_r6);
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.arrowUp", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_arrowUp_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ɵ$index_3_r6 = i0.ɵɵnextContext().$index;
      const ctx_r4 = i0.ɵɵnextContext();
      ctx_r4.focusToPreviousNode(ɵ$index_3_r6);
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.home", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r4 = i0.ɵɵnextContext(2);
      ctx_r4.focusToStart();
      return i0.ɵɵresetView($event.preventDefault());
    })("keydown.end", function ContextMenuComponent_For_3_Conditional_1_Template_a_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r4 = i0.ɵɵnextContext(2);
      ctx_r4.focusToEnd();
      return i0.ɵɵresetView($event.preventDefault());
    })("click", function ContextMenuComponent_For_3_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemElement_r4 = i0.ɵɵreference(1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.itemClick(itemElement_r4, item_r2));
    });
    i0.ɵɵtemplate(2, ContextMenuComponent_For_3_Conditional_1_Conditional_2_Template, 1, 1, "i", 7);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, ContextMenuComponent_For_3_Conditional_1_Conditional_4_Template, 1, 0, "i", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c36, !item_r2.children || item_r2.children.length === 0, item_r2 === ctx_r4.openedSubMenu));
    i0.ɵɵattribute("aria-haspopup", (item_r2.children == null ? null : item_r2.children.length) ? "menu" : undefined)("aria-expanded", (item_r2.children == null ? null : item_r2.children.length) && item_r2 === ctx_r4.openedSubMenu)("aria-controls", (item_r2.children == null ? null : item_r2.children.length) && item_r2 === ctx_r4.openedSubMenu ? ctx_r4.subMenuId : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(item_r2.icon ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r2.children && item_r2.children.length ? 4 : -1);
  }
}
function ContextMenuComponent_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 6);
  }
}
function ContextMenuComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ContextMenuComponent_For_3_Conditional_0_Template, 3, 2, "h6", 4)(1, ContextMenuComponent_For_3_Conditional_1_Template, 5, 10, "a", 5)(2, ContextMenuComponent_For_3_Conditional_2_Template, 1, 0, "hr", 6);
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ɵ$index_3_r6 = ctx.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵconditional(item_r2.header ? 0 : 1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(item_r2.groupEnd && ctx_r4.contextMenuItems.length - 1 > ɵ$index_3_r6 ? 2 : -1);
  }
}
function ContextMenuComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rbb-context-menu", 10);
    i0.ɵɵlistener("contextMenuClose", function ContextMenuComponent_Conditional_4_Template_rbb_context_menu_contextMenuClose_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.closeSubMenu());
    })("contextMenuSelect", function ContextMenuComponent_Conditional_4_Template_rbb_context_menu_contextMenuSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.contextMenuSelect.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const contextMenuElement_r8 = i0.ɵɵreference(1);
    i0.ɵɵproperty("contextMenuItems", ctx_r4.openedSubMenu.children)("xLeft", ctx_r4.openedSubMenuXLeft)("xRight", ctx_r4.openedSubMenuXRight)("y", ctx_r4.openedSubMenuY)("preXTurned", ctx_r4.openedSubMenuXTurned)("id", ctx_r4.subMenuId)("controlElement", contextMenuElement_r8);
  }
}
let CalendarComponent = /*#__PURE__*/(() => {
  class CalendarComponent {
    constructor() {
      this.zone = inject(NgZone);
      this.window = window;
      this.Math = Math;
      this.data = input.required();
      this.mode = input.required();
      this.startDate = input.required();
      this.endDate = input();
      this.workHourStart = input(0);
      this.workHourEnd = input(23);
      this.showMonth = input(false);
      this.showOverflow = input(false);
      this.selectMode = input(false);
      this.timeZone = input();
      this.rowNameFontSize = input(13);
      this.clickOnHeadCellEmitter = new Subject();
      this.clickOnHeadCell = outputFromObservable(this.clickOnHeadCellEmitter);
      this.contextMenuOnHeadCellEmitter = new Subject();
      this.contextMenuOnHeadCell = outputFromObservable(this.contextMenuOnHeadCellEmitter);
      this.doubleClickOnCellEmitter = new Subject();
      this.doubleClickOnCell = outputFromObservable(this.doubleClickOnCellEmitter);
      this.contextMenuOnCellEmitter = new Subject();
      this.contextMenuOnCell = outputFromObservable(this.contextMenuOnCellEmitter);
      this.currentSelection = output();
      this.daysOrHours = [];
      this.months = new Map();
      this.entriesSorted = [];
      this.cellWidth = 35;
      this.cells = new Map();
      this.filterString = localStorage.getItem('calendar-filter-' + this.getUniqueId()) ?? '';
      this.tableBody = viewChild('tableBody');
      this.heads = viewChildren('heads');
    }
    ngOnChanges() {
      const today = new Date(new Date().toLocaleDateString('en-US', {
        timeZone: this.timeZone(),
        timeZoneName: 'short'
      })).getTime();
      const startDateValue = this.startDate();
      if (startDateValue) {
        const startDate = new Date(new Date(startDateValue).toLocaleDateString('en-US', {
          timeZone: this.timeZone(),
          timeZoneName: 'short'
        }));
        switch (this.mode()) {
          case 'DAY':
            {
              this.daysOrHours = [];
              const endDateValue = this.endDate();
              if (!startDateValue || !endDateValue) {
                break;
              }
              const endDate = new Date(new Date(endDateValue).toLocaleDateString('en-US', {
                timeZone: this.timeZone(),
                timeZoneName: 'short'
              }));
              for (const date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
                const calculatedDate = new Date(date);
                let className = 'normal-day';
                if (today === calculatedDate.getTime()) {
                  className = 'today';
                } else if (calculatedDate.toLocaleDateString('en-US', {
                  timeZone: this.timeZone(),
                  weekday: 'short'
                }).startsWith('S')) {
                  className = 'weekend';
                }
                this.daysOrHours.push({
                  dayOrHour: calculatedDate,
                  className,
                  endTime: new Date(calculatedDate.getTime() + 86399999)
                });
              }
              this.months = new Map();
              for (const dayOrHour of this.daysOrHours) {
                const month = dayOrHour.dayOrHour.toLocaleString('sv-SE', {
                  timeZone: this.timeZone()
                }).substring(0, 7);
                if (this.months.has(month)) {
                  this.months.set(month, (this.months.get(month) ?? 0) + 1);
                } else {
                  this.months.set(month, 1);
                }
              }
              break;
            }
          case 'HOUR':
            {
              this.daysOrHours = [];
              const isToday = startDate.getTime() === today;
              const now = new Date().getTime();
              const nextDate = new Date(startDate);
              nextDate.setDate(nextDate.getDate() + 1);
              let lastTime = null;
              for (let time = startDate.getTime(); time < nextDate.getTime(); time += 3600000) {
                const calculatedTime = new Date(time);
                const hour = Number.parseInt(calculatedTime.toLocaleTimeString('sv-SE', {
                  timeZone: this.timeZone(),
                  hour: 'numeric'
                }), 10);
                if (hour === 0 || hour >= this.workHourStart() && hour <= this.workHourEnd()) {
                  if (isToday && lastTime && lastTime < now && now < calculatedTime.getTime()) {
                    this.daysOrHours[this.daysOrHours.length - 1].className = 'today';
                  }
                  if (lastTime) {
                    this.daysOrHours[this.daysOrHours.length - 1].endTime = new Date(calculatedTime.getTime() - 1);
                  }
                  lastTime = calculatedTime.getTime();
                  this.daysOrHours.push({
                    dayOrHour: calculatedTime,
                    className: 'normal-day',
                    endTime: calculatedTime
                  });
                }
              }
              if (isToday && lastTime && now > lastTime) {
                this.daysOrHours[this.daysOrHours.length - 1].className = 'today';
              }
              this.daysOrHours[this.daysOrHours.length - 1].endTime = new Date(nextDate.getTime() - 1);
              break;
            }
          default:
            this.daysOrHours = [];
        }
      } else {
        this.daysOrHours = [];
      }
      this.entriesSorted = [];
      this.cells = new Map();
      for (const group of this.data() ?? []) {
        const rowsSorted = [];
        this.entriesSorted.push(rowsSorted);
        for (const row of group.rows ?? []) {
          const dayOrHoursSorted = [];
          rowsSorted.push(dayOrHoursSorted);
          for (let i = 0; i < this.daysOrHours.length; i++) {
            const entriesSorted = row.entries?.filter(entry => this.startsAt(entry, this.daysOrHours[i], i)).map(entry => {
              this.cells.set(entry, 1);
              return entry;
            }).sort((a, b) => {
              if (a.endTimestamp && b.endTimestamp) {
                if (a.endTimestamp > b.endTimestamp) {
                  return -1;
                }
                if (a.endTimestamp < b.endTimestamp) {
                  return 1;
                }
              }
              return 0;
            }) ?? [];
            if (i === 0) {
              dayOrHoursSorted.push(entriesSorted);
              continue;
            }
            const previous = dayOrHoursSorted[i - 1].map(entry => {
              if (!entry) {
                return null;
              }
              const endTimestamp = new Date(entry.endTimestamp);
              return endTimestamp >= this.daysOrHours[i].dayOrHour ? entry : null;
            });
            const entriesWithSpaces = [];
            let previousIndex = 0;
            for (const entry of entriesSorted) {
              while (previous[previousIndex]) {
                const previousEntry = previous[previousIndex];
                entriesWithSpaces.push(previousEntry);
                this.cells.set(previousEntry, (this.cells.get(previousEntry) ?? 0) + 1);
                previousIndex++;
              }
              entriesWithSpaces.push(entry);
              previousIndex++;
            }
            for (let j = previousIndex; j < previous.length; j++) {
              const previousEntry = previous[j];
              entriesWithSpaces.push(previousEntry);
              if (previousEntry) {
                this.cells.set(previousEntry, (this.cells.get(previousEntry) ?? 0) + 1);
              }
            }
            dayOrHoursSorted.push(entriesWithSpaces);
          }
        }
      }
      if (!this.selectMode()) {
        this.currentSelection.emit([]);
      }
      this.onResize();
    }
    ngAfterViewChecked() {
      if (this.tableBody()?.nativeElement && !isTouchDevice()) {
        this.zone.runOutsideAngular(() => {
          if (!this.selectable) {
            this.selectable = new Selectable({
              container: this.tableBody()?.nativeElement,
              autoScroll: {
                threshold: 0,
                increment: 20
              }
            });
            this.selectable.disable();
          } else {
            this.selectable?.setContainer(this.tableBody()?.nativeElement);
          }
        });
      }
      if (this.selectMode() && !isTouchDevice()) {
        this.zone.runOutsideAngular(() => {
          this.selectable?.enable();
          this.selectable?.update();
        });
      } else {
        this.zone.runOutsideAngular(() => {
          this.selectable?.clear();
          this.selectable?.disable();
        });
      }
    }
    startsAt(entry, dayOrHour, index) {
      if (!entry.startTimestamp || !entry.endTimestamp) {
        return false;
      }
      const startTimestamp = new Date(entry.startTimestamp);
      return startTimestamp <= dayOrHour.endTime && (startTimestamp >= dayOrHour.dayOrHour || index === 0 && new Date(entry.endTimestamp) >= dayOrHour.dayOrHour);
    }
    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.getCellWidth();
      }, 400);
    }
    getCellWidth() {
      const widths = this.heads()?.map(e => e.nativeElement.getBoundingClientRect().width).filter(e => e);
      this.cellWidth = widths?.length ? widths.reduce((a, b) => a + b, 0) / widths.length : 34;
    }
    static lightOrDark(color) {
      let r;
      let g;
      let b;
      if (/^rgb/.exec(color)) {
        const colorParts = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.exec(color);
        r = colorParts?.[0] ? Number(colorParts?.[0]) : 0;
        g = colorParts?.[1] ? Number(colorParts?.[1]) : 0;
        b = colorParts?.[2] ? Number(colorParts?.[2]) : 0;
      } else {
        const hexColor = +('0x' + color.slice(1).replace(color.length < 5 ? /./g : '', '$&$&'));
        r = hexColor >> 16;
        g = hexColor >> 8 & 255;
        b = hexColor & 255;
      }
      const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
      if (hsp < 145) {
        return 'white';
      } else {
        return 'black';
      }
    }
    newDate(date) {
      return new Date(date);
    }
    getUniqueId() {
      return window.location.host + '+' + window.location.pathname.replace(/^\/([^/]*).*$/, '$1');
    }
    saveFilter() {
      localStorage.setItem('calendar-filter-' + this.getUniqueId(), this.filterString);
    }
    getMonths() {
      return Array.from(this.months.keys());
    }
    emitDoubleClickOnCell(event, timestamp, row) {
      this.doubleClickOnCellEmitter.next({
        event,
        timestamp,
        row,
        selected: event.target.classList.contains('ui-selected')
      });
    }
    emitContextMenuOnCell(event, timestamp, row) {
      this.contextMenuOnCellEmitter.next({
        event,
        timestamp,
        row,
        selected: event.target.classList.contains('ui-selected')
      });
    }
    selectStart() {
      if (this.selectMode() && !isTouchDevice()) {
        this.zone.runOutsideAngular(() => {
          this.selectable?.update();
        });
      }
    }
    analyzeSelect() {
      if (this.selectMode()) {
        const tableBody = this.tableBody();
        if (tableBody) {
          this.currentSelection.emit(Array.from(tableBody?.nativeElement.querySelectorAll('td.ui-selected')).map(element => ({
            timestamp: this.daysOrHours[element.getAttribute('data-rbb-day-or-hour-index')].dayOrHour,
            row: this.data()[element.getAttribute('data-rbb-group-index')].rows[element.getAttribute('data-rbb-row-index')]
          })));
        } else {
          this.currentSelection.emit([]);
        }
      }
    }
    static {
      this.ɵfac = function CalendarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CalendarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CalendarComponent,
        selectors: [["rbb-calendar"]],
        viewQuery: function CalendarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.tableBody, _c0, 5);
            i0.ɵɵviewQuerySignal(ctx.heads, _c1, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        hostBindings: function CalendarComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function CalendarComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow)("mouseup", function CalendarComponent_mouseup_HostBindingHandler() {
              return ctx.analyzeSelect();
            }, false, i0.ɵɵresolveWindow)("touchend", function CalendarComponent_touchend_HostBindingHandler() {
              return ctx.analyzeSelect();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          data: [1, "data"],
          mode: [1, "mode"],
          startDate: [1, "startDate"],
          endDate: [1, "endDate"],
          workHourStart: [1, "workHourStart"],
          workHourEnd: [1, "workHourEnd"],
          entryTemplate: "entryTemplate",
          showMonth: [1, "showMonth"],
          showOverflow: [1, "showOverflow"],
          selectMode: [1, "selectMode"],
          timeZone: [1, "timeZone"],
          rowNameFontSize: [1, "rowNameFontSize"]
        },
        outputs: {
          clickOnHeadCell: "clickOnHeadCell",
          contextMenuOnHeadCell: "contextMenuOnHeadCell",
          doubleClickOnCell: "doubleClickOnCell",
          contextMenuOnCell: "contextMenuOnCell",
          currentSelection: "currentSelection"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [["tableBody", ""], ["heads", ""], [1, "table", 2, "table-layout", "fixed", 3, "select-mode", "min-width"], [1, "table", 2, "table-layout", "fixed"], [1, "first-cell-width", "first-cell-width-search"], [1, "input-group", "input-group-sm", "p-1"], ["placeholder", "Suche", "type", "text", 1, "form-control", "search-input", 3, "ngModelChange", "ngModel"], ["data-bs-toggle", "dropdown", "type", "button", "id", "groups-dropdown", "aria-label", "Filterung nach Gruppen", 1, "btn", "btn-outline-secondary", "dropdown-toggle", "dropdown-toggle-split"], ["aria-labelledby", "groups-dropdown", 1, "dropdown-menu", "dropdown-menu-overflow-scroll"], [1, "dropdown-item", "small", 3, "click"], ["role", "separator", 1, "dropdown-divider"], [1, "dropdown-header"], [1, "dropdown-item", "small"], [3, "ngClass", "tabindex"], [1, "text-secondary", "month", "small", 3, "colSpan"], [3, "click", "keydown.enter", "keydown.space", "contextmenu", "ngClass", "tabindex"], [1, "th-day"], [1, "th-date", "text-secondary"], [1, "tr-divider"], [1, "first-cell-width"], [1, "p-2", "ps-3"], [1, "fw-bold", "text-secondary", "m-0", "p-0"], [1, "tr-divider", 3, "ngClass"], [1, "tr-divider", 3, "dblclick", "contextmenu", "ngClass"], [1, "tr-hover"], [1, "first-cell-width", 3, "click", "keydown.enter", "keydown.space", "tabindex"], [1, "row", "p-1", "ps-4"], [1, "col-auto", "row-img", "d-none", "d-lg-block"], [1, "col", "row-name", "align-self-center", 3, "font-size"], [1, "col-auto", "row-badges"], [1, "border", 3, "tabindex", "ui-selectable", "class"], [1, "col", "row-name", "align-self-center"], ["data-bs-placement", "right", "data-bs-toggle", "tooltip", 1, "d-inline-block", "ps-2", 3, "class", "title"], ["data-bs-placement", "right", "data-bs-toggle", "tooltip", 1, "d-inline-block", "ps-2", 3, "title"], [1, "border", 3, "dblclick", "keydown.enter", "keydown.space", "contextmenu", "mousedown", "tabindex"], [1, "entry-placeholder"], [1, "entry", "position-absolute", 2, "cursor", "auto", 3, "background-color", "overflow-left", "overflow-right", "margin-left", "width"], ["data-bs-trigger", "hover focus", "data-bs-custom-class", "no-max-width", "data-bs-placement", "top", "data-bs-html", "true", 1, "entry", 3, "keydown.enter", "keydown.space", "click", "contextmenu", "tabindex", "title"], [1, "entry-content"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "entry", "position-absolute", 2, "cursor", "auto"]],
        template: function CalendarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_Template, 22, 8, "table", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.entryTemplate && ctx.daysOrHours ? 0 : -1);
          }
        },
        dependencies: [FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, NgClass, NgTemplateOutlet, DatePipe],
        styles: ["table[_ngcontent-%COMP%]{border-collapse:collapse!important}table[_ngcontent-%COMP%], th[_ngcontent-%COMP%], td[_ngcontent-%COMP%]{border:1px solid var(--bs-table-border-color)!important;background-clip:padding-box!important}th[_ngcontent-%COMP%], td[_ngcontent-%COMP%]{vertical-align:top;padding:0!important;min-width:35px!important}thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{opacity:1;z-index:102;position:sticky;top:0;background-color:var(--bs-body-bg)!important}thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-width:0!important}th.month[_ngcontent-%COMP%]{overflow:hidden;padding-left:1px!important}.first-cell-width[_ngcontent-%COMP%]{width:250px!important;min-width:200px!important;max-width:250px!important;position:sticky!important;left:-1px!important;z-index:101!important;background-color:var(--bs-body-bg)!important;box-shadow:inset -1px 0 0 0 var(--bs-table-border-color)}.first-cell-width-search[_ngcontent-%COMP%]{position:sticky!important;left:-1px!important;top:-1px!important;z-index:102!important;background-color:var(--bs-body-bg)!important}td.normal-day[_ngcontent-%COMP%], th.normal-day[_ngcontent-%COMP%]{background-color:rgba(var(--bs-body-bg),.08)}td.weekend[_ngcontent-%COMP%], th.weekend[_ngcontent-%COMP%]{background-color:rgba(var(--bs-body-color-rgb),.08)}td.today[_ngcontent-%COMP%], th.today[_ngcontent-%COMP%]{background-color:rgba(var(--bs-primary-rgb),.08)}th.today[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700;color:var(--bs-primary)!important}.th-day[_ngcontent-%COMP%]{display:block;font-size:14px;text-align:center;font-weight:300}.th-date[_ngcontent-%COMP%]{display:block;font-size:12px;text-align:center;font-weight:400}.tr-divider[_ngcontent-%COMP%]{box-shadow:inset 0 3px 0 0 var(--bs-table-border-color)}.tr-hover[_ngcontent-%COMP%]:hover   .row-name[_ngcontent-%COMP%]{font-weight:700!important}.row-img[_ngcontent-%COMP%]{border-radius:50%;border:2px solid var(--bs-secondary-color);width:37px;height:37px;padding:4px 5px 5px;text-align:center}.row-img[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--bs-secondary-color)}.row-badges[_ngcontent-%COMP%]{padding:5px;margin-right:15px;float:right;font-size:18px}.entry-placeholder[_ngcontent-%COMP%]{height:38px;margin-top:4px;margin-bottom:4px}.entry[_ngcontent-%COMP%]{position:relative;height:38px;cursor:pointer;opacity:.7;border-radius:4px;color:#fff;font-size:11px;padding:2px;margin-top:4px;margin-bottom:4px;margin-left:3px;box-shadow:0 0 3px #00000080;transition:width .5s;z-index:auto!important}.entry.overflow-left[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0;box-shadow:-2px 0 currentColor,-1px 0 3px #00000080}.entry.overflow-right[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0;box-shadow:2px 0 currentColor,1px 0 3px #00000080}.entry-content[_ngcontent-%COMP%]{max-height:100%;overflow:hidden;text-overflow:ellipsis}.entry[_ngcontent-%COMP%]:hover{opacity:.88;transition:opacity .1s ease-in}.search-input[_ngcontent-%COMP%]{color:var(--bs-primary);font-weight:700}table.select-mode[_ngcontent-%COMP%]   .entry[_ngcontent-%COMP%]{opacity:.25!important;z-index:-1000!important}table.select-mode[_ngcontent-%COMP%]   td.ui-selectable[_ngcontent-%COMP%]:hover, table.select-mode[_ngcontent-%COMP%]   td.ui-selecting[_ngcontent-%COMP%]{background-color:#51d06199}table.select-mode[_ngcontent-%COMP%]   td.ui-selected[_ngcontent-%COMP%]{background-color:#51d061bf!important}@media only screen and (max-width: 992px){.first-cell-width[_ngcontent-%COMP%]{width:170px!important;max-width:170px!important;min-width:170px!important;min-height:45px!important}.first-cell-width[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{word-wrap:break-word!important}.row-name[_ngcontent-%COMP%]{min-height:38px!important;padding-left:4px!important}}"]
      });
    }
  }
  return CalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FaqService = /*#__PURE__*/(() => {
  class FaqService {
    constructor() {
      this.http = inject(HttpClient);
    }
    getFaq(id) {
      return this.http.get('https://tools.rbb-online.de/tools-service/api/faq/' + id);
    }
    getFaqGroups(projectName) {
      const params = new HttpParams().append('atlassianId', projectName);
      return this.http.get('https://tools.rbb-online.de/tools-service/api/faq-group', {
        params
      });
    }
    static {
      this.ɵfac = function FaqService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FaqService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FaqService,
        factory: FaqService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FaqService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var BrowserMessageType = /*#__PURE__*/function (BrowserMessageType) {
  BrowserMessageType[BrowserMessageType["Info"] = 0] = "Info";
  BrowserMessageType[BrowserMessageType["Warning"] = 1] = "Warning";
  BrowserMessageType[BrowserMessageType["Error"] = 2] = "Error";
  BrowserMessageType[BrowserMessageType["Success"] = 3] = "Success";
  BrowserMessageType[BrowserMessageType["Message"] = 4] = "Message";
  return BrowserMessageType;
}(BrowserMessageType || {});
class BrowserMessage {
  constructor(headline, text, type = BrowserMessageType.Message) {
    this.headline = headline;
    this.text = text;
    this.type = type;
    this.duration = 5000;
    this.time = Date.now();
  }
}
let BrowserMessagesComponent = /*#__PURE__*/(() => {
  class BrowserMessagesComponent {
    constructor() {
      this.BrowserMessageType = BrowserMessageType;
    }
    init(messageEvents) {
      messageEvents?.subscribe(messages => {
        this.messages = messages;
      });
    }
    static {
      this.ɵfac = function BrowserMessagesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BrowserMessagesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BrowserMessagesComponent,
        selectors: [["rbb-browser-messages"]],
        decls: 3,
        vars: 0,
        consts: [[1, "toast-container", 2, "position", "fixed", "bottom", "10px", "right", "10px", "z-index", "1055"], ["data-autohide", "false", 1, "toast"], [1, "toast-header"], [1, "fa-solid", "fa-info-circle", "me-1"], [1, "fa-solid", "fa-exclamation-circle", "text-warning", "me-1"], [1, "fa-solid", "fa-exclamation-circle", "text-danger", "me-1"], [1, "fa-solid", "fa-check-circle", "text-success", "me-1"], [1, "me-auto"], ["type", "button", "data-bs-dismiss", "toast", 1, "btn-close"], [1, "toast-body"]],
        template: function BrowserMessagesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, BrowserMessagesComponent_For_2_Template, 11, 3, "div", 1, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.messages);
          }
        },
        encapsulation: 2
      });
    }
  }
  return BrowserMessagesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RbbTemplateConfig {}
let BrowserMessagesService = /*#__PURE__*/(() => {
  class BrowserMessagesService {
    constructor() {
      this.rbbTemplateConfig = inject(RbbTemplateConfig);
      this.applicationRef = inject(ApplicationRef);
      this.messageEvents = new Subject();
      this.desktopNotificationsPermitted = false;
      this.messages = [];
      if (this.rbbTemplateConfig.desktopNotifications) {
        this.enableDesktopNotification();
      }
      const componentRef = createComponent(BrowserMessagesComponent, {
        environmentInjector: this.applicationRef.injector
      });
      componentRef.instance.init(this.messageEvents);
      this.applicationRef.attachView(componentRef.hostView);
      document.body.appendChild(componentRef.location.nativeElement);
    }
    static visible() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return !(document.hidden || document.msHidden || document.webkitHidden || document.mozHidden);
    }
    enableDesktopNotification() {
      if (!('Notification' in window)) {
        return;
      }
      const ua = navigator.userAgent.toLowerCase();
      if (ua.includes('safari') && ua.includes('applewebkit') && !ua.includes('chrome') && !ua.includes('android')) {
        // noinspection JSIgnoredPromiseFromCall
        Notification.requestPermission(permission => {
          if (permission) {
            this.desktopNotificationsPermitted = true;
          }
        });
      } else {
        Notification.requestPermission().then(permission => {
          if (permission) {
            this.desktopNotificationsPermitted = true;
          }
        });
      }
    }
    addMessage(message) {
      this.messages.push(message);
      this.messageEvents.next(this.messages);
      let notification;
      if (this.desktopNotificationsPermitted && !BrowserMessagesService.visible()) {
        notification = new Notification(message.headline, {
          body: message.text,
          icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAAB3RJTUUH4goECRQUaS+neAAAE35JREFUeNrt3dtvXGe5x/HfOo0Pk/ExiROnSdukbZqmtEALBST2FdpsToVbiorEvuAGuKB/QC/gFon7Xm2pIAESCIpAIFChpailLW3jJMR2Tq3tOE4cHxJ7zuuwL95Z8cSxPWNnPMfvR7Jiz2FlzTPvetbpfZ9XAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO5iTR848F+NXgkADRG5kv7U6LUAUHeWpGlXUk+j1wRAQ0zajV4DAA0RSXqbBAB0poyk90gAQGe6JmmCBAB0pkuSZkkAQGc6IylNAgA6TyRpTJJIAEDnuSXpPxIJAOhEs5I+kkgAQCealLQgkQCATjQmqSiRAIBO40s6LUmH5+ZIAECHWZI0Hv9BAgA6y5SkK/EfJACgs5yTtBz/QQIAOsspSWH8BwkA6Bw5mS7AOjw3J4kEAHSSeUkXyh8gAQCd47KkufIHSABA5zgrabX8ARIA0DlOrX+ABAB0hhWZI4DbFwAlyW30WrWlKJLC0PxrWRs/b1mSbW/8fDsiJo02J3MN4A4kgFqLItkDA+r9xjdkJZObvy4IlP3jH+V/9JFp9O0simQPDqr361/fOiZRpOxf/iJ/crL9Y1J/5yXdWP8gCaDWokj28LBSP/yhnJGRzV+Wz6s4MSH/8uX2b+xRJHtoqGJMFIYKrl6VPz7e/jGpv9OS8usfJMpoLlHU6DVoR4FKFwDLz/8lEgDQCZZVNgKwHAkAaH8zkqY3eoIEALS/cZk6AHchAQDtb0zmOsBdSABAeyuorATYeiQAoL3dkKkCvCESANDePpR0dbMnSQBAe/uPzDiADZEAgPZ2SmYuwA2RAID2lda6EmDrkQCA9nVN0qWtXkACANrXBZk6gJsiAQDt64yk7FYvIAEA7SnUJiMAy5EAgPZ0S2YWoC1REGQzm41Lr2e5qvJ1qHacfPn6tWtpre3GpRNicrcrMvMAbqn9E0AUrTWS8t+ltcYQ16GzbVm2LTnOHfXpLNuWbFtRoaAom93+OmyxblEYygqCtfUq/V9yXVmuK8vzJM+TlUiYxxzHrJ/jmNcHgam1FwSKikVFxaJU+jcqFiXfN8+H4dpnLv9pMtFGMbGs25/Z8jwThzgmnrd5TMLQxKFQaOmY7NCEpMVKL2r9BBBv1OUbt2WtNZKeHlnJpOw9e2SlUrL7+mQPDMgeGJDV1ye7t1dW2Y/d2yt1dZlGFW9wrisrkVD6F7/Q6ksv1aZclWXJ3rtX3mOPyTlwQM7+/XL275c9NCR7eFj24KDsVMqsV0+PrO5u0/hLCcpyHEVxoc24sRcKivJ5RbmcokxG4c2bCpeWFC4uKrh2TcG1awqvX1dw/brCxUWF6bRUKJj3N0lBTmdoSN6JE3JGRkw89u+XMzxs4jI0dFdMyhPAhjEpFjeOydKSicfcnILr1xXMzytcXFS0uqoon2+qmOzQmKRipRe1VgJYX1nWdc1G29cne3hYzsGDcu+7T87Bg7JHRuTs2yd7717Z/f2yk0nTYBIJWa67o43YOXCgZh/F8jz1v/iiLNuWtWeP2Zvtdh28IFCUyym8dUvB/LyCK1fkX7xoahNeuCB/Zkbh0pJJClL9G79tK/XCC0q98IJJ2F1dux+TMDQxWVlROD+vYHZWxYsX5U9MqHjhgoKpKQVLS1I+35iY7ExRJgFseQFQavYEEG/skuR5svv75Rw4IPfIEbkPPST34YflHjkiZ2RE9uCg2ZA8r9FrXR3LkrN/f33/T8eRlUzKSSblHDwoPfGEeTwMFa6umsY/MaHCv/+twgcfyL9wQeHiovke6tTwnX376hsT25bV2yunt1fOyIi8xx9XdxyTdNoUKZ2cVOH991V4/30VJycVLiyY04j4VLH5LGqLEYDlmisBxHt4SVZ3t+yREXkPPSTvscfkPf64vIcflnPwoKy+vsZs6O1asNK2zVFUX5+8Rx9V77PPKkqnVbx0SYW331butddU+OADhfPz5vuJz7XbmW3LTqVkp1LyHnlEPV/9qqJ0Wv6HHyr/7rvKv/aaCu+9p2Burq4JskofyVwErKjxCSA+X3Nd2fv2yXv0USWeekpdn/yk3OPH5Rw4YA4FUT+WJWvPHiWeeEKJJ55Q8vnn5V+4oNxf/6rsn/+s4tmz5mJoJySC8rAkk/JOnpR38qSS3/ym/MuXlXv1VeX+9CcVxsYUpdPNEpNzkm5W88LGJIB4T++6cu67T4mnnlL35z+vxNNPy73/flm9vQ1ZLWzM6upaa/jf/rbyb7yh1ZdfVv6f/1y7kt5hrERC3vHj8o4fV/Jb31L+zTeV/vnPlXv1VXMXorG2HAFYrr4JoNRY7OFhJZ5+Wj3//d/q+tzn5Bw+3Drn7h3OHhxUz9e+psRTT+nG88+reOZMx0/iYff1qeeLX1TXpz6lhe98R/k332zkkUBWFUYAlqtPAijdUnGPHVPPV76ini9/Wd6JE+aqfKtp1+sA2+SMjqr7C19Q8fTpRq9K07CHhtT9pS8p/69/NXI1rku6WO2Ldz8BRJHcY8eUfO459Tz7rNzDh5vpYgnuQddnP6vVl14y1wP4TiVJXZ/+tOyBAYXLy42KySWZiUCrsvsJwLaV+v73lXzuuUYEY2tBoMj3Jd+/u8dY/HvpeUWRmchzN7/UILjd2zDKZBRmMooyGUXptHksn7+9XooiRZIsyzJ9GzxPVleXrGRSVk+PuY+eTJpOM93dpp9Bjdfde/hhOSMjZn7D3YpLHJNcTlE6fXdMSp2ftoxJ3MkrmTS3int6zM8uxMR94AE5991nbp825jTgjKRM1eu766tjWfW/qBd37kinFd28qXB52fT8WlhQuLBw++/w5k1Fq6vmdZmMolxuwy6jUXynolis3fluFJkOOOfPy5+dVTAzo2BuzvTQW15WuLJi9qyFgtnog2BtPcqWUd6F1Yq7EJcng1TK9KTbv1/uoUNyjhwxnaUOHTKdpJLJHX8me3hYzpEj8i9d2tH7N4zJ+fPyJycVzM7Kn542vfVK31m0sqJwo5is7+5dTUyGhmSPjMgdHTUxOXxYzuioicmePTuPSX+/3AcfVPHUqdrEZJsRVBUjAMs1/jbgvXzaYlFR3KttdlbB9LRpNFeumIZz44bp+pnJSPm82ajXNxhpbS9QadBIDfcWke/r1k9+ouwf/nB3v/T432oGsZR9ligIzMax7rniuj71Vk+P7IEB03PyoYeUOHlS3sc+JvfoUTnDw5JbXbOwurvlPvCA8rW6LhKGWvnpT5X57W/rH5Pu7jti4p08qUQpJvbevab3aDUcR+6DDzbq8H9Fpgho1VonAfi+gsVF03310iUVx8flT07Kn5pSMD+vaGVlrQ/3ur2ApDsH/jSJKJczRxk77Jq8oSo2kCiTUZBOK5iZUeHtt5WJewiOjso7cUJdn/mMup55Rt6jj1Y8jHVGR2vX2KPIfIeNiEk2qyCTUXDligrvvLPWa/LgQROTZ55R1zPPyD1xomIycA8dalQ7m5UpA1615k0Avq9gfl7++fMqnD5tuqZOTJg9++rq7XO+OwZsxKPGWkWjLpxtMOotSqdNQh0fV/aVV+QePaq9P/uZ3KNHt1yUOzpqNtZWvzuyWUzOn5c/MaHs738v9/77Nfzyy/IeeWTLRTkHD8pKJMwRZ32dl7SwnTc0VQKIsln5ly+r8M47yr/1lgpjYwpmZxVlMnd2t2y1Db0VxHG1bSmKFJRGyVVKAPbQkCzXbURjr39Mrl1TeO2aVCEB2IODUiJhBlXVN8mPyUwFVrWmSQD+1JRuvvii8u++uzbYomycfjMdurc9y1JUKJjvodJLUynJ8xrR2Osfk2JRQTUxSSbNEUB91zBQlSMAyzXNVhXOzyv3+utmwIm0dg7Yzo2qmQWBuZddgR0PZe4EQWCGS1cQ33qt82nRosw04NvSNAlAkinswAbfHMKwusbe09M5g7WqjUl3dyN6uU5Lmtnum5oqAaCJRJG52FpJXIqr1S8CVhmTaGWl8uvKy5PVz7ik5e2+iQSAjUWRoioSgOU4HXV9ppqkaNl29f0GaueUTCnwbemcbw7bFuVylV9k2yYJdIgom618tBMXlq3fUVFe2xgBeMeq1msN0XqiuK/FVlzX3AXoEFXFJL5zVT/zMn0Ato0EgM1VUdjCKpUv74hrAJKJSaXPGobmNnb9XJZ0dSdvJAFgc9XsxeI++51y96bamPh+PWNyVlIVV2w3+Dj1WkO0Hst1KzbiKAjMgJsOUVVM4hGk9bPjoYckAGyqqnvZpVmJOoXV3V35KKC+MVlVaQTgdi8ASiQAbKGqBBAXVekQVcXE9+t5VDQnUwVoR0gA2FipNHglUTZrZs3phGsA1cYkl5NyuXrF5LykGzt9MwkAGytNFlJJmMmYMfydwLJk9/dXfFmYyZiKRfVxRlIVHTY2RgLAxmxb9sBAxZdF6XR7DgXeiG1XlQCidLpeCSDUNkuA3fWR6rGWaCFRZC5g2bYZ115BuLxsGns7nwLEMZGpf1AxJktLJinufkyWZWYB2rGmqQfQkUq30KzNypftlvICmvGPZZkJWPv65Bw6pMQnPiHv+PHKH2Furrb3vMOw+WKSSpmYPPmkvMceqxyTa9dMxardTwAzMqMAd4wE0CCWZSnx8Y8rvHXLlLuOKxOXSlxHvm/2OhsVMd3+f7bWPdVxZCUSspJJ07D37ZNz6JDcBx80sy0fPSr38GFzqFtFp5fbk2PWYjyAbct78kl13bhhYrG6qjCbXavWvNsxKU017+zbJ2d09O6YDAxUF5OrV+s1ieqEpMrjk7dAAmgU11XqhReU+t73TM37bNYkgdVVUxJ8ddUkh5WV2yXC4/kColzOHGLGnXCCYK26bdygu7rW6t8nk2b234EB8zM0ZH76+2WnUrJ6enbWdz0IFExN1a4bsG0r9YMfKPXd75o5EDKZtZisrq7F4tYt83cmsxaXbHZ7MentNZ+/2WOytTFJ93QPlgTQQJbrmpr1yaQkqer9RdkeMCrfE1rWnYfOuzwgJVxdlf/hhzU91L0jJkNDxGRzBe2gBNh6JIBWVNaIG3npLZidlX/lSnPUA+i8mCxImrzXhTTBN4dWVTx92kyB1c53ALapeOZMvWLyoXY4ArAcCQA7Evm+cn//u7naDUmlmPztb/WKyTlJt+51IZwCYNuibFaZ3/3ONPZmOPxvAlE2q8wrr9QzJqeke688TgJAdaJI4dKS8m++qfSvfqX8668zLbikcHFR+bfeUuaXv1SufjHJaIclwNYjAWBzQaBgYUHF8XHl//EP5V9/XcXxcdPIO3XOhiBQsLgof3xcuTfeUP6111Q8d67eMbkm6WItFtQ8CWCDudlakmUpvHlTmV//Wu6xY2Zq7oEBMy99MmnuRXte833WIFCYTitcWJA/NaXi+LiKp06pePas/OnptQrBOyl5HcfkN7+Rd+yY7PKY9PY2b0zC8I6Y+OfOqTA2ZmIyNXVvMbk3FyVdr8WCdj8BRJH8ixdVeO+9zYsk2LbJou1QWMKyFC4s6OaPf2zuaXd3y+7tlbVnj+mMMzgoe3hYzt69puPJ4KDpiNLfLyuVMhtEabINq6vLLKPUwKx4irRqN5RSua4oCExPukJBUS6ncHVV4fKywoUFMwfgzIz8mRkF09MK5uZMX/b18zHeSwOPY/KjH8nyPPO5entlpVKm483goOyhIROTUnJYHxO7u1vq7jY99jzvzphsZ+cRxyQMTUzyeROTdFrR8rKCspgEMzNmuvmrV01Mstnb4yQaPD/lGUnZWizImj5wYNe7LFldXZXnnA8C0w223YpLbtTHPBZv0I5jNgzPk+INv6dHdk+PKUBRmmnG6u42yaG0AViOYzrNOI5p0KVKNFEQSIWC6R2Xy6018FJ34zCdNs+Vuh1vOKX6bu6NtxOTROLumMQJsiwm8jwTjzgmpQk9o1LX4U1jUupRGGYyJunl86ZHYb1jso3oSfpfSf93r+f/Up1OAaJ83hRIqKQ5Alxb1QxmKW20UbaU1Ms3kNi9Jsby9Vj/e733ZNXGxPc3j0ktdhTNFJPq3dQ9jgAsV79rAO24cddavUa+tYryOBCT2Kykj2q1MG7iAq1lQqYbcE2QAIDWclpSzboakgCA1uGrBiMAy5EAgNaxKHMKUDMkAKB1TEm6UssFkgCA1vEfmduANUMCAFrHmEwp8JohAQCtIacajQAsRwIAWsN1SRdqvVASANAaLslMBFpTJACgNZyVlK71QkkAQGs4tRsLJQEAzW9F5hZgTS8ASiQAoBXMSrq8GwsmAQDN77xqOAKwHAkAaH6nJeV3Y8EkAKC5BarxCMByJACguS1JGt+thZMAgOY2I2l6txZOAgCa2zlJy7u1cBIA0NzGZK4D7ApXNZpgAEDN5VXqAbgbFwAlkwD+p9GfEsBdLJXVAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADq6P8Bk4O2fGgd+GcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTAtMDRUMDk6MjA6MjArMDI6MDBFuXLRAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEwLTA0VDA5OjIwOjIwKzAyOjAwNOTKbQAAAFd6VFh0UmF3IHByb2ZpbGUgdHlwZSBpcHRjAAB4nOPyDAhxVigoyk/LzEnlUgADIwsuYwsTIxNLkxQDEyBEgDTDZAMjs1Qgy9jUyMTMxBzEB8uASKBKLgDqFxF08kI1lQAAAABJRU5ErkJggg==',
          dir: 'auto'
        });
      }
      setTimeout(() => {
        this.messages.shift();
        this.messageEvents.next(this.messages);
        if (notification) {
          notification.close();
        }
      }, this.rbbTemplateConfig.showDuration ? this.rbbTemplateConfig.showDuration : 5000);
    }
    // noinspection JSUnusedGlobalSymbols
    getMessages() {
      return this.messages;
    }
    showHttpError(error, headline) {
      if (!headline) {
        headline = 'Verbindung zum Server fehlgeschlagen';
      }
      let text = '';
      const errorMessage = error.error;
      if (errorMessage?.localizedDescription) {
        text = errorMessage.localizedDescription;
      }
      if (!text && errorMessage?.localizedErrorMessage) {
        text = errorMessage.localizedErrorMessage;
      }
      if (!text && errorMessage?.errorMessage) {
        text = errorMessage.errorMessage;
      }
      if (text) {
        text += ' (Fehlercode: ' + error.status + ')';
      } else {
        text = 'Fehlercode: ' + error.status;
      }
      this.addMessage(new BrowserMessage(headline, text, BrowserMessageType.Error));
    }
    static {
      this.ɵfac = function BrowserMessagesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BrowserMessagesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BrowserMessagesService,
        factory: BrowserMessagesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BrowserMessagesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ObjectSearchPipe = /*#__PURE__*/(() => {
  class ObjectSearchPipe {
    transform(values, configs, search) {
      if (search.length > 1) {
        const applicableConfigs = [];
        for (const config of configs) {
          if (config.type && (search.length > 1 || (config.type === 'number' || config.type === 'short-string') && search)) {
            applicableConfigs.push(config);
          }
        }
        if (applicableConfigs.length) {
          return values.filter(value => {
            for (const config of applicableConfigs) {
              const field = config.field;
              if (!field) {
                continue;
              }
              const fieldValue = get(value, field);
              if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
                continue;
              }
              switch (config.type) {
                case 'string':
                case 'short-string':
                  if (fieldValue.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                  }
                  break;
                case 'Date':
                  if (ObjectSearchPipe.checkDate(fieldValue, search)) {
                    return true;
                  }
                  break;
                case 'string[]':
                  {
                    const arr = Array.isArray(fieldValue) ? Array.from(fieldValue) : Array.of(fieldValue);
                    for (const a of arr) {
                      if (a.toLowerCase().includes(search.toLowerCase())) {
                        return true;
                      }
                    }
                    break;
                  }
                case 'boolean':
                  {
                    const searchInput = search.toLowerCase();
                    const searchValue = searchInput === 'ja' || searchInput === 'yes' || searchInput === 'true' ? 'true' : 'false';
                    if (String(fieldValue).toLowerCase() === searchValue) {
                      return true;
                    }
                    break;
                  }
                default:
                  if (String(fieldValue).toLowerCase() === search.toLowerCase()) {
                    return true;
                  }
              }
            }
            return false;
          });
        }
      }
      return values;
    }
    static checkDate(date, searchInput) {
      if (typeof date === 'string') {
        try {
          date = new Date(date);
        } catch {
          return false;
        }
      }
      const format1 = date.getFullYear() + '-' + (date.getMonth() + 1).toLocaleString(undefined, {
        minimumIntegerDigits: 2
      }) + '-' + date.getDate().toLocaleString(undefined, {
        minimumIntegerDigits: 2
      });
      const format2 = date.getDate().toLocaleString(undefined, {
        minimumIntegerDigits: 2
      }) + '.' + (date.getMonth() + 1).toLocaleString(undefined, {
        minimumIntegerDigits: 2
      }) + '.' + date.getFullYear();
      const format3 = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
      return format1.includes(searchInput) || format2.includes(searchInput) || format3.includes(searchInput);
    }
    static {
      this.ɵfac = function ObjectSearchPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ObjectSearchPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rbbObjectSearch",
        type: ObjectSearchPipe,
        pure: true
      });
    }
  }
  return ObjectSearchPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoaderComponent = /*#__PURE__*/(() => {
  class LoaderComponent {
    constructor() {
      this.active = input(true);
      this.size = input('');
    }
    static {
      this.ɵfac = function LoaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoaderComponent,
        selectors: [["rbb-loader"]],
        inputs: {
          active: [1, "active"],
          size: [1, "size"]
        },
        decls: 6,
        vars: 5,
        consts: [[1, "loader", 3, "ngClass"]],
        template: function LoaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div")(2, "div")(3, "div")(4, "div")(5, "div");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(1, _c6, ctx.active(), ctx.size() === "sm", ctx.size() === "lg"));
          }
        },
        dependencies: [NgClass],
        encapsulation: 2
      });
    }
  }
  return LoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideMenuHeadlineComponent = /*#__PURE__*/(() => {
  class SideMenuHeadlineComponent {
    constructor() {
      this.icon = input.required();
      this.iconColor = input();
      this.headline = input.required();
      this.description = input();
      this.faqLink = input();
    }
    static {
      this.ɵfac = function SideMenuHeadlineComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SideMenuHeadlineComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SideMenuHeadlineComponent,
        selectors: [["rbb-side-menu-headline"]],
        inputs: {
          icon: [1, "icon"],
          iconColor: [1, "iconColor"],
          headline: [1, "headline"],
          description: [1, "description"],
          faqLink: [1, "faqLink"]
        },
        decls: 9,
        vars: 12,
        consts: [[1, "row", "pb-2"], [1, "col-auto", "ps-4", "pe-1", "headline-logo"], [1, "col"], [1, "mb-0", "h3", 3, "ngClass"], [1, "text-secondary"], [1, "col-auto", "pt-3"], [1, "p-0", "m-0", "mb-3"], ["target", "_blank", 1, "btn", "btn-secondary", 3, "href"], [1, "fa-solid", "fa-question", "pe-1"]],
        template: function SideMenuHeadlineComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "i");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "h1", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, SideMenuHeadlineComponent_Conditional_6_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, SideMenuHeadlineComponent_Conditional_7_Template, 4, 1, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "hr", 6);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("color", ctx.iconColor());
            i0.ɵɵclassProp("text-secondary", !ctx.iconColor());
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.icon());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7, !ctx.description()));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.headline());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.description() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.faqLink() ? 7 : -1);
          }
        },
        dependencies: [NgClass],
        styles: ["@media (min-width: 768px){.headline-logo[_ngcontent-%COMP%]{margin-top:-5px;font-size:48px}}@media (max-width: 767px){.headline-logo[_ngcontent-%COMP%]{font-size:30px}}"]
      });
    }
  }
  return SideMenuHeadlineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FaqComponent = /*#__PURE__*/(() => {
  class FaqComponent {
    constructor() {
      this.route = inject(ActivatedRoute);
      this.faqService = inject(FaqService);
      this.browserMessageService = inject(BrowserMessagesService);
      this.search = '';
      this.searchConfig = [{
        field: 'questions',
        type: 'string'
      }, {
        field: 'answer',
        type: 'string'
      }];
      this.searchFlatMap = faqGroup => faqGroup.faqList ?? [];
      this.loading = false;
    }
    ngOnInit() {
      this.getFaqGroups();
      this.route.data.subscribe(data => {
        this.projectName = data['projectName'];
        this.getFaqGroups();
      });
      this.initFaqId = this.route.snapshot.queryParamMap.get('faqId');
    }
    ngAfterViewChecked() {
      if (this.initFaqId) {
        const heading = document.getElementById('heading' + this.initFaqId);
        if (heading) {
          heading?.querySelector('button')?.classList.remove('collapsed');
          document.getElementById('collapse' + this.initFaqId)?.classList.add('show');
          const diff = (document.querySelector('.navbar')?.getBoundingClientRect().height ?? 0) + 10;
          window.scrollTo({
            top: heading.getBoundingClientRect().top - heading.getBoundingClientRect().height - diff,
            behavior: 'smooth'
          });
        }
      }
    }
    getFaqGroups() {
      if (this.projectName) {
        this.loading = true;
        this.faqService.getFaqGroups(this.projectName).subscribe({
          next: data => {
            this.faqGroups = data;
            this.loading = false;
          },
          error: err => {
            this.loading = false;
            this.browserMessageService.showHttpError(err, 'FAQs konnten nicht geladen werden.');
          }
        });
      }
    }
    static {
      this.ɵfac = function FaqComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FaqComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FaqComponent,
        selectors: [["rbb-faq"]],
        inputs: {
          projectName: "projectName"
        },
        decls: 6,
        vars: 3,
        consts: [[1, "container", "pt-3"], ["headline", "FAQ", "icon", "fa-solid fa-question"], ["placeholder", "Suche", 1, "form-control", "form-control-sm", 3, "ngModelChange", "ngModel"], [1, "m-5", "text-center"], [1, "my-4", "text-primary"], ["id", "accordionSearch", 1, "accordion"], [1, "accordion-item"], [1, "accordion-header", 3, "id"], ["type", "button", "data-bs-toggle", "collapse", 1, "accordion-button", "collapsed"], ["data-bs-parent", "#accordionSearch", 1, "accordion-collapse", "collapse", 3, "id"], [1, "accordion-body", 3, "innerHtml"], [1, "m-5", "text-secondary", "text-center"], [1, "accordion", 3, "id"], [1, "accordion-collapse", "collapse", 3, "id"]],
        template: function FaqComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "rbb-side-menu-headline", 1);
            i0.ɵɵelementStart(2, "input", 2);
            i0.ɵɵtwoWayListener("ngModelChange", function FaqComponent_Template_input_ngModelChange_2_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.search, $event) || (ctx.search = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, FaqComponent_Conditional_3_Template, 8, 6)(4, FaqComponent_Conditional_4_Template, 2, 0, "div", 3)(5, FaqComponent_Conditional_5_Template, 2, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.search);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.search.length > 1 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 4 : 5);
          }
        },
        dependencies: [SideMenuHeadlineComponent, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, LoaderComponent, ObjectSearchPipe],
        styles: ["rbb-faq img{max-width:600px}\n"],
        encapsulation: 2
      });
    }
  }
  return FaqComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSelectSearchPipe = /*#__PURE__*/(() => {
  class MultiSelectSearchPipe {
    transform(values, selectedValues, searchQuery, searchFields) {
      return values.filter(value => {
        if (selectedValues) {
          for (const selectedValue of selectedValues) {
            if (lodash.isEqual(value, selectedValue)) {
              return false;
            }
          }
        }
        if (!searchQuery) {
          return true;
        }
        const words = searchQuery.split(/[, ]/).filter(s => s).map(s => s.toLowerCase());
        if (searchFields) {
          for (const word of words) {
            let found = false;
            for (const searchField of searchFields) {
              if (searchField === 'this') {
                if (String(value).toLowerCase().includes(word)) {
                  found = true;
                  break;
                }
              } else {
                if (String(lodash.get(value, searchField)).toLowerCase().includes(word)) {
                  found = true;
                  break;
                }
              }
            }
            if (!found) {
              return false;
            }
          }
        }
        return true;
      });
    }
    static {
      this.ɵfac = function MultiSelectSearchPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiSelectSearchPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "multiSelectSearch",
        type: MultiSelectSearchPipe,
        pure: true
      });
    }
  }
  return MultiSelectSearchPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Autocomplete {
  refreshScroll(autocompleteList, element) {
    if (element && autocompleteList) {
      const boundingRectParent = autocompleteList.nativeElement.getBoundingClientRect();
      const boundingRectChild = element.nativeElement.getBoundingClientRect();
      const topOffset = boundingRectParent.top - boundingRectChild.top;
      const bottomOffset = boundingRectChild.bottom - boundingRectParent.bottom;
      if (topOffset > 0) {
        autocompleteList.nativeElement.scrollTop -= topOffset;
      }
      if (bottomOffset > 0) {
        autocompleteList.nativeElement.scrollTop += bottomOffset;
      }
    }
  }
}
let MultiSelectComponent = /*#__PURE__*/(() => {
  class MultiSelectComponent extends Autocomplete {
    constructor() {
      super();
      this.initSearch = input('');
      this.values = [];
      this.valuesFunction = input();
      this.valuesFunctionOptions = input();
      this.itemTemplate = input.required();
      this.searchFields = input(['this']);
      this.max = input(0);
      this.size = input('md');
      this.loadValuesFunction = input();
      this.loadValuesFunctionOptions = input();
      this.autoSelectFunction = input();
      this.ariaLabel = input('');
      this.autofocus = input(false);
      this.searchInput = viewChild('searchInput');
      this.searchInputFocused = false;
      this.initSearchProcessed = '';
      this.autocompleteHovered = false;
      this.inputGroupHovered = false;
      this.searchQuery = '';
      this.searchValues = [];
      this.searchValueSelectIndex = 0;
      this.autocompleteList = viewChild('autocompleteList');
      this.autocompleteItems = viewChildren('autocompleteItems');
      this.loading = false;
      this.selectedValues = [];
      // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
      this.selectedValuesChanged = _ => {};
      this.computed = computed;
      this.uuid = uuid();
    }
    ngOnInit() {
      this.processInitSearch();
    }
    ngOnChanges() {
      this.processInitSearch();
    }
    processInitSearch() {
      const initSearch = this.initSearch();
      if (initSearch !== this.initSearchProcessed) {
        if (initSearch) {
          this.searchQuery = initSearch;
          this.loadValues();
          this.searchInputFocused = true;
        } else {
          this.searchInput()?.nativeElement.blur();
        }
        this.initSearchProcessed = initSearch;
      } else {
        this.searchInput()?.nativeElement.blur();
      }
    }
    loadValues() {
      if (this.loadValuesFunction()) {
        this.values = [];
        const words = this.searchQuery.split(/[, ]/g).filter(s => s.length > 2);
        if (!this.searchQuery || words.length === 0) {
          this.loading = false;
          return;
        }
        this.loading = true;
        const searchId = uuid();
        this.lastSearchId = searchId;
        setTimeout(() => {
          if (this.lastSearchId === searchId) {
            this.loadValuesFunction()?.(this.searchQuery, this.loadValuesFunctionOptions()).subscribe({
              next: value => {
                if (this.lastSearchId === searchId) {
                  this.values = value;
                  this.loading = false;
                  const autoSelectFunction = this.autoSelectFunction();
                  if (autoSelectFunction) {
                    const v = autoSelectFunction(this.searchQuery, this.values);
                    if (v) {
                      let b = true;
                      for (const selectedValue of this.selectedValues ?? []) {
                        if (isEqual(v, selectedValue)) {
                          b = false;
                          break;
                        }
                      }
                      if (b) {
                        this.selectValue(v);
                      }
                    }
                  }
                }
              },
              error: () => {
                if (this.lastSearchId === searchId) {
                  this.values = [];
                  this.loading = false;
                }
              }
            });
          }
        }, 500);
      }
    }
    selectValue(value) {
      const max = this.max();
      if (max && this.selectedValues && this.selectedValues.length >= max) {
        return;
      }
      this.searchValueSelectIndex = 0;
      if (this.selectedValues) {
        this.selectedValues.push(value);
      } else {
        this.selectedValues = [value];
      }
      this.selectedValues = clone(this.selectedValues);
      this.searchQuery = '';
      this.searchInput()?.nativeElement.focus();
      this.selectedValuesChanged(this.selectedValues);
      this.refreshScroll(this.autocompleteList(), this.autocompleteItems()[this.searchValueSelectIndex]);
    }
    removeValueWithEvent(event, index) {
      this.removeValue(index);
      event.stopImmediatePropagation();
    }
    removeValue(index) {
      this.searchValueSelectIndex = 0;
      this.selectedValues.splice(index, 1);
      this.selectedValues = clone(this.selectedValues);
      this.searchInput()?.nativeElement.focus();
      this.selectedValuesChanged(this.selectedValues);
      this.refreshScroll(this.autocompleteList(), this.autocompleteItems()[this.searchValueSelectIndex]);
    }
    inputKeyDown(event) {
      if (event.key === 'Backspace' && this.searchQuery === '') {
        if (this.selectedValues?.length) {
          this.removeValue(this.selectedValues.length - 1);
        }
      }
      const autocompleteList = this.autocompleteList();
      const autocompleteItems = this.autocompleteItems();
      if (event.key === 'ArrowDown') {
        this.searchValueSelectIndex++;
        if (this.searchValueSelectIndex >= this.searchValues.length) {
          this.searchValueSelectIndex = 0;
        }
        event.stopImmediatePropagation();
        this.refreshScroll(autocompleteList, autocompleteItems[this.searchValueSelectIndex]);
      }
      if (event.key === 'ArrowUp') {
        this.searchValueSelectIndex--;
        if (this.searchValueSelectIndex < 0) {
          this.searchValueSelectIndex = this.searchValues.length - 1;
        }
        event.stopImmediatePropagation();
        this.refreshScroll(autocompleteList, autocompleteItems[this.searchValueSelectIndex]);
      }
      if (event.key === 'Enter' && this.searchValueSelectIndex >= 0 && this.searchValueSelectIndex < this.searchValues.length) {
        this.selectValue(this.searchValues[this.searchValueSelectIndex]);
      }
    }
    prepareSearchList(values) {
      this.searchValues = values;
      return values;
    }
    registerOnChange(fn) {
      this.selectedValuesChanged = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.selectedValues = obj;
    }
    static {
      this.ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiSelectComponent,
        selectors: [["rbb-multi-select"]],
        viewQuery: function MultiSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.searchInput, _c9, 5);
            i0.ɵɵviewQuerySignal(ctx.autocompleteList, _c10, 5);
            i0.ɵɵviewQuerySignal(ctx.autocompleteItems, _c11, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(3);
          }
        },
        hostBindings: function MultiSelectComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function MultiSelectComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          initSearch: [1, "initSearch"],
          values: "values",
          valuesFunction: [1, "valuesFunction"],
          valuesFunctionOptions: [1, "valuesFunctionOptions"],
          itemTemplate: [1, "itemTemplate"],
          prependIcon: "prependIcon",
          searchFields: [1, "searchFields"],
          max: [1, "max"],
          size: [1, "size"],
          loadValuesFunction: [1, "loadValuesFunction"],
          loadValuesFunctionOptions: [1, "loadValuesFunctionOptions"],
          autoSelectFunction: [1, "autoSelectFunction"],
          ariaLabel: [1, "ariaLabel"],
          autofocus: [1, "autofocus"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => MultiSelectComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 19,
        vars: 26,
        consts: [["searchInput", ""], ["autocompleteList", ""], ["autocompleteItems", ""], [1, "rbb-multi-select"], [1, "input-group", "pointer", 3, "click", "mouseover", "mouseenter", "mouseout", "mouseleave", "ngClass"], [1, "input-group-text", 3, "for"], [1, "form-control", "py-1", 2, "height", "auto !important"], [1, "d-inline-block", "rounded", "px-1", "me-1", "my-1", 3, "ngClass"], ["autocomplete", "off", "role", "combobox", "aria-autocomplete", "list", 1, "border-0", "my-1", 3, "ngModelChange", "keydown", "focusin", "focusout", "id", "name", "ngModel", "ngClass"], ["role", "listbox", 1, "autocomplete", "border", "shadow", 3, "mouseover", "mouseenter", "mouseout", "mouseleave", "hidden", "id"], [3, "hidden"], ["role", "option", 1, "autocomplete-item", "p-1", "px-2", 3, "id", "ngClass"], ["role", "note", 1, "p-1", "px-2", "text-secondary", "small", 3, "hidden"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-label", "Eintrag entfernen", "tabindex", "0", 1, "d-inline-block", 3, "click", "keydown.space", "keydown.enter"], [1, "fa-solid", "fa-times", "text-midgray"], [1, "d-flex", "justify-content-center", "p-1", "px-2"], ["role", "option", 1, "autocomplete-item", "p-1", "px-2", 3, "click", "mouseover", "mouseenter", "id", "ngClass"]],
        template: function MultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
            i0.ɵɵlistener("click", function MultiSelectComponent_Template_div_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              const searchInput_r2 = i0.ɵɵreference(7);
              return i0.ɵɵresetView(searchInput_r2 == null ? null : searchInput_r2.focus());
            })("mouseover", function MultiSelectComponent_Template_div_mouseover_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputGroupHovered = ctx.searchInputFocused);
            })("mouseenter", function MultiSelectComponent_Template_div_mouseenter_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputGroupHovered = ctx.searchInputFocused);
            })("mouseout", function MultiSelectComponent_Template_div_mouseout_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputGroupHovered = false);
            })("mouseleave", function MultiSelectComponent_Template_div_mouseleave_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputGroupHovered = false);
            });
            i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_2_Template, 2, 3, "label", 5);
            i0.ɵɵelementStart(3, "div", 6);
            i0.ɵɵrepeaterCreate(4, MultiSelectComponent_For_5_Template, 5, 7, "div", 7, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(6, "input", 8, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function MultiSelectComponent_Template_input_ngModelChange_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.searchQuery, $event) || (ctx.searchQuery = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function MultiSelectComponent_Template_input_ngModelChange_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.loadValues());
            })("keydown", function MultiSelectComponent_Template_input_keydown_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputKeyDown($event));
            })("focusin", function MultiSelectComponent_Template_input_focusin_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchInputFocused = true);
            })("focusout", function MultiSelectComponent_Template_input_focusout_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchInputFocused = false);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "div", 9, 1);
            i0.ɵɵlistener("mouseover", function MultiSelectComponent_Template_div_mouseover_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.autocompleteHovered = true);
            })("mouseenter", function MultiSelectComponent_Template_div_mouseenter_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.autocompleteHovered = true);
            })("mouseout", function MultiSelectComponent_Template_div_mouseout_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.autocompleteHovered = false);
            })("mouseleave", function MultiSelectComponent_Template_div_mouseleave_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.autocompleteHovered = false);
            });
            i0.ɵɵtemplate(10, MultiSelectComponent_Conditional_10_Template, 3, 0, "div");
            i0.ɵɵelementStart(11, "div", 10);
            i0.ɵɵrepeaterCreate(12, MultiSelectComponent_For_13_Template, 3, 9, "span", 11, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵpipe(14, "multiSelectSearch");
            i0.ɵɵelementStart(15, "span", 12);
            i0.ɵɵtext(16, "Die Suchliste ist leer.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "span", 12);
            i0.ɵɵtext(18, "Bitte gib einen Suchbegriff mit mindestens 3 Zeichen ein.");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            let tmp_17_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c12, ctx.size() === "sm", ctx.size() === "lg"));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.prependIcon ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.selectedValues);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.uuid)("name", ctx.uuid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.searchQuery);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c13, ctx.max() && ctx.selectedValues && ctx.selectedValues.length >= ctx.max()));
            i0.ɵɵattribute("aria-label", ctx.ariaLabel())("aria-controls", ctx.uuid + "-autocomplete")("aria-expanded", !ctx.max() || !ctx.selectedValues || ctx.selectedValues.length < ctx.max() || !(ctx.searchInputFocused || ctx.autocompleteHovered || ctx.inputGroupHovered || ctx.loading))("aria-activedescendant", ctx.uuid + "-autocomplete-" + ctx.searchValueSelectIndex);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !(!ctx.max() || !ctx.selectedValues || ctx.selectedValues.length < ctx.max()) || !(ctx.searchInputFocused || ctx.autocompleteHovered || ctx.inputGroupHovered || ctx.loading))("id", ctx.uuid + "-autocomplete");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.loading ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.prepareSearchList(i0.ɵɵpipeBind4(14, 16, (tmp_17_0 = (tmp_17_0 = ctx.valuesFunction()) == null ? null : tmp_17_0(ctx.valuesFunctionOptions())) !== null && tmp_17_0 !== undefined ? tmp_17_0 : ctx.values, ctx.selectedValues, ctx.loadValuesFunction() ? "" : ctx.searchQuery, ctx.searchFields())));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hidden", ctx.searchValues.length || !ctx.loadValuesFunction() || !ctx.searchQuery || ctx.searchQuery.length < 3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.searchValues.length || !ctx.loadValuesFunction() || ctx.searchQuery && ctx.searchQuery.length >= 3);
          }
        },
        dependencies: [NgClass, NgTemplateOutlet, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, LoaderComponent, MultiSelectSearchPipe],
        styles: [".autocomplete-item[_ngcontent-%COMP%]{display:block;cursor:pointer}.autocomplete-item.hover[_ngcontent-%COMP%]{background-color:var(--bs-gray-100)}[data-bs-theme=\"dark\"][_nghost-%COMP%]   .autocomplete-item.hover[_ngcontent-%COMP%], [data-bs-theme=\"dark\"]   [_nghost-%COMP%]   .autocomplete-item.hover[_ngcontent-%COMP%]{background-color:var(--bs-gray-800)}.autocomplete[_ngcontent-%COMP%]{max-height:160px;width:100%;overflow-y:scroll;position:absolute;z-index:1000;background-color:var(--bs-body-bg)}.rbb-multi-select[_ngcontent-%COMP%]{position:relative}input[_ngcontent-%COMP%]{background-color:transparent}input[_ngcontent-%COMP%]:focus{outline:rgb(88,88,86) dotted 1px!important}"]
      });
    }
  }
  return MultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GroupService = /*#__PURE__*/(() => {
  class GroupService {
    constructor() {
      this.http = inject(HttpClient);
    }
    searchAdGroup(search, exchange = false) {
      const params = new HttpParams().append('q', search).append('exc', exchange.toString());
      return this.http.get('https://tools.rbb-online.de/user-service/api/groups/search', {
        params
      });
    }
    static {
      this.ɵfac = function GroupService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GroupService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GroupService,
        factory: GroupService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GroupService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GroupPickerComponent = /*#__PURE__*/(() => {
  class GroupPickerComponent {
    constructor() {
      this.groupService = inject(GroupService);
      this.initSearch = input('');
      this.max = input(0);
      this.size = input('md');
      this.autofocus = input(false);
      this.exchange = input(false);
      this.selectedValues = [];
      // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
      this.selectedValuesChanged = _ => {};
      this.loadValuesFunction = search => this.groupService.searchAdGroup(search, this.exchange());
    }
    registerOnChange(fn) {
      this.selectedValuesChanged = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.selectedValues = obj;
    }
    static {
      this.ɵfac = function GroupPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GroupPickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GroupPickerComponent,
        selectors: [["rbb-group-picker"]],
        hostBindings: function GroupPickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function GroupPickerComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          initSearch: [1, "initSearch"],
          max: [1, "max"],
          size: [1, "size"],
          autofocus: [1, "autofocus"],
          exchange: [1, "exchange"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: GroupPickerComponent,
          multi: true
        }])],
        decls: 3,
        vars: 9,
        consts: [["itemTemplate", ""], ["prependIcon", "fa-solid fa-users", "ariaLabel", "Mehrfachauswahl f\xFCr Gruppen", 3, "ngModelChange", "itemTemplate", "loadValuesFunction", "searchFields", "max", "size", "initSearch", "autofocus", "ngModel"]],
        template: function GroupPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "rbb-multi-select", 1);
            i0.ɵɵlistener("ngModelChange", function GroupPickerComponent_Template_rbb_multi_select_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectedValuesChanged($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(1, GroupPickerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const itemTemplate_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("itemTemplate", itemTemplate_r3)("loadValuesFunction", ctx.loadValuesFunction)("searchFields", i0.ɵɵpureFunction0(8, _c17))("max", ctx.max())("size", ctx.size())("initSearch", ctx.initSearch())("autofocus", ctx.autofocus())("ngModel", ctx.selectedValues);
          }
        },
        dependencies: [MultiSelectComponent, FormsModule, i1.NgControlStatus, i1.NgModel],
        encapsulation: 2
      });
    }
  }
  return GroupPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiValueInputComponent = /*#__PURE__*/(() => {
  class MultiValueInputComponent {
    constructor() {
      this.max = input(0);
      this.size = input('md');
      this.ariaLabel = input('');
      this.inputElement = viewChild('inputElement');
      this.input = '';
      this.values = [];
      // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
      this.valuesChanged = _ => {};
      this.uuid = uuid();
    }
    removeValueWithEvent(event, index) {
      this.removeValue(index);
      event.stopImmediatePropagation();
    }
    addValue() {
      if (!this.values) {
        this.values = [];
      }
      const max = this.max();
      if (this.input && (!max || this.values.length < max)) {
        this.values.push(this.input);
        this.input = '';
        this.valuesChanged(this.values);
      }
    }
    removeValue(index) {
      this.values.splice(index, 1);
      this.values = clone(this.values);
      this.inputElement()?.nativeElement.focus();
      this.valuesChanged(this.values);
    }
    inputKeyDown(event) {
      if (event.key === 'Backspace' && this.input === '' && this.values?.length) {
        this.removeValue(this.values.length - 1);
      }
      if (event.key === 'Enter') {
        this.addValue();
      }
    }
    registerOnChange(fn) {
      this.valuesChanged = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.values = obj;
    }
    static {
      this.ɵfac = function MultiValueInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiValueInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiValueInputComponent,
        selectors: [["rbb-multi-value-input"]],
        viewQuery: function MultiValueInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.inputElement, _c18, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostBindings: function MultiValueInputComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function MultiValueInputComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          max: [1, "max"],
          size: [1, "size"],
          prependIcon: "prependIcon",
          ariaLabel: [1, "ariaLabel"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: MultiValueInputComponent,
          multi: true
        }])],
        decls: 8,
        vars: 14,
        consts: [["inputElement", ""], [1, "rbb-multi-select"], [1, "input-group", "pointer", 3, "click", "ngClass"], [1, "input-group-text", 3, "for"], ["role", "list", 1, "form-control", "py-1", 2, "height", "auto !important", 3, "id"], ["role", "listitem", 1, "d-inline-block", "rounded", "px-1", "me-1", "my-1", 3, "ngClass"], ["aria-description", "Enter zum hinzuf\xFCgen des Eintrags benutzen. Wenn das Eingabefeld leer ist, kann mit der R\xFCcktaste der letzte Eintrag entfernt werden.", 1, "border-0", "my-1", 3, "ngModelChange", "keydown", "focusout", "id", "name", "ngModel", "ngClass"], ["role", "button", "aria-label", "Eintrag entfernen", "tabindex", "0", 1, "d-inline-block", 3, "click", "keydown.space", "keydown.enter"], [1, "fa-solid", "fa-times", "text-midgray"]],
        template: function MultiValueInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵlistener("click", function MultiValueInputComponent_Template_div_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              const inputElement_r2 = i0.ɵɵreference(7);
              return i0.ɵɵresetView(inputElement_r2.focus());
            });
            i0.ɵɵtemplate(2, MultiValueInputComponent_Conditional_2_Template, 2, 3, "label", 3);
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵrepeaterCreate(4, MultiValueInputComponent_For_5_Template, 5, 4, "div", 5, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(6, "input", 6, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function MultiValueInputComponent_Template_input_ngModelChange_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.input, $event) || (ctx.input = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("keydown", function MultiValueInputComponent_Template_input_keydown_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputKeyDown($event));
            })("focusout", function MultiValueInputComponent_Template_input_focusout_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addValue());
            });
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c12, ctx.size() === "sm", ctx.size() === "lg"));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.prependIcon ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.uuid + "-list");
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.values);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.uuid)("name", ctx.uuid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.input);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c13, ctx.max() && ctx.values && ctx.values.length >= ctx.max()));
            i0.ɵɵattribute("aria-label", ctx.ariaLabel())("aria-controls", ctx.uuid + "-list");
          }
        },
        dependencies: [NgClass, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel],
        styles: ["input[_ngcontent-%COMP%]{background-color:transparent}input[_ngcontent-%COMP%]:focus{outline:rgb(88,88,86) dotted 1px!important}"]
      });
    }
  }
  return MultiValueInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavbarComponent = /*#__PURE__*/(() => {
  class NavbarComponent {
    constructor() {
      this.router = inject(Router);
      this.searchTemplate = input(null);
      this.navigationTemplate = input(null);
      this.ard = input(false);
      this.documentTitleSuffix = '';
      this.updateTitleInitiatedThroughComponent = false;
      this.getOrganisationName = getOrganisationName;
      this.getOrganisationImageUrl = getOrganisationImageUrl;
    }
    static {
      this.updateTitleInitiated = false;
    }
    ngOnInit() {
      this.documentTitleSuffix = this.config?.instance ?? '';
      if (!NavbarComponent.updateTitleInitiated) {
        this.router.events.subscribe(() => this.updateTitle());
        this.updateTitleInitiatedThroughComponent = true;
        NavbarComponent.updateTitleInitiated = true;
        this.updateTitle();
      }
    }
    ngOnDestroy() {
      if (this.updateTitleInitiatedThroughComponent) {
        this.updateTitleSubscription?.unsubscribe();
        if (document.title.endsWith(' (' + this.documentTitleSuffix + ')')) {
          document.title = document.title.replace(' (' + this.documentTitleSuffix + ')', '');
        }
        NavbarComponent.updateTitleInitiated = false;
        this.updateTitleInitiatedThroughComponent = false;
      }
    }
    updateTitle() {
      if (this.documentTitleSuffix && !document.title.endsWith(' (' + this.documentTitleSuffix + ')')) {
        document.title = document.title + ' (' + this.documentTitleSuffix + ')';
      }
    }
    isCurrentApplication(path) {
      return window.location.pathname.startsWith(path);
    }
    getRoles() {
      const roles = this.config?.userInfo?.getRole?.();
      return Array.isArray(roles) ? roles : roles ? [roles] : [];
    }
    setThemeMode(themeMode, event) {
      event.stopImmediatePropagation();
      setThemeMode(themeMode);
    }
    static {
      this.ɵfac = function NavbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NavbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NavbarComponent,
        selectors: [["rbb-navbar"]],
        inputs: {
          config: "config",
          searchTemplate: [1, "searchTemplate"],
          navigationTemplate: [1, "navigationTemplate"],
          ard: [1, "ard"]
        },
        decls: 1,
        vars: 1,
        consts: [[1, "navbar", "navbar-expand-xl", "bg-light", "fixed-top"], ["href", "", 1, "navbar-brand", "me-auto"], ["src", "https://tools.rbb-online.de/template/v4/images/ard.svg", "alt", "ARD", 1, "d-inline-block", "align-top", "ard"], ["src", "https://tools.rbb-online.de/template/v4/images/rbb.svg", "alt", "rbb", 1, "d-inline-block", "align-top"], [1, "text-danger"], [1, "fade"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#navbarSupportedContent", 1, "navbar-toggler"], [1, "fa-solid", "fa-bars"], [4, "ngTemplateOutlet"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav"], [1, "nav-item", "dropdown", "ms-xl-4", "nav-info-menu"], ["href", "#", "id", "navbarDropdownContact", "data-bs-toggle", "dropdown", 1, "nav-link", "dropdown-toggle"], [1, "fa-solid", "fa-user-circle"], [1, "text-white", "bg-secondary", "rounded-circle", "text-center", "d-none", "d-xl-block", "position-relative", 2, "height", "32px", "width", "32px", "font-size", "14px", "line-height", "29px"], [1, "d-xl-none"], ["aria-labelledby", "navbarDropdownContact", 1, "dropdown-menu", "dropdown-menu-end"], [1, "dropdown-header"], ["href", "mailto:support@rbb-online.de", 1, "dropdown-item", "external-link"], [1, "elevated-icon", "bg-primary", "fa-solid", "fa-envelope"], ["target", "_blank", 1, "dropdown-item", "external-link", 3, "href"], ["routerLinkActive", "active", 1, "dropdown-item", 3, "routerLink"], [1, "dropdown-item", "external-link", 3, "href"], [1, "dropdown-divider"], [1, "px-4"], [1, "row"], [1, "col", "text-center"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Systemeinstellung", 1, "fa-solid", "fa-desktop", "pointer", "elevated-icon", "bg-secondary", "bg-primary-theme-system", 3, "click"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Hell", 1, "fa-solid", "fa-sun", "pointer", "elevated-icon", "bg-secondary", "bg-primary-theme-light", 3, "click"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Dunkel", 1, "fa-solid", "fa-moon", "pointer", "elevated-icon", "bg-secondary", "bg-primary-theme-dark", 3, "click"], [1, "small", "text-secondary", "px-2", "mt-2", "text-end", "text-nowrap", "text-tabular-numbers"], [1, "align-middle"], ["width", "14", "role", "presentation", 1, "position-absolute", "top-100", "start-100", "translate-middle", 3, "src", "alt"], [1, "px-3", "py-1", "w-100", "text-nowrap", "fw-normal"], [1, "row", "flex-nowrap"], [1, "col-auto", "d-inline-block", "d-flex", "flex-column", "align-items-center", "pe-1"], [1, "text-white", "bg-secondary", "rounded-circle", "text-center", 2, "height", "36px", "width", "36px", "font-size", "16px", "line-height", "32px"], [1, "fa-solid", "fa-user-circle", "text-secondary", "align-middle", 2, "font-size", "36px"], [1, "mt-1"], ["width", "36", "role", "presentation", 3, "src", "alt"], [1, "col", 2, "font-size", "12px"], [1, "text-secondary"], [1, "fw-bold", "d-inline-block", "align-text-top"], [1, "d-block"], [1, "elevated-icon", "bg-primary"], [1, "elevated-icon", "bg-primary", "fa-solid", "fa-comments"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-question"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-shield-alt"], ["href", "https://tools.rbb-online.de/home", "target", "_blank", 1, "dropdown-item", "external-link", "d-hsb-none", "d-ivz-none"], ["href", "https://rbb.sharepoint.com/sites/Intranet-Startseite", "target", "_blank", 1, "dropdown-item", "external-link"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-home"], ["href", "https://tools.rbb-online.de/forms", "target", "_blank", 1, "dropdown-item", "external-link"], ["href", "https://tools.rbb-online.de/mit-service", "target", "_blank", 1, "dropdown-item", "external-link"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-toolbox"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-file-alt"], [1, "elevated-icon", "bg-secondary", "fa-solid", "fa-headset"], [1, "pointer", 3, "routerLink"]],
        template: function NavbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NavbarComponent_Conditional_0_Template, 50, 22, "nav", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.config ? 0 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, RouterLinkActive, RouterLink],
        encapsulation: 2
      });
    }
  }
  return NavbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginatorComponent = /*#__PURE__*/(() => {
  class PaginatorComponent {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.pages = input.required();
      this.ariaLabel = input.required();
      this.ariaControls = input();
      this.pageChange = output();
      this.position = input('left');
      this.currentPage = 1;
    }
    previous() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.pageChange.emit(this.currentPage);
      }
    }
    next() {
      if (this.currentPage < this.pages()) {
        this.currentPage++;
        this.pageChange.emit(this.currentPage);
      }
    }
    selectPage(page) {
      if (page >= 1 && page <= this.pages() && page !== this.currentPage) {
        this.currentPage = page;
        this.pageChange.emit(this.currentPage);
      }
    }
    getPageItems() {
      const pages = this.pages();
      if (this.currentPage > this.pages()) {
        this.selectPage(pages);
      }
      const items = [];
      items.push(1);
      for (let i = Math.max(2, Math.min(this.currentPage - 2, pages - 5)); i <= Math.min(pages - 1, Math.max(this.currentPage + 2, 6)); i++) {
        if (i === Math.min(this.currentPage - 2, pages - 5) || i === Math.max(this.currentPage + 2, 6)) {
          if (i > 2 && i < pages - 1) {
            items.push(0);
          } else {
            items.push(i);
          }
          continue;
        }
        items.push(i);
      }
      if (pages > 1) {
        items.push(pages);
      }
      return items;
    }
    focusCurrent() {
      setTimeout(() => this.elementRef.nativeElement.querySelector('.active button')?.focus());
    }
    static {
      this.ɵfac = function PaginatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaginatorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PaginatorComponent,
        selectors: [["rbb-paginator"]],
        inputs: {
          pages: [1, "pages"],
          ariaLabel: [1, "ariaLabel"],
          ariaControls: [1, "ariaControls"],
          position: [1, "position"],
          currentPage: "currentPage"
        },
        outputs: {
          pageChange: "pageChange"
        },
        decls: 1,
        vars: 1,
        consts: [["aria-description", "Zur Navigation Pfeiltaste links oder rechts benutzen"], ["aria-description", "Zur Navigation Pfeiltaste links oder rechts benutzen", 3, "keydown.arrowLeft", "keydown.arrowRight"], [1, "pagination", "pagination-sm", 3, "ngClass"], [1, "page-item"], ["aria-label", "Vorherige Seite", 1, "page-link", 3, "click"], ["role", "presentation"], [1, "page-item", 3, "ngClass"], ["aria-label", "N\xE4chste Seite", 1, "page-link", 3, "click"], [1, "page-link"], [1, "page-link", 3, "click"]],
        template: function PaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PaginatorComponent_Conditional_0_Template, 12, 5, "nav", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.pages() ? 0 : -1);
          }
        },
        dependencies: [NgClass],
        styles: [".page-item[_ngcontent-%COMP%]:not(.active):not(.disabled){cursor:pointer}"]
      });
    }
  }
  return PaginatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VersionService = /*#__PURE__*/(() => {
  class VersionService {
    constructor() {
      this.http = inject(HttpClient);
    }
    getWebVersionInAssets() {
      return this.http.get('assets/web-version.json', {
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0'
        })
      });
    }
    getVersionOfService(apiBaseUrl) {
      return this.http.get(apiBaseUrl + '/api/info', {
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0'
        })
      });
    }
    getPatchNotes(projectName, test = false) {
      const params = new HttpParams().append('atlassianId', projectName).append('test', test);
      return this.http.get('https://tools.rbb-online.de/tools-service/api/patch-notes', {
        params
      });
    }
    static {
      this.ɵfac = function VersionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VersionService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VersionService,
        factory: VersionService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VersionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PatchNotesComponent = /*#__PURE__*/(() => {
  class PatchNotesComponent {
    constructor() {
      this.route = inject(ActivatedRoute);
      this.versionService = inject(VersionService);
      this.loading = false;
    }
    ngOnInit() {
      this.getPatchNotes();
      this.route.data.subscribe(data => {
        this.projectName = data['projectName'];
        this.getPatchNotes();
      });
    }
    getPatchNotes() {
      if (this.projectName) {
        this.loading = true;
        this.versionService.getPatchNotes(this.projectName).subscribe({
          next: data => {
            this.notes = data;
            this.loading = false;
          },
          error: () => this.loading = false
        });
      }
    }
    static {
      this.ɵfac = function PatchNotesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PatchNotesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PatchNotesComponent,
        selectors: [["rbb-patch-notes"]],
        inputs: {
          projectName: "projectName"
        },
        decls: 4,
        vars: 1,
        consts: [[1, "container", "pt-3"], ["headline", "Versionshinweise", "icon", "fas fa-history"], [1, "m-5", "text-center"], [1, "row"], [1, "m-5", "text-secondary", "text-center"], [1, "col-12", "py-2"], [1, "mb-0", "text-primary"], [1, "text-secondary", "fw-bold", "mb-0", "d-block"], [1, "mt-2", 3, "innerHTML"], [1, "my-1"]],
        template: function PatchNotesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "rbb-side-menu-headline", 1);
            i0.ɵɵtemplate(2, PatchNotesComponent_Conditional_2_Template, 2, 0, "div", 2)(3, PatchNotesComponent_Conditional_3_Template, 2, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.loading ? 2 : 3);
          }
        },
        dependencies: [SideMenuHeadlineComponent, LoaderComponent, DatePipe],
        encapsulation: 2
      });
    }
  }
  return PatchNotesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-classes-per-file */
class UserSearchOptions {
  constructor() {
    this.rbb = true;
    this.hsb = false;
    this.ivz = false;
    this.functionAccounts = false;
    this.vpnAccounts = false;
  }
}
class UserSearchOptionsDefaults {
  constructor() {
    this.rbb = true;
    this.hsb = false;
    this.ivz = false;
    this.functionAccounts = false;
    this.vpnAccounts = false;
  }
}
let UserService = /*#__PURE__*/(() => {
  class UserService {
    constructor() {
      this.http = inject(HttpClient);
      this.defaultOptions = new UserSearchOptionsDefaults();
    }
    getOwnUser() {
      return this.http.get('https://tools.rbb-online.de/user-service/api/accounts/me');
    }
    searchAdUser(search, options) {
      const appliedOptions = merge(clone(this.defaultOptions), options);
      const params = new HttpParams().append('q', search).append('rbb', appliedOptions.rbb).append('hsb', appliedOptions.hsb).append('ivz', appliedOptions.ivz).append('function', appliedOptions.functionAccounts).append('vpn', appliedOptions.vpnAccounts);
      return this.http.get('https://tools.rbb-online.de/user-service/api/accounts', {
        params
      });
    }
    getAdUsers(usernames, options) {
      const appliedOptions = merge(clone(this.defaultOptions), options);
      const params = new HttpParams().append('rbb', appliedOptions.rbb).append('hsb', appliedOptions.hsb).append('ivz', appliedOptions.ivz).append('function', appliedOptions.functionAccounts).append('vpn', appliedOptions.vpnAccounts);
      return this.http.post('https://tools.rbb-online.de/user-service/api/accounts/multiple', usernames, {
        params
      });
    }
    static {
      this.ɵfac = function UserService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserService,
        factory: UserService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PeoplePickerComponent = /*#__PURE__*/(() => {
  class PeoplePickerComponent {
    constructor() {
      this.userService = inject(UserService);
      this.initSearch = input('');
      this.max = input(0);
      this.size = input('md');
      this.showUsername = input(false);
      this.showEmailAddress = input(false);
      this.showOrganisation = input(false);
      this.options = input();
      this.selectedValues = [];
      this.autofocus = input(false);
      this.itemTemplate = input(null);
      this.loadValuesFunction = search => this.userService.searchAdUser(search, this.options());
      this.getOrganisationName = getOrganisationName;
      this.getOrganisationImageUrl = getOrganisationImageUrl;
    }
    registerOnChange(fn) {
      this.selectedValuesChanged = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.selectedValues = obj;
    }
    static {
      this.ɵfac = function PeoplePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PeoplePickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PeoplePickerComponent,
        selectors: [["rbb-people-picker"]],
        hostBindings: function PeoplePickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function PeoplePickerComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          initSearch: [1, "initSearch"],
          max: [1, "max"],
          size: [1, "size"],
          showUsername: [1, "showUsername"],
          showEmailAddress: [1, "showEmailAddress"],
          showOrganisation: [1, "showOrganisation"],
          options: [1, "options"],
          selectedValues: "selectedValues",
          autofocus: [1, "autofocus"],
          itemTemplate: [1, "itemTemplate"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: PeoplePickerComponent,
          multi: true
        }])],
        decls: 3,
        vars: 9,
        consts: [["itemTemplateDefault", ""], ["prependIcon", "fa-solid fa-user", "ariaLabel", "Mehrfachauswahl f\xFCr Personen", 3, "ngModelChange", "itemTemplate", "loadValuesFunction", "searchFields", "max", "size", "initSearch", "autofocus", "ngModel"], [3, "src", "alt", "class"], [3, "src", "alt"]],
        template: function PeoplePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "rbb-multi-select", 1);
            i0.ɵɵlistener("ngModelChange", function PeoplePickerComponent_Template_rbb_multi_select_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectedValuesChanged == null ? null : ctx.selectedValuesChanged($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(1, PeoplePickerComponent_ng_template_1_Template, 4, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_1_0;
            const itemTemplateDefault_r4 = i0.ɵɵreference(2);
            i0.ɵɵproperty("itemTemplate", (tmp_1_0 = ctx.itemTemplate()) !== null && tmp_1_0 !== undefined ? tmp_1_0 : itemTemplateDefault_r4)("loadValuesFunction", ctx.loadValuesFunction)("searchFields", i0.ɵɵpureFunction0(8, _c17))("max", ctx.max())("size", ctx.size())("initSearch", ctx.initSearch())("autofocus", ctx.autofocus())("ngModel", ctx.selectedValues);
          }
        },
        dependencies: [MultiSelectComponent, FormsModule, i1.NgControlStatus, i1.NgModel],
        styles: ["img[_ngcontent-%COMP%]{height:.8em}"]
      });
    }
  }
  return PeoplePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProgressComponent = /*#__PURE__*/(() => {
  class ProgressComponent {
    constructor() {
      this.ariaLabel = input.required();
      this.percent = input(0);
      this.timeDuration = input(0);
      this.timeStart = input(0);
      this.progressBar = viewChild('progressBar');
    }
    ngOnInit() {
      this.currentTimeInterval = setInterval(() => {
        const progressBar = this.progressBar();
        if (progressBar) {
          const progress = this.calculateProgress();
          progressBar.nativeElement.style.width = this.calculateProgress() + '%';
          progressBar.nativeElement.ariaValueNow = progress.toString();
        }
      }, 100);
    }
    ngOnDestroy() {
      clearInterval(this.currentTimeInterval);
    }
    calculateProgress() {
      const percent = this.percent();
      if (percent) {
        return Math.min(100, Math.max(0, percent));
      }
      const timeDuration = this.timeDuration();
      const timeStart = this.timeStart();
      if (timeDuration && timeStart) {
        return Math.min(100, Math.max(0, Math.floor(100 * (Date.now() - timeStart) / timeDuration)));
      }
      return 0;
    }
    static {
      this.ɵfac = function ProgressComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProgressComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProgressComponent,
        selectors: [["rbb-progress"]],
        viewQuery: function ProgressComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.progressBar, _c21, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          ariaLabel: [1, "ariaLabel"],
          percent: [1, "percent"],
          timeDuration: [1, "timeDuration"],
          timeStart: [1, "timeStart"]
        },
        decls: 5,
        vars: 1,
        consts: [["progressBar", ""], [1, "text-center", "m-5", "p-5"], [1, "progress", "mt-3", 2, "height", "5px"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "progress-bar-striped", "progress-bar-animated"]],
        template: function ProgressComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "rbb-loader");
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "div", 3, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel());
          }
        },
        dependencies: [LoaderComponent],
        encapsulation: 2
      });
    }
  }
  return ProgressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchInputPipe = /*#__PURE__*/(() => {
  class SearchInputPipe {
    transform(values, searchQuery) {
      if (!searchQuery) {
        return [];
      }
      const words = searchQuery.split(/[, ]/).filter(s => s).map(s => s.toLowerCase()) ?? [];
      if (words.length === 0) {
        return [];
      }
      const filteredValues = values.filter(value => {
        for (const word of words) {
          const lValue = value.toLowerCase();
          if (!lValue.includes(word)) {
            return false;
          }
        }
        return true;
      });
      return this.orderValue(filteredValues, words, 0).slice(0, 10);
    }
    orderValue(values, words, index) {
      if (index >= words.length) {
        return values;
      }
      const word = words[index] ?? '';
      const complete = [];
      const starts = [];
      const prio = [];
      const other = [];
      for (const value of values) {
        const valueWords = value.split(/[, ]/).map(s => s.toLowerCase());
        if (valueWords[0] === word) {
          complete.push(value);
          continue;
        }
        const i = valueWords.findIndex(s => s.startsWith(word));
        if (i === 0) {
          starts.push(value);
        } else if (i !== -1) {
          prio.push(value);
        } else {
          other.push(value);
        }
      }
      return this.orderValue(complete, words, index + 1).concat(this.orderValue(starts, words, index + 1)).concat(this.orderValue(prio, words, index + 1)).concat(other);
    }
    static {
      this.ɵfac = function SearchInputPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchInputPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "searchInput",
        type: SearchInputPipe,
        pure: true
      });
    }
  }
  return SearchInputPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchInputComponent = /*#__PURE__*/(() => {
  class SearchInputComponent extends Autocomplete {
    constructor() {
      super();
      this.name = input('search');
      this.values = [];
      this.placeholder = input('');
      this.focusAlwaysItem = input(false);
      this.showWarning = input(false);
      this.warnMessage = '';
      this.initFocus = input(false);
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.submit = output();
      this.searchQuery = '';
      this.searchValues = [];
      this.searchValueSelectIndex = 0;
      this.autocompleteList = viewChild('autocompleteList');
      this.autocompleteItems = viewChildren('autocompleteItems');
      this.inputElement = viewChild('inputElement');
      this.searching = false;
      this.autocompleteHovered = false;
      // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
      this.searchQueryChanged = _ => {};
      this.uuid = uuid();
    }
    ngOnInit() {
      this.searchValueSelectIndex = this.focusAlwaysItem() ? 0 : -1;
    }
    ngAfterViewInit() {
      if (this.initFocus()) {
        this.inputElement()?.nativeElement.focus();
      }
    }
    selectValue(value) {
      this.searchQuery = value;
      this.searchQueryChanged(this.searchQuery);
      this.refreshScroll(this.autocompleteList(), this.autocompleteItems()[this.searchValueSelectIndex]);
      this.sendSubmit();
    }
    inputKeyDown(event) {
      const autocompleteList = this.autocompleteList();
      const autocompleteItems = this.autocompleteItems();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.searchValueSelectIndex++;
        if (this.searchValueSelectIndex >= this.searchValues.length) {
          if (this.focusAlwaysItem()) {
            this.searchValueSelectIndex = 0;
          } else {
            this.searchValueSelectIndex = this.searchValues.length - 1;
          }
        }
        event.stopImmediatePropagation();
        this.refreshScroll(autocompleteList, autocompleteItems[this.searchValueSelectIndex]);
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.searchValueSelectIndex--;
        if (this.searchValueSelectIndex < 0) {
          if (this.focusAlwaysItem()) {
            this.searchValueSelectIndex = this.searchValues.length - 1;
          } else {
            this.searchValueSelectIndex = -1;
          }
        }
        event.stopImmediatePropagation();
        this.refreshScroll(autocompleteList, autocompleteItems[this.searchValueSelectIndex]);
      }
      if (event.key === 'Enter') {
        if (this.searchValueSelectIndex >= 0 && this.searchValueSelectIndex < this.searchValues.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.selectValue(this.searchValues[this.searchValueSelectIndex]);
        }
      }
    }
    prepareSearchList(values) {
      this.searchValues = values;
      if (this.searchValueSelectIndex >= values.length) {
        this.searchValueSelectIndex = values.length - 1;
      }
      if (this.searchValueSelectIndex < 0 && this.focusAlwaysItem()) {
        this.searchValueSelectIndex = 0;
      }
      return values;
    }
    registerOnChange(fn) {
      this.searchQueryChanged = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.searchQuery = obj;
    }
    sendSubmit() {
      this.searching = false;
      this.searchValueSelectIndex = this.focusAlwaysItem() ? 0 : -1;
      this.submit.emit(this.searchQuery ?? '');
    }
    formatSplit(value) {
      const words = (this.searchQuery ?? '').split(/[, ]/).filter(s => s);
      let start = 0;
      const indexes = [0];
      for (const word of words) {
        const i = value.substring(start).toLowerCase().indexOf(word.toLowerCase());
        if (i !== -1) {
          start += i;
          indexes.push(start);
          start += word.length;
          indexes.push(start);
        }
      }
      indexes.push(value.length);
      const values = [];
      for (let i = 0; i < indexes.length - 1; i++) {
        values.push(value.substring(indexes[i], indexes[i + 1]));
      }
      return values;
    }
    static {
      this.ɵfac = function SearchInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchInputComponent,
        selectors: [["rbb-search-input"]],
        viewQuery: function SearchInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.autocompleteList, _c10, 5);
            i0.ɵɵviewQuerySignal(ctx.autocompleteItems, _c11, 5);
            i0.ɵɵviewQuerySignal(ctx.inputElement, _c18, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(3);
          }
        },
        hostBindings: function SearchInputComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function SearchInputComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          name: [1, "name"],
          values: "values",
          placeholder: [1, "placeholder"],
          focusAlwaysItem: [1, "focusAlwaysItem"],
          showWarning: [1, "showWarning"],
          warnMessage: "warnMessage",
          initFocus: [1, "initFocus"]
        },
        outputs: {
          submit: "submit"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SearchInputComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 10,
        consts: [["inputElement", ""], ["autocompleteList", ""], ["autocompleteItems", ""], ["role", "search", 1, "rbb-search-input", 3, "submit"], [1, "input-group", "w-100"], ["type", "search", "autocomplete", "off", "role", "combobox", "aria-autocomplete", "list", 1, "form-control", "border-secondary", 3, "ngModelChange", "keydown", "click", "focusout", "id", "name", "ngModel", "placeholder"], ["type", "submit", "aria-label", "Suchanfrage abschicken", 1, "btn", "btn-outline-secondary"], [1, "fa-solid", "fa-search"], ["role", "alert", 1, "search_invalid", "rounded", "alert-primary", "border", "border-primary", "p-1", "shadow", "input-warning"], ["role", "listbox", 1, "autocomplete", "border", "shadow", 3, "hidden", "id"], [1, "text-primary", "ps-2"], [1, "fa-solid", "fa-exclamation-circle"], ["role", "listbox", 1, "autocomplete", "border", "shadow", 3, "mouseover", "mouseenter", "mouseout", "mouseleave", "hidden", "id"], ["role", "option", 1, "autocomplete-item", "p-1", "px-2", 3, "id"], ["role", "option", 1, "autocomplete-item", "p-1", "px-2", 3, "click", "mouseover", "mouseenter", "id"], [3, "fw-bold"]],
        template: function SearchInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 3);
            i0.ɵɵlistener("submit", function SearchInputComponent_Template_form_submit_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.sendSubmit();
              $event.preventDefault();
              return i0.ɵɵresetView($event.stopImmediatePropagation());
            });
            i0.ɵɵelementStart(1, "div", 4)(2, "input", 5, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function SearchInputComponent_Template_input_ngModelChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.searchQuery, $event) || (ctx.searchQuery = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function SearchInputComponent_Template_input_ngModelChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.searching = true;
              return i0.ɵɵresetView(ctx.searchQueryChanged($event));
            })("keydown", function SearchInputComponent_Template_input_keydown_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputKeyDown($event));
            })("click", function SearchInputComponent_Template_input_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searching = true);
            })("focusout", function SearchInputComponent_Template_input_focusout_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searching = ctx.autocompleteHovered);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 6);
            i0.ɵɵelement(5, "i", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, SearchInputComponent_Conditional_6_Template, 4, 1, "div", 8)(7, SearchInputComponent_Conditional_7_Template, 5, 5, "div", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("id", ctx.uuid)("name", ctx.name());
            i0.ɵɵtwoWayProperty("ngModel", ctx.searchQuery);
            i0.ɵɵproperty("placeholder", ctx.placeholder());
            i0.ɵɵattribute("aria-label", ctx.placeholder())("aria-controls", ctx.uuid + "-autocomplete")("aria-expanded", ctx.searching)("aria-activedescendant", ctx.uuid + "-autocomplete-" + ctx.searchValueSelectIndex);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showWarning() && ctx.warnMessage ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.values.length ? 7 : -1);
          }
        },
        dependencies: [FormsModule, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.NgModel, i1.NgForm, SearchInputPipe],
        styles: [".autocomplete-item[_ngcontent-%COMP%]{cursor:pointer}.autocomplete-item[aria-selected=true][_ngcontent-%COMP%]{background-color:var(--bs-gray-100)}[data-bs-theme=\"dark\"][_nghost-%COMP%]   .autocomplete-item[aria-selected=true][_ngcontent-%COMP%], [data-bs-theme=\"dark\"]   [_nghost-%COMP%]   .autocomplete-item[aria-selected=true][_ngcontent-%COMP%]{background-color:var(--bs-gray-800)}.autocomplete[_ngcontent-%COMP%]{width:100%;position:absolute;z-index:1000;background-color:var(--bs-body-bg)}.rbb-search-input[_ngcontent-%COMP%]{position:relative}.input-warning[_ngcontent-%COMP%]{position:absolute;top:40px;width:100%}"]
      });
    }
  }
  return SearchInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SettingService = /*#__PURE__*/(() => {
  class SettingService {
    constructor() {
      this.http = inject(HttpClient);
    }
    getSettings(serviceUrl) {
      return this.http.get(serviceUrl + '/api/service-settings');
    }
    getSetting(serviceUrl, key) {
      return this.http.get(serviceUrl + '/api/service-settings/' + key);
    }
    updateSetting(serviceUrl, key, value) {
      return this.http.put(serviceUrl + '/api/service-settings/' + key, {
        value
      });
    }
    setSettingToDefault(serviceUrl, key) {
      return this.http.delete(serviceUrl + '/api/service-settings/' + key);
    }
    static {
      this.ɵfac = function SettingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SettingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SettingService,
        factory: SettingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SettingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ModalRef {
  constructor(windowRef, contentRef, backdropRef) {
    this.windowRef = windowRef;
    this.contentRef = contentRef;
    this.backdropRef = backdropRef;
    windowRef.instance.dismissEvent.subscribe(() => this.dismiss());
    this.result = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
  /**
   * Closes the modal with an optional `result` value.
   */
  close(result) {
    if (this.windowRef) {
      this.resolve?.(result);
      this.removeModalElements();
    }
  }
  /**
   * Dismisses the modal.
   */
  dismiss() {
    if (this.windowRef) {
      this.reject?.();
      this.removeModalElements();
    }
  }
  get componentInstance() {
    return this.contentRef.componentRef?.instance;
  }
  removeModalElements() {
    const windowTransition$ = this.windowRef.instance.hide();
    const backdropTransition$ = this.backdropRef ? this.backdropRef.instance.hide() : of(undefined);
    // hiding window
    windowTransition$.subscribe(() => {
      const {
        nativeElement
      } = this.windowRef.location;
      nativeElement.parentNode.removeChild(nativeElement);
      this.windowRef.destroy();
      this.contentRef.viewRef.destroy();
      this.windowRef = undefined;
    });
    // hiding backdrop
    backdropTransition$.subscribe(() => {
      if (this.backdropRef) {
        const {
          nativeElement
        } = this.backdropRef.location;
        nativeElement.parentNode.removeChild(nativeElement);
        this.backdropRef.destroy();
        this.backdropRef = undefined;
      }
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noopFn = () => {};
const runningTransitions = new Map();
function getTransitionDurationMs(element) {
  const {
    transitionDelay,
    transitionDuration
  } = window.getComputedStyle(element);
  const transitionDelaySec = parseFloat(transitionDelay);
  const transitionDurationSec = parseFloat(transitionDuration);
  return (transitionDelaySec + transitionDurationSec) * 1000;
}
function runInZone(zone) {
  return source => new Observable(observer => {
    const onNext = value => zone.run(() => observer.next(value));
    const onError = e => zone.run(() => observer.error(e));
    const onComplete = () => zone.run(() => observer.complete());
    return source.subscribe({
      next: onNext,
      error: onError,
      complete: onComplete
    });
  });
}
function runTransition(zone, element, startFn, options) {
  // Getting initial context from options
  let context = options.context ?? {};
  // Checking if there are already running transitions on the given element.
  const running = runningTransitions.get(element);
  if (running) {
    switch (options.runningTransition) {
      // If there is one running, and we want for it to 'continue' to run, we have to cancel the new one.
      // We're not emitting any values, but simply completing the observable (EMPTY).
      case 'continue':
        return EMPTY;
      // If there is one running, and we want for it to 'stop', we have to complete the running one.
      // We're simply completing the running one and not emitting any values and merging newly provided context
      // with the one coming from currently running transition.
      case 'stop':
        zone.run(() => running.transition$.complete());
        context = Object.assign(running.context, context);
        runningTransitions.delete(element);
    }
  }
  // Running the start function
  const endFn = startFn(element, context) || noopFn;
  // If 'prefer-reduced-motion' is enabled, the 'transition' will be set to 'none'.
  // If animations are disabled, we have to emit a value and complete the observable
  // In this case we have to call the end function, but can finish immediately by emitting a value,
  // completing the observable and executing end functions synchronously.
  if (window.getComputedStyle(element).transitionProperty === 'none') {
    zone.run(() => endFn());
    return of(undefined).pipe(runInZone(zone));
  }
  // Starting a new transition
  const transition$ = new Subject();
  const finishTransition$ = new Subject();
  const stop$ = transition$.pipe(endWith(true));
  runningTransitions.set(element, {
    transition$,
    complete: () => {
      finishTransition$.next(null);
      finishTransition$.complete();
    },
    context
  });
  const transitionDurationMs = getTransitionDurationMs(element);
  // 1. We have to both listen for the 'transitionend' event and have a 'just-in-case' timer,
  // because 'transitionend' event might not be fired in some browsers, if the transitioning
  // element becomes invisible (ex. when scrolling, making browser tab inactive, etc.). The timer
  // guarantees, that we'll release the DOM element and complete 'ngbRunTransition'.
  // 2. We need to filter transition end events, because they might bubble from shorter transitions
  // on inner DOM elements. We're only interested in the transition on the 'element' itself.
  zone.runOutsideAngular(() => {
    const transitionEnd$ = fromEvent(element, 'transitionend').pipe(takeUntil(stop$), filter(({
      target
    }) => target === element));
    const timer$ = timer(transitionDurationMs + 5).pipe(takeUntil(stop$));
    race(timer$, transitionEnd$, finishTransition$).pipe(takeUntil(stop$)).subscribe(() => {
      runningTransitions.delete(element);
      zone.run(() => {
        endFn();
        transition$.next(null);
        transition$.complete();
      });
    });
  });
  return transition$.asObservable();
}
const FOCUSABLE_ELEMENTS_SELECTOR = ['a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'].join(', ');
function getFocusableBoundaryElements(element) {
  const list = Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR)).filter(el => el.tabIndex !== -1);
  return [list[0], list[list.length - 1]];
}

/* eslint-disable @typescript-eslint/class-literal-property-style */
let ModalWindowComponent = /*#__PURE__*/(() => {
  class ModalWindowComponent {
    constructor() {
      this.elRef = inject(ElementRef);
      this.zone = inject(NgZone);
      this.closed$ = new Subject();
      this.elWithFocus = null; // element that is focused prior to modal opening
      this.dialogEl = viewChild('dialog');
      this.backdrop = true;
      this.keyboard = true;
      // eslint-disable-next-line @angular-eslint/no-output-rename
      this.dismissEvent = output({
        alias: 'dismiss'
      });
      this.shown = new Subject();
      this.hidden = new Subject();
    }
    get class() {
      return 'modal d-block fade' + (this.windowClass ? ' ' + this.windowClass : '');
    }
    get role() {
      return 'dialog';
    }
    get tabindex() {
      return '-1';
    }
    get ariaModal() {
      return true;
    }
    get attrAriaLabelledBy() {
      return this.ariaLabelledBy;
    }
    get attrAriaDescribedBy() {
      return this.ariaDescribedBy;
    }
    dismiss() {
      this.dismissEvent.emit();
    }
    ngOnInit() {
      this.elWithFocus = document.activeElement;
      this.zone.onStable.asObservable().pipe(take(1)).subscribe(() => {
        this.show();
      });
    }
    ngOnDestroy() {
      this.disableEventHandling();
    }
    hide() {
      const {
        nativeElement
      } = this.elRef;
      const context = {
        runningTransition: 'stop'
      };
      const windowTransition$ = runTransition(this.zone, nativeElement, () => nativeElement.classList.remove('show'), context);
      const dialogEl = this.dialogEl();
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      const dialogTransition$ = dialogEl?.nativeElement ? runTransition(this.zone, dialogEl?.nativeElement, () => {}, context) : undefined;
      const transitions$ = dialogTransition$ ? zip(windowTransition$, dialogTransition$) : windowTransition$;
      transitions$.subscribe(() => {
        this.hidden.next();
        this.hidden.complete();
      });
      this.disableEventHandling();
      this.restoreFocus();
      return transitions$;
    }
    show() {
      const context = {
        runningTransition: 'continue'
      };
      const windowTransition$ = runTransition(this.zone, this.elRef.nativeElement, element => {
        (element || document.body).getBoundingClientRect();
        element.classList.add('show');
      }, context);
      const dialogEl = this.dialogEl();
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      const dialogTransition$ = dialogEl?.nativeElement ? runTransition(this.zone, dialogEl?.nativeElement, () => {}, context) : undefined;
      const transitions$ = dialogTransition$ ? zip(windowTransition$, dialogTransition$) : windowTransition$;
      transitions$.subscribe(() => {
        this.shown.next();
        this.shown.complete();
      });
      this.enableEventHandling();
      this.setFocus();
    }
    enableEventHandling() {
      const {
        nativeElement
      } = this.elRef;
      this.zone.runOutsideAngular(() => {
        fromEvent(nativeElement, 'keydown').pipe(takeUntil(this.closed$), filter(e => e.key === 'Escape')).subscribe(event => {
          if (this.keyboard) {
            requestAnimationFrame(() => {
              if (!event.defaultPrevented) {
                this.zone.run(() => this.dismiss());
              }
            });
          } else if (this.backdrop === 'static') {
            this.bumpBackdrop();
          }
        });
        // We're listening to 'mousedown' and 'mouseup' to prevent modal from closing when pressing the mouse
        // inside the modal dialog and releasing it outside
        let preventClose = false;
        const dialogEl = this.dialogEl();
        if (dialogEl) {
          fromEvent(dialogEl?.nativeElement, 'mousedown').pipe(takeUntil(this.closed$), tap(() => preventClose = false), switchMap(() => fromEvent(nativeElement, 'mouseup').pipe(takeUntil(this.closed$), take(1))), filter(({
            target
          }) => nativeElement === target)).subscribe(() => {
            preventClose = true;
          });
        }
        // We're listening to 'click' to dismiss modal on modal window click, except when:
        // 1. clicking on modal dialog itself
        // 2. closing was prevented by mousedown/up handlers
        // 3. clicking on scrollbar when the viewport is too small and modal doesn't fit (click is not triggered at all)
        fromEvent(nativeElement, 'click').pipe(takeUntil(this.closed$)).subscribe(({
          target
        }) => {
          if (nativeElement === target) {
            const backdrop = this.backdrop;
            if (backdrop === 'static') {
              this.bumpBackdrop();
            } else if (backdrop === true && !preventClose) {
              this.zone.run(() => this.dismiss());
            }
          }
          preventClose = false;
        });
      });
    }
    disableEventHandling() {
      this.closed$.next();
    }
    setFocus() {
      const {
        nativeElement
      } = this.elRef;
      if (!nativeElement.contains(document.activeElement)) {
        const autoFocusable = nativeElement.querySelector('[ngbAutofocus]');
        const firstFocusable = getFocusableBoundaryElements(nativeElement)[0];
        const elementToFocus = autoFocusable || firstFocusable || nativeElement;
        elementToFocus.focus();
      }
    }
    restoreFocus() {
      const body = document.body;
      const elWithFocus = this.elWithFocus;
      let elementToFocus;
      if (elWithFocus?.focus && body.contains(elWithFocus)) {
        elementToFocus = elWithFocus;
      } else {
        elementToFocus = body;
      }
      this.zone.runOutsideAngular(() => {
        setTimeout(() => elementToFocus.focus());
        this.elWithFocus = null;
      });
    }
    bumpBackdrop() {
      if (this.backdrop === 'static') {
        runTransition(this.zone, this.elRef.nativeElement, ({
          classList
        }) => {
          classList.add('modal-static');
          return () => classList.remove('modal-static');
        }, {
          runningTransition: 'continue'
        });
      }
    }
    static {
      this.ɵfac = function ModalWindowComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalWindowComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalWindowComponent,
        selectors: [["rbb-modal-window"]],
        viewQuery: function ModalWindowComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.dialogEl, _c22, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostVars: 7,
        hostBindings: function ModalWindowComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("role", ctx.role)("tabindex", ctx.tabindex);
            i0.ɵɵattribute("aria-modal", ctx.ariaModal)("aria-labelledby", ctx.attrAriaLabelledBy)("aria-describedby", ctx.attrAriaDescribedBy);
            i0.ɵɵclassMap(ctx.class);
          }
        },
        outputs: {
          dismissEvent: "dismiss"
        },
        ngContentSelectors: _c23,
        decls: 4,
        vars: 2,
        consts: [["dialog", ""], ["role", "document"], [1, "modal-content"]],
        template: function ModalWindowComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("modal-dialog" + (ctx.size ? " modal-" + ctx.size : "") + (ctx.centered ? " modal-dialog-centered" : "") + (ctx.scrollable ? " modal-dialog-scrollable" : "") + (ctx.modalDialogClass ? " " + ctx.modalDialogClass : ""));
          }
        },
        styles: [".component-host-scrollable{display:flex;flex-direction:column;overflow:hidden}\n"],
        encapsulation: 2
      });
    }
  }
  return ModalWindowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any,@typescript-eslint/no-empty-function */
class ActiveModal {
  /**
   * Closes the modal with an optional `result` value.
   *
   * The `NgbModalRef.result` promise will be resolved with the provided value.
   */
  close(result) {}
  /**
   * Dismisses the modal with an optional `reason` value.
   *
   * The `NgbModalRef.result` promise will be rejected with the provided value.
   */
  dismiss() {}
}
let ModalBackdropComponent = /*#__PURE__*/(() => {
  class ModalBackdropComponent {
    constructor() {
      this.el = inject(ElementRef);
      this.zone = inject(NgZone);
    }
    get class() {
      return 'modal-backdrop fade' + (this.backdropClass ? ' ' + this.backdropClass : '');
    }
    ngOnInit() {
      this.zone.onStable.asObservable().pipe(take(1)).subscribe(() => {
        runTransition(this.zone, this.el.nativeElement, element => {
          (element || document.body).getBoundingClientRect();
          element.classList.add('show');
        }, {
          runningTransition: 'continue'
        });
      });
    }
    hide() {
      return runTransition(this.zone, this.el.nativeElement, ({
        classList
      }) => classList.remove('show'), {
        runningTransition: 'stop'
      });
    }
    static {
      this.ɵfac = function ModalBackdropComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalBackdropComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalBackdropComponent,
        selectors: [["rbb-modal-backdrop"]],
        hostVars: 2,
        hostBindings: function ModalBackdropComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
          }
        },
        decls: 0,
        vars: 0,
        template: function ModalBackdropComponent_Template(rf, ctx) {},
        styles: [":host{z-index:1050}\n"],
        encapsulation: 2
      });
    }
  }
  return ModalBackdropComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScrollbarService = /*#__PURE__*/(() => {
  class ScrollbarService {
    /**
     * To be called right before a potential vertical scrollbar would be removed:
     *
     * - if there was a scrollbar, adds some compensation padding to the body
     * to keep the same layout as when the scrollbar is there
     * - if there was none, there is nothing to do
     *
     * @return a callback used to revert the compensation (noop if there was none,
     * otherwise a function removing the padding)
     */
    compensate() {
      const width = this.getWidth();
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return !this.isPresent(width) ? () => {} : this.adjustBody(width);
    }
    /**
     * Adds a padding of the given width on the right of the body.
     *
     * @return a callback used to revert the padding to its previous value
     */
    adjustBody(scrollbarWidth) {
      const body = document.body;
      const userSetPaddingStyle = body.style.paddingRight;
      const actualPadding = parseFloat(window.getComputedStyle(body).paddingRight);
      body.style.paddingRight = `${actualPadding + scrollbarWidth}px`;
      const navbar = document.querySelector('nav.navbar.fixed-top');
      if (navbar) {
        navbar.style.right = scrollbarWidth + 'px';
      }
      return () => {
        body.style.paddingRight = userSetPaddingStyle;
        if (navbar) {
          navbar.style.right = '';
        }
      };
    }
    /**
     * Tells whether a scrollbar is currently present on the body.
     *
     * @return true if scrollbar is present, false otherwise
     */
    isPresent(scrollbarWidth) {
      const rect = document.body.getBoundingClientRect();
      const bodyToViewportGap = window.innerWidth - (rect.left + rect.right);
      const uncertainty = 0.1 * scrollbarWidth;
      return bodyToViewportGap >= scrollbarWidth - uncertainty;
    }
    /**
     * Calculates and returns the width of a scrollbar.
     *
     * @return the width of a scrollbar on this page
     */
    getWidth() {
      const documentWidth = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - documentWidth);
    }
    static {
      this.ɵfac = function ScrollbarService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollbarService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScrollbarService,
        factory: ScrollbarService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScrollbarService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ContentRef {
  constructor(nodes, viewRef, componentRef) {
    this.nodes = nodes;
    this.viewRef = viewRef;
    this.componentRef = componentRef;
  }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
let ModalStackService = /*#__PURE__*/(() => {
  class ModalStackService {
    constructor() {
      this.applicationRef = inject(ApplicationRef);
      this.scrollBar = inject(ScrollbarService);
      this.rendererFactory = inject(RendererFactory2);
      this.zone = inject(NgZone);
      this.activeWindowCmptHasChanged = new Subject();
      this.ariaHiddenValues = new Map();
      this.modalRefs = [];
      this.windowCmpts = [];
      this.activeWindowCmptHasChanged.subscribe(() => {
        if (this.windowCmpts.length) {
          const activeWindowCmpt = this.windowCmpts[this.windowCmpts.length - 1];
          this.focusTrap(this.zone, activeWindowCmpt.location.nativeElement, this.activeWindowCmptHasChanged);
          this.revertAriaHidden();
          this.setAriaHidden(activeWindowCmpt.location.nativeElement);
        }
      });
    }
    open(content, options) {
      const renderer = this.rendererFactory.createRenderer(null, null);
      const revertPaddingForScrollBar = this.scrollBar.compensate();
      const removeBodyClass = () => {
        if (!this.modalRefs.length) {
          renderer.removeClass(document.body, 'modal-open');
          document.body.style.overflow = '';
          this.revertAriaHidden();
        }
      };
      const activeModal = new ActiveModal();
      const contentRef = this.getContentRef(content, activeModal, options);
      const backdropCmptRef = this.attachBackdrop();
      const windowCmptRef = this.attachWindowComponent(contentRef.nodes);
      const modalRef = new ModalRef(windowCmptRef, contentRef, backdropCmptRef);
      this.registerModalRef(modalRef);
      this.registerWindowCmpt(windowCmptRef);
      modalRef.result.then(revertPaddingForScrollBar, revertPaddingForScrollBar);
      modalRef.result.then(removeBodyClass, removeBodyClass);
      activeModal.close = result => {
        modalRef.close(result);
      };
      activeModal.dismiss = () => {
        modalRef.dismiss();
      };
      Object.assign(windowCmptRef.instance, options);
      if (this.modalRefs.length === 1) {
        renderer.addClass(document.body, 'modal-open');
        document.body.style.overflow = 'hidden';
      }
      Object.assign(windowCmptRef.instance, options);
      backdropCmptRef.changeDetectorRef.detectChanges();
      windowCmptRef.changeDetectorRef.detectChanges();
      return modalRef;
    }
    attachBackdrop() {
      const backdropCmptRef = createComponent(ModalBackdropComponent, {
        environmentInjector: this.applicationRef.injector
      });
      this.applicationRef.attachView(backdropCmptRef.hostView);
      document.body.appendChild(backdropCmptRef.location.nativeElement);
      return backdropCmptRef;
    }
    attachWindowComponent(projectableNodes) {
      const windowCmptRef = createComponent(ModalWindowComponent, {
        environmentInjector: this.applicationRef.injector,
        projectableNodes
      });
      this.applicationRef.attachView(windowCmptRef.hostView);
      document.body.appendChild(windowCmptRef.location.nativeElement);
      return windowCmptRef;
    }
    getContentRef(content, activeModal, options) {
      if (content instanceof TemplateRef) {
        return this.getViewRefFromTemplate(content, activeModal);
      } else {
        return this.getViewRefFromComponent(content, activeModal, options);
      }
    }
    getViewRefFromTemplate(content, activeModal) {
      const context = {
        $implicit: activeModal,
        close(result) {
          activeModal.close(result);
        },
        dismiss() {
          activeModal.dismiss();
        }
      };
      const viewRef = content.createEmbeddedView(context);
      this.applicationRef.attachView(viewRef);
      return new ContentRef([viewRef.rootNodes], viewRef);
    }
    getViewRefFromComponent(content, activeModal, options) {
      const elementInjector = Injector.create({
        providers: [{
          provide: ActiveModal,
          useValue: activeModal
        }]
      });
      const componentRef = createComponent(content, {
        environmentInjector: this.applicationRef.injector,
        elementInjector
      });
      const componentNativeEl = componentRef.location.nativeElement;
      if (options.scrollable) {
        componentNativeEl.classList.add('component-host-scrollable');
      }
      this.applicationRef.attachView(componentRef.hostView);
      return new ContentRef([[componentNativeEl]], componentRef.hostView, componentRef);
    }
    setAriaHidden(element) {
      const parent = element.parentElement;
      if (parent && element !== document.body) {
        Array.from(parent.children).forEach(sibling => {
          if (sibling !== element && sibling.nodeName !== 'SCRIPT') {
            this.ariaHiddenValues.set(sibling, sibling.ariaHidden);
            sibling.ariaHidden = 'true';
          }
        });
        this.setAriaHidden(parent);
      }
    }
    revertAriaHidden() {
      this.ariaHiddenValues.forEach((value, element) => {
        if (value) {
          element.setAttribute('aria-hidden', value);
        } else {
          element.removeAttribute('aria-hidden');
        }
      });
      this.ariaHiddenValues.clear();
    }
    registerModalRef(modalRef) {
      const unregisterModalRef = () => {
        const index = this.modalRefs.indexOf(modalRef);
        if (index > -1) {
          this.modalRefs.splice(index, 1);
        }
      };
      this.modalRefs.push(modalRef);
      modalRef.result.then(unregisterModalRef, unregisterModalRef);
    }
    registerWindowCmpt(windowCmpt) {
      this.windowCmpts.push(windowCmpt);
      this.activeWindowCmptHasChanged.next(null);
      windowCmpt.onDestroy(() => {
        const index = this.windowCmpts.indexOf(windowCmpt);
        if (index > -1) {
          this.windowCmpts.splice(index, 1);
          this.activeWindowCmptHasChanged.next(null);
        }
      });
    }
    focusTrap(zone, element, stopFocusTrap$, refocusOnClick = false) {
      zone.runOutsideAngular(() => {
        const lastFocusedElement$ = fromEvent(element, 'focusin').pipe(takeUntil(stopFocusTrap$), map(e => e.target));
        fromEvent(element, 'keydown').pipe(takeUntil(stopFocusTrap$), filter(e => e.key === 'Tab'), withLatestFrom(lastFocusedElement$)).subscribe(([tabEvent, focusedElement]) => {
          const [first, last] = getFocusableBoundaryElements(element);
          if ((focusedElement === first || focusedElement === element) && tabEvent.shiftKey) {
            last.focus();
            tabEvent.preventDefault();
          }
          if (focusedElement === last && !tabEvent.shiftKey) {
            first.focus();
            tabEvent.preventDefault();
          }
        });
        if (refocusOnClick) {
          fromEvent(element, 'click').pipe(takeUntil(stopFocusTrap$), withLatestFrom(lastFocusedElement$), map(arr => arr[1])).subscribe(lastFocusedElement => lastFocusedElement.focus());
        }
      });
    }
    activeModals() {
      return [...this.modalRefs];
    }
    dismissAll() {
      this.modalRefs.forEach(ngbModalRef => ngbModalRef.dismiss());
    }
    hasOpenModals() {
      return this.modalRefs.length > 0;
    }
    static {
      this.ɵfac = function ModalStackService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalStackService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModalStackService,
        factory: ModalStackService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModalStackService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalService = /*#__PURE__*/(() => {
  class ModalService {
    constructor() {
      this.modalStackService = inject(ModalStackService);
    }
    open(content, options = {}) {
      return this.modalStackService.open(content, options);
    }
    activeModals() {
      return this.modalStackService.activeModals();
    }
    dismissAll() {
      this.modalStackService.dismissAll();
    }
    hasOpenModals() {
      return this.modalStackService.hasOpenModals();
    }
    static {
      this.ɵfac = function ModalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModalService,
        factory: ModalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExportService = /*#__PURE__*/(() => {
  class ExportService {
    exportCSV(fields, values, name = 'export') {
      let csv = '\ufeff';
      // headers
      let first = true;
      for (const field of fields) {
        if (!first) {
          csv += ',';
        } else {
          first = false;
        }
        csv += '"' + field + '"';
      }
      // body
      for (const value of values) {
        csv += '\n';
        first = true;
        for (const field of fields) {
          if (!first) {
            csv += ',';
          } else {
            first = false;
          }
          let cellData = get(value, field);
          cellData = String(cellData).replace(/"/g, '""');
          csv += '"' + cellData + '"';
        }
      }
      this.createDownloadableFile('text/csv;charset=utf-8', name, csv);
    }
    exportCsvForExcel(fields, values, name = 'export') {
      let csv = '\ufeff';
      // headers
      let first = true;
      for (const field of fields) {
        if (!first) {
          csv += ';';
        } else {
          first = false;
        }
        csv += '"' + field + '"';
      }
      // body
      for (const value of values) {
        csv += '\n';
        first = true;
        for (const field of fields) {
          if (!first) {
            csv += ';';
          } else {
            first = false;
          }
          let cellData = get(value, field);
          cellData = String(cellData).replace(/"/g, '""');
          csv += '"' + cellData + '"';
        }
      }
      this.createDownloadableFile('text/csv;charset=utf-8', name, csv);
    }
    exportJson(fields, values, name = 'export') {
      const mapValues = [];
      for (const value of values) {
        const mapValue = {};
        for (const field of fields) {
          set(mapValue, field, get(value, field));
        }
        mapValues.push(mapValue);
      }
      const json = JSON.stringify(mapValues);
      this.createDownloadableFile('application/json;charset=utf-8', name, json);
    }
    createDownloadableFileFromHttpResponse(response, defaultName) {
      if (response.body) {
        this.createDownloadableFile(response.headers.get('content-type') ?? 'application/octet-stream', response.headers.get('content-disposition')?.replace(/.*filename=/g, '').replace(/"/g, '').trim() ?? defaultName, response.body);
      }
    }
    createDownloadableFile(mimeType, name, ...blobParts) {
      if (!blobParts.length) {
        return;
      }
      const blob = new Blob(blobParts, {
        type: mimeType
      });
      this.createDownloadableFileFromBlob(name, blob);
    }
    createDownloadableFileFromBlob(name, blob) {
      if (!name) {
        name = 'export.txt';
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.navigator.msSaveOrOpenBlob) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        navigator.msSaveOrOpenBlob(blob, name);
      } else {
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        if (link.download !== undefined) {
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', name);
          link.click();
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            window.open(reader.result);
          };
        }
        document.body.removeChild(link);
      }
    }
    static {
      this.ɵfac = function ExportService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ExportService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ExportService,
        factory: ExportService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ExportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TablePagePipe = /*#__PURE__*/(() => {
  class TablePagePipe {
    transform(value, pageSize, page) {
      if (pageSize <= 0 || page <= 0) {
        return value;
      }
      return value.slice((page - 1) * pageSize, pageSize * page);
    }
    static {
      this.ɵfac = function TablePagePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TablePagePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tablePage",
        type: TablePagePipe,
        pure: true
      });
    }
  }
  return TablePagePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableComponent = /*#__PURE__*/(() => {
  class TableComponent {
    constructor() {
      this.exportService = inject(ExportService);
      this.Math = Math;
      this.id = uuid();
      this.title = '';
      this.titleClass = input('h2');
      this.sticky = input(false);
      this.loading = input(false);
      this.tableClass = input('');
      this.tableData = input.required();
      this.columns = input.required();
      this.processedColumns = [];
      this.values = input.required();
      this.selectedPageSize = 0;
      this.pageSizes = [0];
      this.resultNumbers = input(false);
      this.additionalNavigationAtTop = input(false);
      this.searchType = input('GENERAL');
      this.search = input(false);
      this.sort = input(false);
      this.defaultSortField = input('');
      this.defaultSortDesc = input(false);
      this.altValueMapper = input();
      this.trClickEmitter = new Subject();
      this.trClick = outputFromObservable(this.trClickEmitter);
      this.trAuxClickEmitter = new Subject();
      this.trAuxClick = outputFromObservable(this.trAuxClickEmitter);
      this.trClass = input('');
      this.hideColumns = input(false);
      this.hiddenColumns = [];
      this.buttons = input();
      this.export = input(false);
      this.currentPage = 1;
      this.generalSearchInput = '';
      this.initSearch = input({});
      this.searchInputs = {};
      this.outputValues = [];
      this.filteredChanged = output();
      this.newFilterName = '';
      this.altValueMap = new Map();
      this.initialized = false;
    }
    ngOnInit() {
      this.resetFilter(true);
      if (!this.pageSizes.includes(this.selectedPageSize)) {
        this.selectedPageSize = this.pageSizes[0];
      }
      this.sortField = this.defaultSortField();
      this.desc = this.defaultSortDesc();
      this.processedColumns = cloneDeep(this.columns());
      this.initialized = true;
      this.refreshOutputValues();
      if (!this.hiddenColumns || this.hiddenColumns.length === 0) {
        this.loadHiddenColumns();
      }
    }
    ngOnChanges() {
      if (this.initialized) {
        const columns = this.columns();
        if (!isEqual(columns, this.processedColumns)) {
          this.processedColumns = cloneDeep(columns);
          this.resetFilter(true);
        }
        this.refreshOutputValues();
      }
    }
    resetFilter(empty = false) {
      for (const column of this.columns()) {
        if (column.name) {
          if (empty) {
            set(this.searchInputs, column.name, '');
            continue;
          }
          let init = get(this.initSearch(), column.name) ?? '';
          if (column.selections) {
            const selectionValues = column.selections.map(selection => selection.value);
            if (column.multipleSelections) {
              init = init.split(';').filter(value => selectionValues.includes(value)).join(';');
            } else {
              if (!selectionValues.includes(init)) {
                init = '';
              }
            }
          }
          set(this.searchInputs, column.name, init ?? '');
        }
      }
    }
    getUniqueTableId() {
      let id = window.location.host + '+' + window.location.pathname.replace(/^\/([^/]*).*$/, '$1');
      for (const column of this.columns()) {
        if (column.name && column.type) {
          id += '+' + column.name;
        }
      }
      return id;
    }
    saveHiddenColumns() {
      localStorage.setItem(this.getUniqueTableId() + '-hiddenColumns', JSON.stringify(this.hiddenColumns));
    }
    loadHiddenColumns() {
      const json = localStorage.getItem(this.getUniqueTableId() + '-hiddenColumns');
      if (json) {
        const hideableColumns = this.getHideableColumns();
        this.hiddenColumns = JSON.parse(json).filter(columnName => hideableColumns.includes(columnName));
      }
    }
    loadAvailableFilter() {
      const json = localStorage.getItem(this.getUniqueTableId() + '-filter');
      if (json) {
        const filters = JSON.parse(json);
        if (filters) {
          return Object.keys(filters).filter(s => s);
        }
      }
      return [];
    }
    loadFilter(name) {
      const json = localStorage.getItem(this.getUniqueTableId() + '-filter');
      if (json) {
        const filters = JSON.parse(json);
        if (filters) {
          const filter = get(filters, name);
          if (filter) {
            this.resetFilter(true);
            for (const key of Object.keys(filter)) {
              const value = get(filter, key);
              if (value) {
                this.searchInputs[key] = value;
              }
            }
          }
        }
      }
      this.refreshOutputValues();
    }
    deleteFilter(name) {
      const json = localStorage.getItem(this.getUniqueTableId() + '-filter');
      if (json) {
        const filters = JSON.parse(json);
        set(filters, name, undefined);
        localStorage.setItem(this.getUniqueTableId() + '-filter', JSON.stringify(filters));
      }
    }
    saveFilter() {
      const json = localStorage.getItem(this.getUniqueTableId() + '-filter') ?? '{}';
      const filters = JSON.parse(json);
      const filter = {};
      for (const key of Object.keys(this.searchInputs)) {
        const value = get(this.searchInputs, key);
        if (value) {
          set(filter, key, value);
        }
      }
      set(filters, this.newFilterName, filter);
      localStorage.setItem(this.getUniqueTableId() + '-filter', JSON.stringify(filters));
      this.newFilterName = '';
    }
    getVisibleColumns() {
      return this.columns().filter(column => !this.hideColumns() || !column.type || !column.name || !this.hiddenColumns.includes(column.name));
    }
    getHideableColumns() {
      return this.columns().filter(column => column.name && column.type).map(column => column.name);
    }
    getHiddenColumns() {
      return this.columns().filter(column => column.name && column.type).map(column => column.name).filter(name => this.hiddenColumns.includes(name));
    }
    hideColumn(field) {
      if (this.hiddenColumns.includes(field)) {
        this.hiddenColumns = this.hiddenColumns.filter(hiddenField => hiddenField !== field);
      } else {
        this.hiddenColumns.push(field);
        this.hiddenColumns = cloneDeep(this.hiddenColumns);
      }
      this.saveHiddenColumns();
    }
    changeFilterOption(column, optionValue) {
      if (column.name && column.selections) {
        const currentOptions = this.searchInputs[column.name].split(';').filter(s => s);
        if (currentOptions.includes(optionValue)) {
          this.searchInputs[column.name] = currentOptions.filter(value => value !== optionValue).join(';');
        } else {
          currentOptions.push(optionValue);
          this.searchInputs[column.name] = currentOptions.length === column.selections?.length ? '' : currentOptions.join(';');
        }
      }
    }
    getTableMinHeight() {
      if (this.search() && this.searchType() === 'SEPARATE') {
        const maxSelections = this.columns().filter(column => column.multipleSelections).map(column => column.selections?.length ?? 0).sort().reverse()[0] ?? 0;
        return maxSelections * 32 + 163 + 'px';
      }
      return undefined;
    }
    getPageNumber() {
      return Math.ceil(this.outputValues.length / this.selectedPageSize);
    }
    pageChange(page) {
      this.currentPage = page;
    }
    setSortField(event, column) {
      if (!column.type || column.type.endsWith('[]')) {
        return;
      }
      if (this.sortField === column.field) {
        if (this.desc) {
          this.sortField = '';
          this.desc = false;
        } else {
          this.desc = true;
        }
      } else {
        if (column.type) {
          this.sortField = column.field;
          this.desc = false;
        }
      }
      this.refreshOutputValues();
      event.stopImmediatePropagation();
    }
    prepareTableForOutputValues(values) {
      const newPageNumber = Math.ceil(values.length / this.selectedPageSize);
      if (this.currentPage > newPageNumber) {
        this.currentPage = Math.max(newPageNumber, 1);
      }
      return values;
    }
    mapValue(v) {
      let value = v;
      const altValueMapper = this.altValueMapper();
      if (altValueMapper && !this.altValueMap.get(v)) {
        this.altValueMap.set(v, altValueMapper(cloneDeep(v)));
      }
      if (altValueMapper) {
        value = this.altValueMap.get(v);
      }
      return value;
    }
    refreshOutputValues() {
      const values = this.values();
      if (!values) {
        this.outputValues = this.prepareTableForOutputValues([]);
        this.filteredChanged.emit(this.outputValues);
        return;
      }
      if (!this.search()) {
        this.outputValues = this.prepareTableForOutputValues(this.sortValues(values));
        this.filteredChanged.emit(this.outputValues);
        return;
      }
      const searchType = this.searchType();
      if (searchType === 'SEPARATE') {
        const columns = [];
        for (const column of this.columns()) {
          if (column.type && column.name && (get(this.searchInputs, column.name).length > 1 || (column.type === 'number' || column.type === 'short-string') && get(this.searchInputs, column.name).length > 0)) {
            columns.push(column);
          }
        }
        if (columns.length > 0) {
          this.outputValues = this.prepareTableForOutputValues(this.sortValues(values.filter(v => {
            const value = this.mapValue(v);
            for (const column of columns) {
              const field = column.field;
              if (!field || !column.name) {
                return false;
              }
              const fieldValue = get(value, field);
              if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
                return false;
              }
              switch (column.type) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                case 'short-string':
                  {
                    const filter = get(this.searchInputs, column.name).toLowerCase();
                    if (filter?.replace(' ', '').match(/^(([a-z]-)?[a-z],)*([a-z]-)?[a-z]$/g)) {
                      const parts = filter.replace(' ', '').split(',');
                      const letters = [];
                      for (const part of parts) {
                        if (part.length === 3) {
                          for (let i = part.charCodeAt(0); i <= part.charCodeAt(2); i++) {
                            letters.push(String.fromCharCode(i));
                          }
                        } else {
                          letters.push(part.charAt(0));
                        }
                      }
                      if (!letters.includes(fieldValue.trim().charAt(0).toLowerCase())) {
                        return false;
                      }
                      break;
                    }
                  }
                // eslint-disable-next-line no-fallthrough
                case 'string':
                  if (column.selections && column.multipleSelections) {
                    if (!get(this.searchInputs, column.name).toLowerCase().split(';').includes(fieldValue.toLowerCase())) {
                      return false;
                    }
                  } else if (!fieldValue.toLowerCase().includes(get(this.searchInputs, column.name).toLowerCase())) {
                    return false;
                  }
                  break;
                case 'Date':
                  if (!ObjectSearchPipe.checkDate(fieldValue, get(this.searchInputs, column.name))) {
                    return false;
                  }
                  break;
                case 'string[]':
                  {
                    let contains = false;
                    const arr = Array.isArray(fieldValue) ? Array.from(fieldValue) : Array.of(fieldValue);
                    for (const a of arr) {
                      if (a?.toLowerCase().includes(get(this.searchInputs, column.name).toLowerCase())) {
                        contains = true;
                      }
                    }
                    if (!contains) {
                      return false;
                    }
                    break;
                  }
                case 'boolean':
                  {
                    const searchInput = get(this.searchInputs, column.name).toLowerCase();
                    const searchValue = searchInput === 'ja' || searchInput === 'yes' || searchInput === 'true' ? 'true' : 'false';
                    if (String(fieldValue).toLowerCase() !== searchValue) {
                      return false;
                    }
                    break;
                  }
                default:
                  if (column.selections && column.multipleSelections) {
                    if (!get(this.searchInputs, column.name).toLowerCase().split(';').includes(String(fieldValue).toLowerCase())) {
                      return false;
                    }
                  } else if (String(fieldValue).toLowerCase() !== get(this.searchInputs, column.name).toLowerCase()) {
                    return false;
                  }
              }
            }
            return true;
          })));
        } else {
          this.outputValues = this.prepareTableForOutputValues(this.sortValues(values));
        }
        this.filteredChanged.emit(this.outputValues);
        return;
      }
      if (searchType === 'GENERAL' && this.generalSearchInput.length > 1) {
        const columns = [];
        for (const column of this.columns()) {
          if (column.type && (this.generalSearchInput.length > 1 || (column.type === 'number' || column.type === 'short-string') && this.generalSearchInput.length > 0)) {
            columns.push(column);
          }
        }
        if (columns.length > 0) {
          this.outputValues = this.prepareTableForOutputValues(this.sortValues(values.filter(v => {
            const value = this.mapValue(v);
            for (const column of columns) {
              const field = column.field;
              if (!field) {
                continue;
              }
              const fieldValue = get(value, field);
              if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
                continue;
              }
              switch (column.type) {
                case 'string':
                case 'short-string':
                  if (fieldValue.toLowerCase().includes(this.generalSearchInput.toLowerCase())) {
                    return true;
                  }
                  break;
                case 'Date':
                  if (ObjectSearchPipe.checkDate(fieldValue, this.generalSearchInput)) {
                    return true;
                  }
                  break;
                case 'string[]':
                  {
                    const arr = Array.isArray(fieldValue) ? Array.from(fieldValue) : Array.of(fieldValue);
                    for (const a of arr) {
                      if (a.toLowerCase().includes(this.generalSearchInput.toLowerCase())) {
                        return true;
                      }
                    }
                    break;
                  }
                case 'boolean':
                  {
                    const searchInput = this.generalSearchInput.toLowerCase();
                    const searchValue = searchInput === 'ja' || searchInput === 'yes' || searchInput === 'true' ? 'true' : 'false';
                    if (String(fieldValue).toLowerCase() === searchValue) {
                      return true;
                    }
                    break;
                  }
                default:
                  if (String(fieldValue).toLowerCase() === this.generalSearchInput.toLowerCase()) {
                    return true;
                  }
              }
            }
            return false;
          })));
        } else {
          this.outputValues = this.prepareTableForOutputValues(this.sortValues(values));
        }
        this.filteredChanged.emit(this.outputValues);
        return;
      }
      this.outputValues = this.prepareTableForOutputValues(this.sortValues(values));
      this.filteredChanged.emit(this.outputValues);
    }
    sortValues(values) {
      if (!this.sort() || !this.sortField) {
        return values;
      }
      const field = this.sortField;
      const fieldColumn = this.columns().find(column => column.field === field);
      const defaultField = this.defaultSortField();
      const defaultFieldColumn = this.columns().find(column => column.field === defaultField);
      return uniq(values).sort((a, b) => {
        let aObject = a;
        let bObject = b;
        const altValueMapper = this.altValueMapper();
        if (altValueMapper && !this.altValueMap.get(a)) {
          this.altValueMap.set(a, altValueMapper(cloneDeep(a)));
        }
        if (altValueMapper && !this.altValueMap.get(b)) {
          this.altValueMap.set(b, altValueMapper(cloneDeep(b)));
        }
        if (altValueMapper) {
          aObject = this.altValueMap.get(a) ?? aObject;
          bObject = this.altValueMap.get(b) ?? bObject;
        }
        let aValue = get(aObject, field);
        let bValue = get(bObject, field);
        if (fieldColumn && (fieldColumn.type === 'string' || fieldColumn.type === 'short-string')) {
          if (aValue) {
            aValue = aValue.toLowerCase();
          }
          if (bValue) {
            bValue = bValue.toLowerCase();
          }
        }
        /*
        if (fieldColumn && fieldColumn.type === 'string[]') {
          let lowestValue = '';
          if (aValue) {
            for (const value of aValue) {
              if (!lowestValue && value && value.toLowerCase() < lowestValue) {
                lowestValue = value;
              }
            }
          }
          aValue = lowestValue;
          lowestValue = '';
          if (bValue) {
            for (const value of bValue) {
              if (!lowestValue && value && value.toLowerCase() < lowestValue) {
                lowestValue = value;
              }
            }
          }
          bValue = lowestValue;
        }
        */
        if (this.desc && aValue > bValue || !this.desc && aValue < bValue) {
          return -1;
        }
        if (this.desc && aValue < bValue || !this.desc && aValue > bValue) {
          return 1;
        }
        let aDefaultValue = get(aObject, defaultField);
        let bDefaultValue = get(bObject, defaultField);
        if (defaultFieldColumn && (defaultFieldColumn.type === 'string' || defaultFieldColumn.type === 'short-string')) {
          if (aValue) {
            aDefaultValue = aDefaultValue.toLowerCase();
          }
          if (bValue) {
            bDefaultValue = bDefaultValue.toLowerCase();
          }
        }
        /* if (defaultFieldColumn && defaultFieldColumn.type === 'string[]') {
          let lowestValue = '';
          if (aDefaultValue) {
            for (const value of aDefaultValue) {
              if (!lowestValue && value && value.toLowerCase() < lowestValue) {
                lowestValue = value;
              }
            }
          }
          aDefaultValue = lowestValue;
          lowestValue = '';
          if (bDefaultValue) {
            for (const value of bDefaultValue) {
              if (!lowestValue && value && value.toLowerCase() < lowestValue) {
                lowestValue = value;
              }
            }
          }
          bDefaultValue = lowestValue;
        } */
        const defaultSortDesc = this.defaultSortDesc();
        if (defaultSortDesc && aDefaultValue > bDefaultValue || !defaultSortDesc && aDefaultValue < bDefaultValue) {
          return -1;
        }
        if (defaultSortDesc && aDefaultValue < bDefaultValue || !defaultSortDesc && aDefaultValue > bDefaultValue) {
          return 1;
        }
        return 0;
      });
    }
    getDataColumns() {
      return this.columns().filter(column => column.type);
    }
    exportCSV() {
      this.exportService.exportCSV(this.getDataColumns().map(column => column.field).filter(s => s), this.outputValues?.map(value => this.altValueMapper()?.(cloneDeep(value)) ?? value) ?? []);
    }
    exportCsvForExcel() {
      this.exportService.exportCsvForExcel(this.getDataColumns().map(column => column.field).filter(s => s), this.outputValues?.map(value => this.altValueMapper()?.(cloneDeep(value)) ?? value) ?? []);
    }
    exportJson() {
      this.exportService.exportJson(this.getDataColumns().map(value => value.field).filter(s => s), this.outputValues?.map(value => this.altValueMapper()?.(cloneDeep(value)) ?? value) ?? []);
    }
    exportPrint() {
      const frame = get(window.frames, 'print_frame');
      if (frame) {
        const columns = this.getDataColumns();
        frame.document.body.innerHTML = '<table>\n' + '  <thead>\n' + '  <tr>\n' + columns.map(column => '    <th>\n' + '      ' + column.name + '\n' + '    </th>\n').join('\n') + '  </tr>\n' + '  </thead>\n' + '  <tbody>\n' + (this.outputValues?.map(value => this.altValueMapper()?.(cloneDeep(value)) ?? value) ?? []).map(value => '  <tr>\n' + columns.map(column => '    <td>' + get(value, column.field ?? '') + '</td>\n').join('\n') + '  </tr>\n').join('\n') + '  </tbody>\n' + '</table>';
        const table = frame.document.body.querySelector('table');
        if (table) {
          table.style.fontSize = '11pt';
          table.style.fontVariantNumeric = 'tabular-nums';
          table.style.fontFamily = 'rbb V2 Interstate, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji';
          table.style.fontWeight = '300';
        }
        frame.document.body.querySelectorAll('.no-print').forEach(element => element.remove());
        frame.document.body.querySelectorAll('td').forEach(element => {
          element.style.borderWidth = '0';
          element.style.borderTopWidth = '2px';
          element.style.borderStyle = 'solid';
          element.style.borderColor = '#000000';
        });
        frame.window.focus();
        frame.window.print();
        frame.document.body.innerHTML = '';
      }
    }
    static {
      this.ɵfac = function TableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TableComponent,
        selectors: [["rbb-table"]],
        inputs: {
          title: "title",
          titleClass: [1, "titleClass"],
          sticky: [1, "sticky"],
          loading: [1, "loading"],
          tableClass: [1, "tableClass"],
          tableData: [1, "tableData"],
          columns: [1, "columns"],
          values: [1, "values"],
          selectedPageSize: "selectedPageSize",
          pageSizes: "pageSizes",
          resultNumbers: [1, "resultNumbers"],
          additionalNavigationAtTop: [1, "additionalNavigationAtTop"],
          searchType: [1, "searchType"],
          search: [1, "search"],
          sort: [1, "sort"],
          defaultSortField: [1, "defaultSortField"],
          defaultSortDesc: [1, "defaultSortDesc"],
          altValueMapper: [1, "altValueMapper"],
          responsiveBreakpoint: "responsiveBreakpoint",
          trClass: [1, "trClass"],
          hideColumns: [1, "hideColumns"],
          hiddenColumns: "hiddenColumns",
          buttons: [1, "buttons"],
          export: [1, "export"],
          initSearch: [1, "initSearch"]
        },
        outputs: {
          trClick: "trClick",
          trAuxClick: "trAuxClick",
          filteredChanged: "filteredChanged"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 20,
        vars: 24,
        consts: [["tableElement", ""], ["tableHead", ""], [1, "d-flex", "align-items-lg-start", "align-items-center", "justify-content-lg-end", "flex-lg-row", "flex-column", "gap-3"], [3, "class", "id"], [1, "d-flex", "flex-wrap", "justify-content-lg-end", "justify-content-center", "gap-2", "mb-3"], [1, "dropdown"], [1, "input-group", "input-group-sm", "mb-3"], [1, "d-flex", "align-items-center", "justify-content-lg-between", "justify-content-center", "flex-lg-row-reverse", "flex-column"], [1, "mb-5", 3, "ngClass"], [1, "scroll-wrapper"], [1, "table", "table-sm", "table-hover", 3, "id", "ngClass"], [1, "text-center"], ["ariaLabel", "Tabellenseiten", 3, "currentPage", "pages", "ariaControls"], ["role", "meter", 1, "mb-3", "small"], ["name", "print_frame", "src", "about:blank", "aria-hidden", "true"], [3, "id"], [1, "input-group", "input-group-sm"], [1, "input-group-text", 3, "for"], ["aria-label", "Anzahl der gleichzeitig angezeigten Tabelleneintr\xE4ge", 1, "form-select", 3, "ngModelChange", "id", "ngModel"], [3, "ngValue"], ["type", "button", "data-bs-toggle", "dropdown", "data-bs-auto-close", "outside", 1, "btn", "btn-sm", "btn-outline-secondary", "dropdown-toggle", 3, "id"], [1, "fa-solid", "fa-columns"], [1, "dropdown-menu", "px-4", "py-2", "dropdown-menu-sm-end"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "id", "checked"], [1, "form-check-label", 3, "for"], ["type", "button", "data-bs-toggle", "dropdown", 1, "btn", "btn-sm", "btn-outline-secondary", "dropdown-toggle", 3, "id"], [1, "fa-solid", "fa-file-export"], [1, "dropdown-menu", "dropdown-menu-sm-end"], [1, "dropdown-item", 3, "click"], [1, "fa-regular", "fa-file-excel"], [1, "fa-regular", "fa-file-code"], [1, "fa-regular", "fa-file-pdf"], [1, "fa-solid", "fa-filter"], [1, "dropdown-header"], [1, "dropdown-item", "pointer"], [1, "dropdown-item", "pointer", 3, "click"], [1, "dropdown-divider"], [1, "input-group", "input-group-sm", "px-3", "py-2"], ["type", "text", "name", "filterSave", "placeholder", "Name", "aria-label", "Filtername", 1, "form-control", 3, "ngModelChange", "id", "ngModel"], ["aria-label", "Filtereinstellungen speichern", 1, "btn", "btn-primary", 3, "click", "disabled"], [1, "fa-solid", "fa-save"], [1, "small", "text-secondary", "px-3", 3, "id"], [1, "fas", "fa-info", "pe-1"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Filter l\xF6schen", "tabindex", "0", 1, "fa-solid", "fa-times", "d-inline-block", "pointer", 3, "click", "keydown.enter", "keydown.space"], ["type", "button", 1, "btn", "btn-sm", 3, "click"], [1, "me-2", 3, "class"], [1, "me-2"], [1, "fa-solid", "fa-search"], ["type", "text", "name", "generalSearch", "placeholder", "in der Tabelle suchen", "aria-label", "Suche in der Tabelle", 1, "form-control", 3, "ngModelChange", "id", "ngModel"], ["ariaLabel", "Tabellenseiten", 3, "pageChange", "currentPage", "pages", "ariaControls"], [1, "fw-bold", "text-secondary"], [1, "form-group", "my-1"], [1, "input-group-text", "same-prepend-width", 3, "for"], [1, "form-select", "form-select-sm", 3, "id", "name", "ngModel"], ["type", "button", "data-bs-toggle", "dropdown", "data-bs-auto-close", "outside", 1, "btn", "btn-sm", "btn-outline-secondary", "dropdown-toggle", "flex-grow-1", "text-start", 3, "id"], [1, "dropdown-menu", "dropdown-menu-sm-start"], [1, "icon-width", 3, "ngClass"], [1, "form-select", "form-select-sm", 3, "ngModelChange", "id", "name", "ngModel"], ["type", "text", 1, "form-control", "form-control-sm", 3, "ngModelChange", "id", "name", "ngModel"], [1, "input-group-text"], [3, "value"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Es kann nach dem Anfangsbuchstaben gefiltert werden z.B.: a-c,f,k-m", 1, "fa-solid", "fa-question-circle", "d-inline-block", "text-secondary"], ["aria-description", "Enter oder Leertaste benutzen um die Tabelle nach dieser Spalte zu sortieren.", 3, "id", "ngClass", "tabindex", "width"], [1, "no-print"], [3, "class", "tabIndex"], ["aria-description", "Enter oder Leertaste benutzen um die Tabelle nach dieser Spalte zu sortieren.", 3, "click", "keydown.space", "keydown.enter", "id", "ngClass", "tabindex"], ["data-bs-toggle", "tooltip", "data-bs-placement", "right", 1, "fa-regular", "fa-question-circle", "text-secondary", "d-inline-block", "ms-2", 3, "title"], [1, "d-inline-block", "text-secondary", "fa-solid", "fa-sort", "no-print"], ["role", "status", 1, "d-inline-block", "text-secondary", "fa-solid", "no-print", 3, "ngClass"], [3, "width"], [1, "dropdown", "d-inline-block"], [1, "form-select", "form-select-sm", 3, "min-width", "id", "name", "ngModel"], ["type", "text", 1, "form-control", 3, "ngModelChange", "id", "name", "ngModel"], [3, "keydown.enter", "mousedown", "click", "auxclick", "tabIndex"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["name", "print_frame", "src", i0.ɵɵtrustConstantResourceUrl`about:blank`, "aria-hidden", "true"]],
        template: function TableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, TableComponent_Conditional_1_Template, 2, 5, "h2", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵtemplate(3, TableComponent_Conditional_3_Template, 7, 4, "div")(4, TableComponent_Conditional_4_Template, 7, 4, "div", 5)(5, TableComponent_Conditional_5_Template, 21, 2, "div", 5)(6, TableComponent_Conditional_6_Template, 22, 7, "div", 5);
            i0.ɵɵrepeaterCreate(7, TableComponent_For_8_Template, 4, 4, "div", null, _forTrack0);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, TableComponent_Conditional_9_Template, 5, 4, "div", 6)(10, TableComponent_Conditional_10_Template, 3, 2, "div", 7)(11, TableComponent_Conditional_11_Template, 5, 1, "div", 8);
            i0.ɵɵelementStart(12, "div", 9);
            i0.ɵɵtemplate(13, TableComponent_Conditional_13_Template, 12, 10, "table", 10)(14, TableComponent_Conditional_14_Template, 2, 0, "div", 11)(15, TableComponent_Conditional_15_Template, 2, 0, "div", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 7);
            i0.ɵɵtemplate(17, TableComponent_Conditional_17_Template, 1, 3, "rbb-paginator", 12)(18, TableComponent_Conditional_18_Template, 3, 2, "div", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(19, TableComponent_Conditional_19_Template, 1, 0, "iframe", 14);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("justify-content-lg-end", !ctx.title)("justify-content-lg-between", ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.title ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.pageSizes.length > 1 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hideColumns() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.export() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.search() && ctx.searchType() === "SEPARATE" ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.buttons());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.search() && ctx.searchType() === "GENERAL" ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.additionalNavigationAtTop() ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.responsiveBreakpoint && ctx.search() && ctx.searchType() === "SEPARATE" ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("min-height", ctx.getTableMinHeight());
            i0.ɵɵclassProp("sticky", ctx.sticky());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.columns() && ctx.values() ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading() ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.outputValues.length && !ctx.loading() ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("d-none", ctx.loading());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectedPageSize && ctx.currentPage ? 17 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.resultNumbers() ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.export() ? 19 : -1);
          }
        },
        dependencies: [FormsModule, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.DefaultValueAccessor, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.NgModel, PaginatorComponent, NgClass, NgTemplateOutlet, LoaderComponent, TablePagePipe],
        styles: ["iframe[_ngcontent-%COMP%]{height:0;width:0;border-width:0}.icon-width[_ngcontent-%COMP%]{display:inline-block;width:25px}.scroll-wrapper.sticky[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{position:sticky;z-index:1020;top:52px}.scroll-wrapper.sticky[_ngcontent-%COMP%]{overflow-x:visible}@media print{*[_ngcontent-%COMP%], .no-print[_ngcontent-%COMP%]{display:none}tr[_ngcontent-%COMP%]{border-top-width:1px;border-style:solid;border-color:#000}}"]
      });
    }
  }
  return TableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SettingComponent = /*#__PURE__*/(() => {
  class SettingComponent {
    constructor() {
      this.route = inject(ActivatedRoute);
      this.settingService = inject(SettingService);
      this.browserMessageService = inject(BrowserMessagesService);
      this.modalService = inject(ModalService);
      this.initShow = true;
      this.loading = false;
      this.settings = [];
      this.settingListColumns = [{
        name: 'Name',
        field: 'name',
        type: 'string'
      }, {
        name: 'Beschreibung',
        field: 'description',
        type: 'string'
      }, {
        name: 'Wert',
        field: 'value',
        type: null
      }, {
        name: 'Standard',
        field: 'config.defaultValue',
        type: null
      }];
      this.settingModal = viewChild('settingModal');
      this.get = get;
      this.isEqual = isEqual;
    }
    ngOnInit() {
      this.route.data.subscribe(data => {
        this.serviceUrls = data['serviceUrls'];
        this.initShow = data['initShow'] !== undefined ? data['initShow'] : true;
        this.getSettings();
      });
      this.getSettings();
    }
    getSettings() {
      if (!this.selectedServiceUrl && this.serviceUrls?.length) {
        this.selectedServiceUrl = this.serviceUrls[0];
      }
      if (this.selectedServiceUrl) {
        this.loading = true;
        this.settingService.getSettings(this.selectedServiceUrl).subscribe({
          next: data => {
            this.settings = data;
            this.loading = false;
          },
          error: err => {
            this.loading = false;
            this.browserMessageService.showHttpError(err, 'Settings konnten nicht geladen werden.');
          }
        });
      }
    }
    getCategories() {
      return uniq(this.settings?.map(setting => setting.category).filter(s => s) ?? []);
    }
    getSettingsByCategory(category) {
      return this.settings?.filter(setting => setting.category === category);
    }
    openModal(setting) {
      this.selectedSetting = cloneDeep(setting);
      const settingModal = this.settingModal();
      if (settingModal) {
        this.settingModalRef = this.modalService.open(settingModal, {
          size: 'lg',
          centered: true
        });
      }
    }
    closeModal() {
      this.settingModalRef?.close();
    }
    updateSetting() {
      if (this.selectedServiceUrl && this.selectedSetting?.key) {
        this.settingService.updateSetting(this.selectedServiceUrl, this.selectedSetting.key, this.selectedSetting.value).subscribe(() => {
          this.getSettings();
          this.closeModal();
        });
      }
    }
    setSettingToDefault() {
      if (this.selectedServiceUrl && this.selectedSetting?.key) {
        this.settingService.setSettingToDefault(this.selectedServiceUrl, this.selectedSetting.key).subscribe(() => {
          this.getSettings();
          this.closeModal();
        });
      }
    }
    static {
      this.ɵfac = function SettingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SettingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SettingComponent,
        selectors: [["rbb-setting"]],
        viewQuery: function SettingComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.settingModal, _c27, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          serviceUrls: "serviceUrls",
          initShow: "initShow"
        },
        decls: 15,
        vars: 1,
        consts: [["settingModal", ""], ["settingValue", ""], ["tableData", ""], ["optionListTemplate", ""], [1, "container-fluid"], ["description", "Einstellungen f\xFCr die Applikation.", "headline", "Einstellungen", "icon", "fas fa-tools"], [1, "input-group", "mb-3"], ["for", "serviceUrl", 1, "input-group-text"], ["id", "serviceUrl", 1, "form-select", 3, "ngModelChange", "ngModel"], [3, "value"], [1, "accordion"], [1, "accordion-item"], [1, "accordion-header", 3, "id"], ["type", "button", "data-bs-toggle", "collapse", 1, "accordion-button"], [1, "accordion-collapse", "collapse", 3, "id"], [1, "accordion-body"], ["trClass", "pointer", "searchType", "SEPARATE", 1, "w-100", 3, "trClick", "columns", "values", "tableData", "pageSizes", "selectedPageSize", "resultNumbers", "search", "sort", "export"], [3, "ngClass"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "modal-header"], [1, "modal-title"], [1, "btn-close", 3, "click"], [1, "modal-body"], [1, "row"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-sm", "btn-success"], ["type", "button", 1, "btn", "btn-sm", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "btn-sm", "btn-secondary", 3, "click"], [1, "col-6", "mb-3"], [1, "d-block", "small", "fw-bold", "text-secondary"], [1, "col-12", "mb-3"], ["for", "settingValue", 1, "d-block", "small", "fw-bold", "text-secondary"], [1, "small", "text-primary", "text-center", "mt-2"], ["id", "settingValue", "name", "value", 1, "form-select", "form-select-sm", 3, "ngModel"], ["id", "settingValue", "type", "number", 1, "form-control", "form-control-sm", 3, "step", "min", "max", "ngModel"], ["id", "settingValue", "type", "text", 1, "form-control", "form-control-sm", 3, "ngModel"], ["prependIcon", "fa-solid fa-list", 3, "ngModel"], ["id", "settingValue", "name", "value", 1, "form-select", "form-select-sm", 3, "ngModelChange", "ngModel"], [3, "ngValue"], ["id", "settingValue", "type", "number", 1, "form-control", "form-control-sm", 3, "ngModelChange", "step", "min", "max", "ngModel"], ["id", "settingValue", "type", "text", 1, "form-control", "form-control-sm", 3, "ngModelChange", "ngModel"], ["prependIcon", "fa-solid fa-list", 3, "ngModelChange", "ngModel"], ["prependIcon", "fa-solid fa-list", 3, "ngModelChange", "ngModel", "values", "itemTemplate"], ["type", "button", 1, "btn", "btn-sm", "btn-success", 3, "click"], [1, "fa-solid", "fa-check", "text-success", "ps"], [1, "fa-solid", "fa-xmark", "text-danger"]],
        template: function SettingComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 4);
            i0.ɵɵelement(1, "rbb-side-menu-headline", 5);
            i0.ɵɵelementStart(2, "div", 6)(3, "label", 7);
            i0.ɵɵtext(4, "Service");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "select", 8);
            i0.ɵɵtwoWayListener("ngModelChange", function SettingComponent_Template_select_ngModelChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedServiceUrl, $event) || (ctx.selectedServiceUrl = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function SettingComponent_Template_select_ngModelChange_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.getSettings());
            });
            i0.ɵɵrepeaterCreate(6, SettingComponent_For_7_Template, 5, 3, "option", 9, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 10);
            i0.ɵɵrepeaterCreate(9, SettingComponent_For_10_Template, 9, 21, "div", 11, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, SettingComponent_ng_template_11_Template, 12, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(13, SettingComponent_ng_template_13_Template, 4, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedServiceUrl);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.serviceUrls);
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.getCategories());
          }
        },
        dependencies: [SideMenuHeadlineComponent, FormsModule, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.DefaultValueAccessor, i1.NumberValueAccessor, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.MinValidator, i1.MaxValidator, i1.NgModel, TableComponent, NgClass, NgTemplateOutlet, MultiValueInputComponent, MultiSelectComponent],
        encapsulation: 2
      });
    }
  }
  return SettingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideMenuComponent = /*#__PURE__*/(() => {
  class SideMenuComponent {
    constructor() {
      this.groups = input.required();
    }
    static {
      this.ɵfac = function SideMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SideMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SideMenuComponent,
        selectors: [["rbb-side-menu"]],
        inputs: {
          groups: [1, "groups"]
        },
        decls: 4,
        vars: 0,
        consts: [[1, "side-menu"], [1, "list-group", "list-group-flush"], [1, "list-group-item", "h5"], ["target", "_blank", 1, "list-group-item", "list-group-item-action", 3, "href"], ["tabindex", "0", "target", "_blank", 1, "list-group-item", "list-group-item-action"], ["target", "_blank", 1, "list-group-item", "list-group-item-action", 3, "disabled", "href"], [1, "side-menu-icon"], [1, "side-menu-text"], ["routerLinkActive", "active", 1, "list-group-item", "list-group-item-action", 3, "routerLink"], [1, "sub-entry", "small"], ["routerLinkActive", "active", 1, "ps-4", "list-group-item", "list-group-item-action", 3, "routerLink"], ["tabindex", "0", "target", "_blank", 1, "list-group-item", "list-group-item-action", 3, "click", "keydown.enter", "keydown.space"]],
        template: function SideMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
            i0.ɵɵrepeaterCreate(2, SideMenuComponent_For_3_Template, 4, 1, null, null, _forTrack0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.groups());
          }
        },
        dependencies: [RouterLinkActive, RouterLink],
        styles: [".disabled[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed!important;background:none!important}[_ngcontent-%COMP%]:not(a.active) + span.sub-entry[_ngcontent-%COMP%]{display:none}@media (max-width: 1199px){.sub-menu[_ngcontent-%COMP%]:not(.collapse)   span.sub-entry[_ngcontent-%COMP%]{display:none}}"]
      });
    }
  }
  return SideMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StepsComponent = /*#__PURE__*/(() => {
  class StepsComponent {
    constructor() {
      this.steps = input.required();
      this.current = input.required();
    }
    clickStep(step) {
      if (!step.disabled && step.func) {
        step.func();
      }
    }
    static {
      this.ɵfac = function StepsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StepsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StepsComponent,
        selectors: [["rbb-steps"]],
        inputs: {
          steps: [1, "steps"],
          current: [1, "current"]
        },
        decls: 4,
        vars: 0,
        consts: [["aria-label", "Schritte"], [3, "ngClass"], [3, "click", "ngClass", "tabindex", "disabled"], [1, "number"], [1, "name"]],
        template: function StepsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav")(1, "ul", 0);
            i0.ɵɵrepeaterCreate(2, StepsComponent_For_3_Template, 6, 16, "li", 1, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.steps());
          }
        },
        dependencies: [NgClass],
        styles: ["ul[_ngcontent-%COMP%]{position:relative;display:flex;list-style-type:none;padding:0}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:center;flex:1 1 0}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\" \";border-top:1px solid var(--bs-secondary);width:100%;top:50%;left:0;display:block;position:absolute;margin-top:-1rem}ul[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%]{opacity:30%}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:inline-flex;flex-direction:column;align-items:center;overflow:hidden;text-decoration:none;border:none;background-color:transparent;font-weight:300}.number[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;background-color:var(--bs-body-bg);border:1px solid var(--bs-secondary);min-width:2rem;height:2rem;font-size:1.143rem;border-radius:50%;z-index:1;text-align:center}.old[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{background-color:var(--bs-secondary);color:#fff}.active[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{background-color:var(--bs-primary);border-color:var(--bs-primary);color:#fff;font-weight:700}.name[_ngcontent-%COMP%]{margin-top:.5rem;display:block;white-space:nowrap}.active[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{font-weight:700;color:var(--bs-primary)}"]
      });
    }
  }
  return StepsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StepsCircleComponent = /*#__PURE__*/(() => {
  class StepsCircleComponent {
    constructor() {
      this.iconClass = input.required();
      this.stepColors = input.required();
      this.tooltip = input();
    }
    generateProgressCircle() {
      const style = window.getComputedStyle(document.body);
      const colors = this.stepColors().map(c => {
        if (c.includes('danger')) {
          return style.getPropertyValue('--bs-danger');
        }
        if (c.includes('warning')) {
          return style.getPropertyValue('--bs-warning');
        }
        if (c.includes('success')) {
          return style.getPropertyValue('--bs-success');
        }
        if (c.includes('secondary')) {
          return style.getPropertyValue('--bs-secondary');
        }
        return c;
      });
      let svg = '<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">';
      if (colors.length) {
        const strokeDashOffset = 295.31 * (366 - 360 / colors.length) / 360;
        for (let i = 0; i < colors.length; i++) {
          svg += `<circle r="47" cx="50" cy="50" fill="transparent" stroke="${colors[i]}" stroke-width="6px" stroke-dasharray="295.31px" stroke-dashoffset="${strokeDashOffset}px" transform="rotate(${i * 360 / colors.length - 87}, 50, 50)"/>`;
        }
      }
      svg += '</svg>';
      return 'url(data:image/svg+xml;base64,' + btoa(svg) + ')';
    }
    static {
      this.ɵfac = function StepsCircleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StepsCircleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StepsCircleComponent,
        selectors: [["rbb-steps-circle"]],
        inputs: {
          iconClass: [1, "iconClass"],
          stepColors: [1, "stepColors"],
          tooltip: [1, "tooltip"]
        },
        decls: 1,
        vars: 7,
        consts: [[1, "d-inline-block", "text-center", 2, "background-position", "center", "background-size", "contain", "background-repeat", "no-repeat", "box-sizing", "content-box", "width", "1em", "height", "1em", "padding", "0.75em", 3, "title"]],
        template: function StepsCircleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "i", 0);
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.iconClass());
            i0.ɵɵstyleProp("background-image", ctx.generateProgressCircle());
            i0.ɵɵproperty("title", ctx.tooltip());
            i0.ɵɵattribute("data-bs-toggle", ctx.tooltip() ? "tooltip" : "")("data-bs-placement", ctx.tooltip() ? "top" : "");
          }
        },
        encapsulation: 2
      });
    }
  }
  return StepsCircleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TreeItemComponent = /*#__PURE__*/(() => {
  class TreeItemComponent {
    constructor() {
      this.isEqual = isEqual;
      this.id = uuid();
      this.subTree = input(false);
      this.foldedIcon = input();
      this.unfoldedIcon = input();
      this.itemIcon = input();
      this.selectOnlyItems = input();
      this.rememberId = input();
      this.search = input('');
      this.parentElement = input();
      this.searchProcessed = '';
      this.itemSelect = output();
      this.unfolded = false;
      this.treeItemElement = viewChild('treeItemElement');
    }
    ngOnInit() {
      if (!this.subTree()) {
        this.unfolded = true;
      }
      if (!this.selected) {
        setTimeout(() => this.loadSelected());
      }
    }
    ngOnChanges() {
      const search = this.search();
      if (search !== this.searchProcessed) {
        this.searchProcessed = search;
        this.unfolded = this.foundInSub(this.treeItem, this.searchProcessed);
      }
      if (!this.treeItem?.item && this.selectedInSub(this.treeItem)) {
        this.unfolded = true;
      }
    }
    saveSelected() {
      const rememberId = this.rememberId();
      if (rememberId) {
        localStorage.setItem('rbb-tree-' + rememberId, JSON.stringify(this.selected));
      }
    }
    loadSelected() {
      const rememberId = this.rememberId();
      if (rememberId && !this.selected) {
        const json = localStorage.getItem('rbb-tree-' + rememberId);
        if (json) {
          this.selected = JSON.parse(json);
          this.itemSelect.emit(this.selected);
        }
      }
    }
    fold() {
      this.unfolded = false;
    }
    unfold() {
      if (!this.treeItem?.item) {
        this.unfolded = true;
      }
    }
    selectedInSub(treeItem) {
      if (treeItem?.children) {
        for (const item of treeItem.children) {
          if (isEqual(item.object, this.selected)) {
            return true;
          }
          if (this.selectedInSub(item)) {
            return true;
          }
        }
      }
      return false;
    }
    foundInSub(treeItem, q) {
      if (q && treeItem?.children) {
        for (const item of treeItem.children) {
          if (item.name?.toLowerCase().includes(q)) {
            return true;
          }
          if (this.foundInSub(item, q)) {
            return true;
          }
        }
      }
      return false;
    }
    selectTreeItem(treeItem) {
      if (this.selectOnlyItems() && !treeItem.item) {
        return;
      }
      this.selectObject(treeItem.object);
    }
    selectObject(item) {
      if (!this.subTree()) {
        this.selected = item;
      }
      this.itemSelect.emit(item);
      this.saveSelected();
    }
    formatSplit(value) {
      let start = 0;
      const indexes = [0];
      const i = value.substring(start).toLowerCase().indexOf(this.searchProcessed);
      if (this.searchProcessed && i !== -1) {
        start += i;
        indexes.push(start);
        start += this.searchProcessed.length;
        indexes.push(start);
      }
      indexes.push(value.length);
      const values = [];
      for (let j = 0; j < indexes.length - 1; j++) {
        values.push(value.substring(indexes[j], indexes[j + 1]));
      }
      return values;
    }
    visibleTreeElements() {
      const treeItemElement = this.treeItemElement();
      if (!treeItemElement?.nativeElement) {
        return [];
      }
      let treeElement = treeItemElement?.nativeElement;
      while (treeElement.parentElement && treeElement.role !== 'tree') {
        treeElement = treeElement.parentElement;
      }
      return Array.from(treeElement.querySelectorAll('[role="treeitem"]'));
    }
    focusToNextNode() {
      const visibleTreeElements = this.visibleTreeElements();
      const treeItemElement = this.treeItemElement();
      if (!treeItemElement?.nativeElement) {
        return;
      }
      const i = visibleTreeElements.indexOf(treeItemElement?.nativeElement);
      visibleTreeElements[Math.min(i + 1, visibleTreeElements.length - 1)]?.focus();
    }
    focusToPreviousNode() {
      const visibleTreeElements = this.visibleTreeElements();
      const treeItemElement = this.treeItemElement();
      if (!treeItemElement?.nativeElement) {
        return;
      }
      const i = visibleTreeElements.indexOf(treeItemElement?.nativeElement);
      visibleTreeElements[Math.max(i - 1, 0)]?.focus();
    }
    focusToStart() {
      const visibleTreeElements = this.visibleTreeElements();
      if (!this.treeItemElement()?.nativeElement) {
        return;
      }
      visibleTreeElements[0]?.focus();
    }
    focusToEnd() {
      const visibleTreeElements = this.visibleTreeElements();
      if (!this.treeItemElement()?.nativeElement) {
        return;
      }
      visibleTreeElements[visibleTreeElements.length - 1]?.focus();
    }
    static {
      this.ɵfac = function TreeItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TreeItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TreeItemComponent,
        selectors: [["rbb-tree-item"]],
        viewQuery: function TreeItemComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.treeItemElement, _c32, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          treeItem: "treeItem",
          subTree: [1, "subTree"],
          foldedIcon: [1, "foldedIcon"],
          unfoldedIcon: [1, "unfoldedIcon"],
          itemIcon: [1, "itemIcon"],
          selected: "selected",
          selectOnlyItems: [1, "selectOnlyItems"],
          rememberId: [1, "rememberId"],
          search: [1, "search"],
          parentElement: [1, "parentElement"]
        },
        outputs: {
          itemSelect: "itemSelect"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [["treeItemElement", ""], ["role", "group", 1, "ps-3", 3, "id"], ["role", "presentation"], [1, "pointer", 3, "click"], ["tabindex", "0", "role", "treeitem", 1, "inline-block", "pointer", "ps-2", 3, "click", "keydown.enter", "keydown.arrowLeft", "keydown.arrowDown", "keydown.arrowUp", "keydown.home", "keydown.end", "ngClass"], [3, "bg-warning"], [1, "pointer", 3, "class"], ["tabindex", "0", "role", "treeitem", 1, "inline-block", "pointer", "ps-2", 3, "click", "keydown.enter", "keydown.arrowRight", "keydown.arrowLeft", "keydown.arrowDown", "keydown.arrowUp", "keydown.home", "keydown.end", "ngClass"], [3, "treeItem", "search", "subTree", "selected", "foldedIcon", "unfoldedIcon", "itemIcon", "selectOnlyItems", "parentElement"], [3, "itemSelect", "treeItem", "search", "subTree", "selected", "foldedIcon", "unfoldedIcon", "itemIcon", "selectOnlyItems", "parentElement"]],
        template: function TreeItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TreeItemComponent_Conditional_0_Template, 2, 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.treeItem ? 0 : -1);
          }
        },
        dependencies: [TreeItemComponent, NgClass],
        encapsulation: 2
      });
    }
  }
  return TreeItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TreeComponent = /*#__PURE__*/(() => {
  class TreeComponent {
    constructor() {
      this.treeItem = input.required();
      this.foldedIcon = input();
      this.unfoldedIcon = input();
      this.itemIcon = input();
      this.selectOnlyItems = input();
      this.rememberId = input();
      this.enableSearch = input(false);
      this.search = '';
      // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
      this.onChange = _ => {};
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(obj) {
      this.selected = obj;
    }
    static {
      this.ɵfac = function TreeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TreeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TreeComponent,
        selectors: [["rbb-tree"]],
        hostBindings: function TreeComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function TreeComponent_blur_HostBindingHandler() {
              return ctx.onTouched();
            });
          }
        },
        inputs: {
          treeItem: [1, "treeItem"],
          foldedIcon: [1, "foldedIcon"],
          unfoldedIcon: [1, "unfoldedIcon"],
          itemIcon: [1, "itemIcon"],
          selectOnlyItems: [1, "selectOnlyItems"],
          rememberId: [1, "rememberId"],
          enableSearch: [1, "enableSearch"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => TreeComponent),
          multi: true
        }])],
        decls: 3,
        vars: 9,
        consts: [["role", "tree", "aria-orientation", "vertical"], ["type", "search", "placeholder", "Suche", "aria-label", "Suche", "aria-hidden", "true", 1, "form-control", "form-control-sm", "mb-2", 3, "ngModel"], [3, "itemSelect", "treeItem", "selected", "search", "foldedIcon", "unfoldedIcon", "itemIcon", "selectOnlyItems", "rememberId"], ["type", "search", "placeholder", "Suche", "aria-label", "Suche", "aria-hidden", "true", 1, "form-control", "form-control-sm", "mb-2", 3, "ngModelChange", "ngModel"]],
        template: function TreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, TreeComponent_Conditional_1_Template, 1, 1, "input", 1);
            i0.ɵɵelementStart(2, "rbb-tree-item", 2);
            i0.ɵɵlistener("itemSelect", function TreeComponent_Template_rbb_tree_item_itemSelect_2_listener($event) {
              return ctx.onChange($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.enableSearch() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("treeItem", ctx.treeItem())("selected", ctx.selected)("search", ctx.search.toLowerCase().trim())("foldedIcon", ctx.foldedIcon())("unfoldedIcon", ctx.unfoldedIcon())("itemIcon", ctx.itemIcon())("selectOnlyItems", ctx.selectOnlyItems())("rememberId", ctx.rememberId());
          }
        },
        dependencies: [FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, TreeItemComponent],
        styles: ["i[_ngcontent-%COMP%]{min-width:20px;display:inline-block}"]
      });
    }
  }
  return TreeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const baseColors = [[221, 21, 0],
// red
[88, 151, 38],
// green
[35, 117, 237],
// blue
[247, 117, 1],
// orange
[172, 63, 117],
// violet
[255, 213, 37],
// yellow
[94, 8, 0],
// red
[58, 99, 25],
// green
[16, 54, 110],
// blue
[120, 56, 0],
// orange
[120, 44, 82],
// violet
[128, 106, 18],
// yellow
[227, 81, 68],
// red
[171, 227, 125],
// green
[108, 161, 240],
// blue
[249, 156, 75],
// orange
[247, 166, 207],
// violet
[225, 226, 112] // yellow
];
function getColor(index = 0, alpha = 1) {
  const color = baseColors[index % baseColors.length];
  return 'rgba(' + color.concat(alpha).join(',') + ')';
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const chartDefaults = {
  font: {
    family: 'rbb V2 Interstate, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
    weight: 300
  },
  plugins: {
    colors: {
      enabled: false
    },
    legend: {
      display: true,
      position: 'right'
    }
  },
  borderColor: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300'),
  color: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-secondary-color'),
  datasets: {
    bar: {
      backgroundColor: context => getColor(context.datasetIndex, 1),
      borderColor: context => getColor(context.datasetIndex, 1)
    },
    bubble: {
      backgroundColor: context => getColor(context.dataIndex, 1),
      borderColor: context => getColor(context.dataIndex, 1),
      borderWidth: 0
    },
    doughnut: {
      backgroundColor: context => getColor(context.dataIndex, 1),
      borderColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
    },
    line: {
      backgroundColor: context => getColor(context.datasetIndex, 1),
      borderColor: context => getColor(context.datasetIndex, 1),
      pointBackgroundColor: context => getColor(context.datasetIndex, 1),
      pointBorderWidth: 0,
      pointRadius: 5
    },
    pie: {
      backgroundColor: context => getColor(context.dataIndex, 1),
      borderColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
    },
    polarArea: {
      backgroundColor: context => getColor(context.dataIndex, 1),
      borderColor: context => getColor(context.dataIndex, 1)
    },
    radar: {
      backgroundColor: context => getColor(context.datasetIndex, 0.6),
      borderColor: context => getColor(context.datasetIndex, 0.6),
      pointBackgroundColor: context => getColor(context.datasetIndex, 1),
      pointRadius: 5
    },
    scatter: {
      backgroundColor: context => getColor(context.dataIndex, 1),
      borderColor: context => getColor(context.dataIndex, 1),
      pointBorderWidth: 0,
      pointRadius: 5
    }
  },
  scales: {
    category: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    },
    linear: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    },
    logarithmic: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    },
    radialLinear: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    },
    time: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    },
    timeseries: {
      grid: {
        color: () => getComputedStyle(document.documentElement).getPropertyValue(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '--bs-gray-700' : '--bs-gray-300')
      },
      ticks: {
        backdropColor: () => getComputedStyle(document.documentElement).getPropertyValue('--bs-body-bg')
      }
    }
  }
};
Chart.register(...registerables);
defaults.set(chartDefaults);
let BaseChartDirective = /*#__PURE__*/(() => {
  class BaseChartDirective {
    constructor() {
      this.element = inject(ElementRef);
      this.zone = inject(NgZone);
      this.type = input.required();
      this.ariaLabel = input.required();
      this.legend = input();
      this.data = input();
      this.options = input();
      this.plugins = input([]);
      this.labels = input();
      this.datasets = input();
      this.chartClickEmitter = new Subject();
      this.chartClick = outputFromObservable(this.chartClickEmitter);
      this.chartHoverEmitter = new Subject();
      this.chartHover = outputFromObservable(this.chartHoverEmitter);
      this.themeOverrides = {};
      this.observer = new MutationObserver(() => this.update());
      const element = this.element;
      this.ctx = element.nativeElement.getContext('2d');
      this.observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-bs-theme']
      });
    }
    ngOnInit() {
      const ariaLabel = this.ariaLabel();
      this.element.nativeElement.ariaLabel = ariaLabel?.toLowerCase()?.includes('diagram') ? ariaLabel : 'Diagramm: ' + ariaLabel;
    }
    ngOnChanges(changes) {
      const requireRender = ['type'];
      const propertyNames = Object.getOwnPropertyNames(changes);
      if (propertyNames.some(key => requireRender.includes(key)) || propertyNames.every(key => changes[key].isFirstChange())) {
        this.render();
      } else {
        const config = this.getChartConfiguration();
        // Using assign to avoid changing the original object reference
        if (this.chart) {
          Object.assign(this.chart.config.data, config.data);
          if (this.chart.config.plugins) {
            Object.assign(this.chart.config.plugins, config.plugins);
          }
          if (this.chart.config.options) {
            Object.assign(this.chart.config.options, config.options);
          }
        }
        this.update();
      }
    }
    ngOnDestroy() {
      this.observer.disconnect();
      if (this.chart) {
        this.chart.destroy();
        this.chart = void 0;
      }
    }
    render() {
      if (this.chart) {
        this.chart.destroy();
      }
      return this.zone.runOutsideAngular(() => this.chart = new Chart(this.ctx, this.getChartConfiguration()));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(duration) {
      if (this.chart) {
        this.zone.runOutsideAngular(() => this.chart?.update(duration));
      }
    }
    hideDataset(index, hidden) {
      if (this.chart) {
        this.chart.getDatasetMeta(index).hidden = hidden;
        this.update();
      }
    }
    isDatasetHidden(index) {
      return this.chart?.getDatasetMeta(index)?.hidden;
    }
    toBase64Image() {
      return this.chart?.toBase64Image();
    }
    getChartOptions() {
      return merge({
        onHover: (event, active) => {
          if (!this.chartHoverEmitter.observed) {
            return;
          }
          this.zone.run(() => this.chartHoverEmitter.next({
            event,
            active
          }));
        },
        onClick: (event, active) => {
          if (!this.chartClickEmitter.observed) {
            return;
          }
          this.zone.run(() => this.chartClickEmitter.next({
            event,
            active
          }));
        }
      }, this.themeOverrides, this.options(), {
        plugins: {
          legend: {
            display: this.legend()
          }
        }
      });
    }
    getChartConfiguration() {
      return {
        type: this.type(),
        data: this.getChartData(),
        options: this.getChartOptions(),
        plugins: this.plugins()
      };
    }
    getChartData() {
      const data = this.data();
      return data ? data : {
        labels: this.labels() ?? [],
        datasets: this.datasets() ?? []
      };
    }
    static {
      this.ɵfac = function BaseChartDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BaseChartDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BaseChartDirective,
        selectors: [["canvas", "rbbBaseChart", ""]],
        inputs: {
          type: [1, "type"],
          ariaLabel: [1, "ariaLabel"],
          legend: [1, "legend"],
          data: [1, "data"],
          options: [1, "options"],
          plugins: [1, "plugins"],
          labels: [1, "labels"],
          datasets: [1, "datasets"]
        },
        outputs: {
          chartClick: "chartClick",
          chartHover: "chartHover"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return BaseChartDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ButtonConfirmType = /*#__PURE__*/function (ButtonConfirmType) {
  ButtonConfirmType[ButtonConfirmType["ChangeText"] = 0] = "ChangeText";
  return ButtonConfirmType;
}(ButtonConfirmType || {});
let ButtonConfirmDirective = /*#__PURE__*/(() => {
  class ButtonConfirmDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.type = input(undefined, {
        alias: 'rbbButtonConfirmType'
      });
      // eslint-disable-next-line @angular-eslint/no-input-rename
      this.content = input(undefined, {
        alias: 'rbbButtonConfirmContent'
      });
      // eslint-disable-next-line @angular-eslint/no-input-rename
      this.staticWidth = input(false, {
        alias: 'rbbButtonConfirmStaticWidth'
      });
      this.rbbButtonConfirmOnConfirmed = output();
      this.confirming = false;
    }
    ngAfterViewInit() {
      if (this.staticWidth() && this.type() === ButtonConfirmType.ChangeText) {
        this.originalContent = this.el.nativeElement.innerHTML;
        const w1 = this.el.nativeElement.scrollWidth + 5;
        this.el.nativeElement.innerHTML = this.content();
        const w2 = this.el.nativeElement.scrollWidth + 5;
        this.el.nativeElement.style.minWidth = Math.max(w1, w2) + 'px';
        this.el.nativeElement.innerHTML = this.originalContent;
      }
    }
    buttonClick() {
      switch (this.type()) {
        case ButtonConfirmType.ChangeText:
          this.changeText();
          break;
      }
    }
    resetByClick(event) {
      if (event.target !== this.el.nativeElement) {
        this.reset();
      }
    }
    resetByKey(event) {
      if (event.key === 'Esc' || event.key === 'Tab') {
        this.reset();
      }
    }
    reset() {
      if (this.confirming) {
        this.el.nativeElement.innerHTML = this.originalContent;
        this.confirming = false;
        this.el.nativeElement.ariaDescription = undefined;
      }
    }
    changeText() {
      if (this.confirming) {
        this.rbbButtonConfirmOnConfirmed.emit(null);
        this.reset();
      } else {
        this.originalContent = this.el.nativeElement.innerHTML;
        this.el.nativeElement.innerHTML = this.content();
        this.confirming = true;
        this.el.nativeElement.ariaDescription = 'Escape zum Abbruch der Aktion benutzen.';
        const id = uuid();
        this.currentConfirming = id;
        setTimeout(() => {
          if (id === this.currentConfirming) {
            this.reset();
          }
        }, 8000);
      }
    }
    static {
      this.ɵfac = function ButtonConfirmDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonConfirmDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ButtonConfirmDirective,
        selectors: [["", "rbbButtonConfirmType", ""]],
        hostBindings: function ButtonConfirmDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ButtonConfirmDirective_click_HostBindingHandler() {
              return ctx.buttonClick();
            })("click", function ButtonConfirmDirective_click_HostBindingHandler($event) {
              return ctx.resetByClick($event);
            }, false, i0.ɵɵresolveDocument)("keydown", function ButtonConfirmDirective_keydown_HostBindingHandler($event) {
              return ctx.resetByKey($event);
            });
          }
        },
        inputs: {
          type: [1, "rbbButtonConfirmType", "type"],
          content: [1, "rbbButtonConfirmContent", "content"],
          staticWidth: [1, "rbbButtonConfirmStaticWidth", "staticWidth"]
        },
        outputs: {
          rbbButtonConfirmOnConfirmed: "rbbButtonConfirmOnConfirmed"
        }
      });
    }
  }
  return ButtonConfirmDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContextMenuComponent = /*#__PURE__*/(() => {
  class ContextMenuComponent {
    constructor() {
      this.windowX = document.body.offsetWidth;
      this.windowY = window.innerHeight;
      this.xLeft = 0;
      this.xRight = 0;
      this.y = 0;
      this.preXTurned = input(false);
      this.contextMenuItems = [];
      this.contextMenuSelect = output();
      this.contextMenuClose = output();
      this.subMenuId = uuid();
      this.x = 0;
      this.xTurned = false;
      this.openedSubMenuXLeft = 0;
      this.openedSubMenuXRight = 0;
      this.openedSubMenuY = 0;
      this.openedSubMenuXTurned = false;
      this.contextMenuElement = viewChild('contextMenuElement');
    }
    ngOnInit() {
      if (this.preXTurned()) {
        this.xTurned = true;
      }
      this.calcTurned();
    }
    ngOnChanges() {
      this.calcTurned();
      this.openedSubMenu = null;
    }
    ngAfterViewInit() {
      const contextMenuElement = this.contextMenuElement();
      if (contextMenuElement) {
        contextMenuElement.nativeElement.onContextMenu = () => false;
        contextMenuElement.nativeElement.addEventListener('click', this.stopPropagation);
        contextMenuElement.nativeElement.addEventListener('contextmenu', this.stopPropagation);
        if (this.controlElement) {
          contextMenuElement.nativeElement.ariaLabelledBy = this.controlElement.id;
        }
        if (document.body.getAttribute('data-tabnav') === 'true') {
          contextMenuElement.nativeElement.querySelector('[tabindex="0"]')?.focus();
        }
      }
    }
    windowResized() {
      this.windowX = window.innerWidth;
      this.windowY = window.innerHeight;
    }
    itemClick(target, item) {
      if ((!item.children || item.children.length === 0) && !item.header) {
        this.contextMenuSelect.emit(item);
      } else {
        this.openSubMenu(target, item);
      }
    }
    calcTurned() {
      if (this.xRight + 200 > window.innerWidth) {
        this.xTurned = true;
      }
      if (this.xTurned) {
        this.x = this.xLeft;
      } else {
        this.x = this.xRight;
      }
      const menuPaddingHeight = 18;
      const menuHeight = this.contextMenuItems.map(item => item.groupEnd ? 49 : 32).reduce((sum, current) => sum + current, 0) + menuPaddingHeight;
      if (menuHeight + this.y > window.innerHeight - 10) {
        this.y = window.innerHeight - menuHeight - 10;
        if (this.y < 0) {
          this.y = 0;
        }
      }
    }
    openSubMenu(target, item) {
      if (item.children && item.children.length > 0) {
        if (this.xTurned) {
          this.openedSubMenuXLeft = this.x - target.offsetWidth;
          this.openedSubMenuXRight = this.x;
        } else {
          this.openedSubMenuXLeft = this.x;
          this.openedSubMenuXRight = this.x + target.offsetWidth;
        }
        this.openedSubMenuY = this.y + target.offsetTop;
        this.openedSubMenuXTurned = this.xTurned;
        this.openedSubMenu = item;
      }
    }
    closeSubMenu() {
      this.contextMenuElement()?.nativeElement.querySelector('.opened')?.focus();
      this.openedSubMenu = null;
    }
    stopPropagation(event) {
      if (event.preventDefault) {
        event.preventDefault();
      }
      event.stopPropagation();
    }
    focusToNextNode(index) {
      const focusableElements = this.contextMenuElement()?.nativeElement.querySelectorAll('[tabindex="0"]');
      if (index < focusableElements.length - 1) {
        focusableElements.item(index + 1).focus();
      }
    }
    focusToPreviousNode(index) {
      const focusableElements = this.contextMenuElement()?.nativeElement.querySelectorAll('[tabindex="0"]');
      if (index > 0) {
        focusableElements.item(index - 1).focus();
      }
    }
    focusToStart() {
      const focusableElements = this.contextMenuElement()?.nativeElement.querySelectorAll('[tabindex="0"]');
      focusableElements.item(0).focus();
    }
    focusToEnd() {
      const focusableElements = this.contextMenuElement()?.nativeElement.querySelectorAll('[tabindex="0"]');
      focusableElements.item(focusableElements.length - 1).focus();
    }
    static {
      this.ɵfac = function ContextMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContextMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContextMenuComponent,
        selectors: [["rbb-context-menu"]],
        viewQuery: function ContextMenuComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.contextMenuElement, _c34, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostBindings: function ContextMenuComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function ContextMenuComponent_resize_HostBindingHandler() {
              return ctx.windowResized();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          id: "id",
          xLeft: "xLeft",
          xRight: "xRight",
          y: "y",
          preXTurned: [1, "preXTurned"],
          contextMenuItems: "contextMenuItems",
          controlElement: "controlElement"
        },
        outputs: {
          contextMenuSelect: "contextMenuSelect",
          contextMenuClose: "contextMenuClose"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 7,
        consts: [["contextMenuElement", ""], ["itemElement", ""], ["role", "menu", 1, "context-menu", "position-fixed", "shadow", "py-2", 3, "keydown.escape", "id", "ngStyle"], [3, "contextMenuItems", "xLeft", "xRight", "y", "preXTurned", "id", "controlElement"], [1, "dropdown-header", "px-2"], ["tabindex", "0", "role", "menuitem", 1, "dropdown-item", "position-relative", "px-2", 3, "ngClass"], [1, "dropdown-divider"], [1, "d-inline-block", "me-2", 3, "ngClass"], ["tabindex", "0", "role", "menuitem", 1, "dropdown-item", "position-relative", "px-2", 3, "mouseenter", "keydown.arrowRight", "keydown.enter", "keydown.space", "keydown.arrowDown", "keydown.arrowUp", "keydown.home", "keydown.end", "click", "ngClass"], [1, "d-inline-block", "fa-solid", "fa-caret-right", "ms-auto"], [3, "contextMenuClose", "contextMenuSelect", "contextMenuItems", "xLeft", "xRight", "y", "preXTurned", "id", "controlElement"]],
        template: function ContextMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2, 0);
            i0.ɵɵlistener("keydown.escape", function ContextMenuComponent_Template_div_keydown_escape_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.contextMenuClose.emit();
              $event.preventDefault();
              return i0.ɵɵresetView($event.stopPropagation());
            });
            i0.ɵɵrepeaterCreate(2, ContextMenuComponent_For_3_Template, 3, 2, null, null, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ContextMenuComponent_Conditional_4_Template, 1, 7, "rbb-context-menu", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.id)("ngStyle", i0.ɵɵpureFunction3(3, _c35, ctx.y + "px", ctx.xTurned ? "unset" : ctx.xRight + "px", ctx.xTurned ? ctx.windowX - ctx.xLeft + "px" : "unset"));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.contextMenuItems);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.openedSubMenu && ctx.openedSubMenu.children && ctx.openedSubMenu.children.length ? 4 : -1);
          }
        },
        dependencies: [ContextMenuComponent, NgStyle, NgClass],
        styles: [".context-menu[_ngcontent-%COMP%]{--bs-dropdown-zindex: 1025;--bs-dropdown-min-width: 10rem;--bs-dropdown-padding-x: 0;--bs-dropdown-padding-y: .5rem;--bs-dropdown-spacer: .125rem;--bs-dropdown-font-size: 1rem;--bs-dropdown-color: var(--bs-body-color);--bs-dropdown-bg: var(--bs-body-bg);--bs-dropdown-border-color: var(--bs-border-color-translucent);--bs-dropdown-border-radius: var(--bs-border-radius);--bs-dropdown-border-width: var(--bs-border-width);--bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));--bs-dropdown-divider-bg: var(--bs-border-color-translucent);--bs-dropdown-divider-margin-y: .5rem;--bs-dropdown-box-shadow: var(--bs-box-shadow);--bs-dropdown-link-color: var(--bs-body-color);--bs-dropdown-link-hover-color: var(--bs-body-color);--bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);--bs-dropdown-link-active-color: #fff;--bs-dropdown-link-active-bg: rgb(88, 88, 86);--bs-dropdown-link-disabled-color: var(--bs-tertiary-color);--bs-dropdown-item-padding-x: 1rem;--bs-dropdown-item-padding-y: .25rem;--bs-dropdown-header-color: var(--bs-secondary-color);--bs-dropdown-header-padding-x: 1rem;--bs-dropdown-header-padding-y: .5rem;position:absolute;z-index:var(--bs-dropdown-zindex);min-width:var(--bs-dropdown-min-width);padding:var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);margin:0;font-size:var(--bs-dropdown-font-size);color:var(--bs-dropdown-color);text-align:left;list-style:none;background-color:var(--bs-dropdown-bg);background-clip:padding-box;border:var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);border-radius:var(--bs-dropdown-border-radius)}i.d-inline-block[_ngcontent-%COMP%]{width:25px;text-align:center}.dropdown-item.opened[_ngcontent-%COMP%]{color:var(--bs-dropdown-link-active-color);text-decoration:none;background-color:var(--bs-dropdown-link-active-bg)}i.fas.fa-caret-right[_ngcontent-%COMP%]{height:20px;line-height:20px;vertical-align:center}"]
      });
    }
  }
  return ContextMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContextMenuService = /*#__PURE__*/(() => {
  class ContextMenuService {
    constructor() {
      this.applicationRef = inject(ApplicationRef);
      document.body.addEventListener('click', () => this.removeContextMenu());
      document.body.addEventListener('contextmenu', () => this.removeContextMenu());
      document.body.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.removeContextMenu();
        }
      });
    }
    removeContextMenu() {
      if (this.contextMenuComponent) {
        if (this.contextMenuComponent.instance.controlElement) {
          this.contextMenuComponent.instance.controlElement.ariaExpanded = 'false';
          this.contextMenuComponent.instance.controlElement.removeAttribute('aria-controls');
        }
        this.applicationRef.detachView(this.contextMenuComponent.hostView);
        this.contextMenuComponent.destroy();
      }
    }
    createContextMenuByMouseEvent(event, contextMenuItems) {
      return this.createContextMenuByCoordinates(event.clientX, event.clientY, contextMenuItems, event.currentTarget);
    }
    createContextMenuByCoordinates(x, y, contextMenuItems, currentTarget) {
      this.removeContextMenu();
      const componentRef = createComponent(ContextMenuComponent, {
        environmentInjector: this.applicationRef.injector
      });
      componentRef.instance.id = uuid();
      componentRef.instance.xLeft = x;
      componentRef.instance.xRight = x;
      componentRef.instance.y = y;
      componentRef.instance.contextMenuItems = contextMenuItems;
      componentRef.instance.controlElement = currentTarget;
      componentRef.instance.contextMenuSelect.subscribe(item => {
        if (!item.children || item.children.length === 0) {
          this.removeContextMenu();
        }
      });
      componentRef.instance.contextMenuClose.subscribe(() => {
        componentRef.instance.controlElement?.focus();
        this.removeContextMenu();
      });
      if (componentRef.instance.controlElement) {
        if (!componentRef.instance.controlElement.id) {
          componentRef.instance.controlElement.id = uuid();
        }
        componentRef.instance.controlElement.ariaHasPopup = 'menu';
        componentRef.instance.controlElement.ariaExpanded = 'true';
        componentRef.instance.controlElement.setAttribute('aria-controls', componentRef.instance.id);
      }
      this.applicationRef.attachView(componentRef.hostView);
      const element = componentRef.hostView.rootNodes[0];
      if (componentRef.instance.controlElement) {
        if (componentRef.instance.controlElement.tagName === 'TD' || componentRef.instance.controlElement.tagName === 'TH') {
          componentRef.instance.controlElement.appendChild(element);
        } else {
          componentRef.instance.controlElement.after(element);
        }
      } else {
        document.body.appendChild(element);
      }
      this.contextMenuComponent = componentRef;
      return componentRef.instance.contextMenuSelect;
    }
    static {
      this.ɵfac = function ContextMenuService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContextMenuService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ContextMenuService,
        factory: ContextMenuService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ContextMenuService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContextMenuDirective = /*#__PURE__*/(() => {
  class ContextMenuDirective {
    constructor() {
      this.contextMenuService = inject(ContextMenuService);
      this.contextMenuItems = input(undefined, {
        alias: 'rbbContextMenu'
      });
      this.rbbContextMenuSelect = output();
      const el = inject(ElementRef);
      el.nativeElement.onContextMenu = () => false;
      el.nativeElement.ariaHasPopup = 'menu';
      el.nativeElement.ariaExpanded = 'false';
    }
    onMouseClick(event) {
      const contextMenuItems = this.contextMenuItems();
      if (contextMenuItems) {
        this.contextMenuService.createContextMenuByMouseEvent(event, contextMenuItems).subscribe(item => {
          if (!item.children || item.children.length === 0) {
            this.rbbContextMenuSelect.emit(item);
          }
        });
      }
      if (event.preventDefault) {
        event.preventDefault();
      }
      event.stopPropagation();
    }
    static {
      this.ɵfac = function ContextMenuDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContextMenuDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ContextMenuDirective,
        selectors: [["", "rbbContextMenu", ""]],
        hostBindings: function ContextMenuDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("contextmenu", function ContextMenuDirective_contextmenu_HostBindingHandler($event) {
              return ctx.onMouseClick($event);
            });
          }
        },
        inputs: {
          contextMenuItems: [1, "rbbContextMenu", "contextMenuItems"]
        },
        outputs: {
          rbbContextMenuSelect: "rbbContextMenuSelect"
        }
      });
    }
  }
  return ContextMenuDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CopyTooltipDirective = /*#__PURE__*/(() => {
  class CopyTooltipDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.copyContent = input(undefined, {
        alias: 'rbbCopyTooltip'
      });
      const el = this.el;
      el.nativeElement.setAttribute('data-bs-placement', 'right');
      el.nativeElement.title = 'Kopieren';
      el.nativeElement.setAttribute('data-bs-trigger', 'hover');
      el.nativeElement.setAttribute('data-bs-original-title', 'Kopieren');
      el.nativeElement.setAttribute('data-bs-toggle', 'tooltip');
    }
    onMouseClick(event) {
      const copyContent = this.copyContent();
      if (copyContent) {
        navigator.clipboard.writeText(copyContent).then(() => this.changeTooltip('Erfolgreich!'), () => this.changeTooltip('Fehler beim kopieren'));
      }
      event.stopPropagation();
    }
    changeTooltip(text) {
      const tooltipElementId = this.el.nativeElement.getAttribute('aria-describedby');
      if (tooltipElementId) {
        const innerTooltipElement = document.querySelector('#' + tooltipElementId + ' .tooltip-inner');
        if (innerTooltipElement) {
          innerTooltipElement.innerText = text;
        }
      }
    }
    static {
      this.ɵfac = function CopyTooltipDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CopyTooltipDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CopyTooltipDirective,
        selectors: [["", "rbbCopyTooltip", ""]],
        hostBindings: function CopyTooltipDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function CopyTooltipDirective_click_HostBindingHandler($event) {
              return ctx.onMouseClick($event);
            });
          }
        },
        inputs: {
          copyContent: [1, "rbbCopyTooltip", "copyContent"]
        }
      });
    }
  }
  return CopyTooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DragSortDirection = /*#__PURE__*/function (DragSortDirection) {
  DragSortDirection[DragSortDirection["HORIZONTAL"] = 0] = "HORIZONTAL";
  DragSortDirection[DragSortDirection["VERTICAL"] = 1] = "VERTICAL";
  return DragSortDirection;
}(DragSortDirection || {});
let DragSortDirective = /*#__PURE__*/(() => {
  class DragSortDirective {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.childrenSorted = output({
        alias: 'rbbDragSort'
      });
      this.movedElement = output({
        alias: 'rbbDragSortMovedElement'
      });
      this.direction = input(undefined, {
        alias: 'rbbDragSortDirection'
      });
      this.mouseStartX = 0;
      this.mouseStartY = 0;
    }
    static getOuterHeight(element) {
      const computedStyle = window.getComputedStyle(element);
      return element.offsetHeight + parseFloat(computedStyle.marginTop) + parseFloat(computedStyle.marginBottom);
    }
    static getOuterWidth(element) {
      const computedStyle = window.getComputedStyle(element);
      return element.offsetWidth + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
    }
    ngAfterViewInit() {
      this.elementRef.nativeElement.addEventListener('DOMNodeInserted', () => this.initChildren(), false);
      this.initChildren();
    }
    initChildren() {
      const element = this.elementRef.nativeElement;
      for (const child of element.children) {
        if (!child.classList.contains('drag-element')) {
          child.classList.add('drag-element');
          child.style.position = 'relative';
          if (!child.getAttribute('data-zindex')) {
            child.setAttribute('data-zindex', 'z' + child.style.zIndex);
          }
          child.setAttribute('tabindex', '0');
          const dragPoints = child.querySelectorAll('.drag-point');
          if (dragPoints.length > 0) {
            for (const dragPoint of dragPoints) {
              dragPoint.addEventListener('mousedown', event => this.startDrag(event));
              dragPoint.style.cursor = 'grab';
            }
          } else {
            child.addEventListener('mousedown', event => this.startDrag(event));
            child.style.cursor = 'grab';
          }
          child.addEventListener('keydown', event => this.sortWithKeyboard(event));
          child.setAttribute('data-cursor', child.style.cursor);
        }
      }
    }
    sortWithKeyboard(event) {
      const item = event.target;
      const children = this.elementRef.nativeElement.children;
      if (event.key === 's' || event.key === 'd') {
        let oldIndex = 0;
        for (const c of children) {
          if (c === item) {
            break;
          }
          oldIndex++;
        }
        if (oldIndex < children.length - 1) {
          const switchElement = children[oldIndex + 1];
          this.elementRef.nativeElement.insertBefore(item, switchElement.nextSibling);
        }
      }
      if (event.key === 'w' || event.key === 'a') {
        let oldIndex = 0;
        for (const c of children) {
          if (c === item) {
            break;
          }
          oldIndex++;
        }
        if (oldIndex > 0) {
          const switchElement = children[oldIndex - 1];
          this.elementRef.nativeElement.insertBefore(item, switchElement);
        }
      }
      this.childrenSorted.emit(this.elementRef.nativeElement.children);
      item.focus();
      event.stopImmediatePropagation();
    }
    startDrag(event) {
      this.previousOrder = this.elementRef.nativeElement.children;
      this.draggedElement = event.target;
      while (!this.draggedElement?.classList.contains('drag-element')) {
        this.draggedElement = this.draggedElement?.parentNode;
      }
      this.draggedElement.style.cursor = 'grabbing !important';
      this.draggedElement.style.zIndex = '1200';
      this.mouseStartX = event.clientX;
      this.mouseStartY = event.clientY;
      this.draggedElement.focus();
      event.preventDefault();
      event.stopPropagation();
    }
    mouseMoved(event) {
      if (this.draggedElement) {
        const diffX = event.clientX - this.mouseStartX;
        const diffY = event.clientY - this.mouseStartY;
        this.draggedElement.style.left = diffX + 'px';
        this.draggedElement.style.top = diffY + 'px';
        const direction = this.direction();
        if (direction === DragSortDirection.VERTICAL) {
          if (diffY > DragSortDirective.getOuterHeight(this.draggedElement) / 2) {
            const children = this.elementRef.nativeElement.children;
            let oldIndex = 0;
            for (const c of children) {
              if (c === this.draggedElement) {
                break;
              }
              oldIndex++;
            }
            if (oldIndex < children.length - 1) {
              const switchElement = children[oldIndex + 1];
              this.elementRef.nativeElement.insertBefore(this.draggedElement, switchElement.nextSibling);
              this.mouseStartY += switchElement.offsetHeight + Math.max(parseFloat(window.getComputedStyle(this.draggedElement).marginBottom), parseFloat(window.getComputedStyle(switchElement).marginTop));
              this.draggedElement.style.top = event.clientY - this.mouseStartY + 'px';
            }
          }
          if (diffY < -(DragSortDirective.getOuterHeight(this.draggedElement) / 2)) {
            const children = this.elementRef.nativeElement.children;
            let oldIndex = 0;
            for (const c of children) {
              if (c === this.draggedElement) {
                break;
              }
              oldIndex++;
            }
            if (oldIndex > 0) {
              const switchElement = children[oldIndex - 1];
              this.elementRef.nativeElement.insertBefore(this.draggedElement, switchElement);
              this.mouseStartY -= switchElement.offsetHeight + Math.max(parseFloat(window.getComputedStyle(this.draggedElement).marginTop), parseFloat(window.getComputedStyle(switchElement).marginBottom));
              this.draggedElement.style.top = event.clientY - this.mouseStartY + 'px';
            }
          }
        }
        if (direction === DragSortDirection.HORIZONTAL) {
          if (diffX > DragSortDirective.getOuterWidth(this.draggedElement) / 2) {
            const children = this.elementRef.nativeElement.children;
            let oldIndex = 0;
            for (const c of children) {
              if (c === this.draggedElement) {
                break;
              }
              oldIndex++;
            }
            if (oldIndex < children.length - 1) {
              const switchElement = children[oldIndex + 1];
              this.elementRef.nativeElement.insertBefore(this.draggedElement, switchElement.nextSibling);
              this.mouseStartX += switchElement.offsetWidth + Math.max(parseFloat(window.getComputedStyle(this.draggedElement).marginRight), parseFloat(window.getComputedStyle(switchElement).marginLeft));
              this.draggedElement.style.left = event.clientX - this.mouseStartX + 'px';
            }
          }
          if (diffX < -(DragSortDirective.getOuterWidth(this.draggedElement) / 2)) {
            const children = this.elementRef.nativeElement.children;
            let oldIndex = 0;
            for (const c of children) {
              if (c === this.draggedElement) {
                break;
              }
              oldIndex++;
            }
            if (oldIndex > 0) {
              const switchElement = children[oldIndex - 1];
              this.elementRef.nativeElement.insertBefore(this.draggedElement, switchElement);
              this.mouseStartX -= switchElement.offsetWidth + Math.max(parseFloat(window.getComputedStyle(this.draggedElement).marginLeft), parseFloat(window.getComputedStyle(switchElement).marginRight));
              this.draggedElement.style.left = event.clientX - this.mouseStartX + 'px';
            }
          }
        }
      }
    }
    stopDrag() {
      if (this.draggedElement) {
        this.draggedElement.style.top = '0';
        this.draggedElement.style.left = '0';
        this.draggedElement.style.zIndex = this.draggedElement.getAttribute('data-zindex')?.substring(1) ?? '';
        this.draggedElement.style.cursor = this.draggedElement.getAttribute('data-cursor') ?? '';
        this.movedElement.emit(this.draggedElement);
        this.draggedElement = null;
        this.childrenSorted.emit(this.elementRef.nativeElement.children);
      }
    }
    static {
      this.ɵfac = function DragSortDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DragSortDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DragSortDirective,
        selectors: [["", "rbbDragSort", ""]],
        hostBindings: function DragSortDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousemove", function DragSortDirective_mousemove_HostBindingHandler($event) {
              return ctx.mouseMoved($event);
            }, false, i0.ɵɵresolveWindow)("mouseup", function DragSortDirective_mouseup_HostBindingHandler() {
              return ctx.stopDrag();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          direction: [1, "rbbDragSortDirection", "direction"]
        },
        outputs: {
          childrenSorted: "rbbDragSort",
          movedElement: "rbbDragSortMovedElement"
        }
      });
    }
  }
  return DragSortDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FaqPopoverDirective = /*#__PURE__*/(() => {
  class FaqPopoverDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.faqService = inject(FaqService);
      this.faqId = input.required({
        alias: 'rbbFaqPopover'
      });
    }
    ngOnInit() {
      this.faqService.getFaq(this.faqId()).subscribe(faq => {
        this.el.nativeElement.setAttribute('data-bs-toggle', 'popover');
        this.el.nativeElement.setAttribute('data-bs-custom-class', 'faq-popover');
        this.el.nativeElement.setAttribute('data-bs-title', faq.questions ?? ' ');
        this.el.nativeElement.setAttribute('data-bs-content', faq.answer ?? ' ');
        this.el.nativeElement.setAttribute('data-bs-html', 'true');
        this.el.nativeElement.setAttribute('data-bs-placement', 'bottom');
        this.el.nativeElement.setAttribute('data-bs-trigger', 'hover focus');
      });
    }
    static {
      this.ɵfac = function FaqPopoverDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FaqPopoverDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FaqPopoverDirective,
        selectors: [["", "rbbFaqPopover", ""]],
        inputs: {
          faqId: [1, "rbbFaqPopover", "faqId"]
        }
      });
    }
  }
  return FaqPopoverDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScrollSpyDirective = /*#__PURE__*/(() => {
  class ScrollSpyDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.spiedElementQuery = input.required();
      this.navElement = input();
      this.scrollElement = input();
      this.scrollOffset = input();
      this.sectionChange = output();
    }
    ngOnChanges() {
      this.ngAfterViewChecked();
    }
    ngAfterViewChecked() {
      const spiedElementQuery = this.spiedElementQuery();
      this.el.nativeElement?.querySelectorAll(spiedElementQuery).forEach(element => {
        if (element.id) {
          this.navElement()?.querySelectorAll(`[href="#${element.id}"]:not(.scroll-spy-initiated)`).forEach(navRefElement => {
            navRefElement.classList.add('scroll-spy-initiated');
            navRefElement.addEventListener('click', event => {
              this.scrollTo(element.id, event);
            });
            navRefElement.addEventListener('keydown', event => {
              if (event.key === 'Enter' || event.key === ' ') {
                this.scrollTo(element.id, event);
              }
            });
          });
        }
      });
      const scrollElement = this.scrollElement();
      if (scrollElement && !scrollElement.classList.contains('scroll-spy-initiated')) {
        scrollElement.classList.add('scroll-spy-initiated');
        scrollElement.addEventListener('scroll', () => this.onScroll());
      }
      this.onScroll();
    }
    scrollTo(elementId, event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const scrollElement = this.scrollElement() ?? this.el.nativeElement;
      const scrollOffset = this.scrollOffset();
      const target = scrollElement.getBoundingClientRect().top + (typeof scrollOffset === 'number' ? scrollOffset : scrollOffset?.offsetHeight ?? 0);
      const current = this.el.nativeElement.querySelector(`#${elementId}`).getBoundingClientRect().top;
      const diff = current - target;
      scrollElement.scrollBy({
        top: diff,
        behavior: 'smooth'
      });
    }
    onScroll() {
      let currentSection;
      const scrollTop = (this.scrollElement() ?? this.el.nativeElement).scrollTop;
      const scrollOffset = this.scrollOffset();
      const parentOffset = (this.scrollElement() ?? this.el.nativeElement).offsetTop + 80 + (typeof scrollOffset === 'number' ? scrollOffset : scrollOffset?.offsetHeight ?? 0);
      for (const element of this.el.nativeElement.querySelectorAll(this.spiedElementQuery())) {
        if (element.id && element.offsetTop - parentOffset <= scrollTop) {
          currentSection = element.id;
        }
      }
      if (currentSection !== this.currentSection) {
        this.currentSection = currentSection;
        const navElement = this.navElement();
        navElement?.querySelectorAll('.active[href]').forEach(navRefElement => {
          navRefElement.classList.remove('active');
        });
        navElement?.querySelectorAll(`[href="#${currentSection}"]`).forEach(navRefElement => {
          navRefElement.classList.add('active');
        });
        this.sectionChange.emit(this.currentSection);
      }
    }
    static {
      this.ɵfac = function ScrollSpyDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScrollSpyDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ScrollSpyDirective,
        selectors: [["", "rbbScrollSpy", ""]],
        hostBindings: function ScrollSpyDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function ScrollSpyDirective_scroll_HostBindingHandler() {
              return ctx.onScroll();
            });
          }
        },
        inputs: {
          spiedElementQuery: [1, "spiedElementQuery"],
          navElement: [1, "navElement"],
          scrollElement: [1, "scrollElement"],
          scrollOffset: [1, "scrollOffset"]
        },
        outputs: {
          sectionChange: "sectionChange"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return ScrollSpyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AdGroup {}
class AdUser {}
class CalendarGroup {}
class CalendarEntry {}
class CalendarRow {}
class ContextMenuItem {
  constructor() {
    this.groupEnd = false;
    this.header = false;
  }
}
class Faq {}
class FaqGroup {}
class ModalOptions {
  constructor() {
    this.keyboard = true;
  }
}
class NavbarConfig {}
class PatchNote {}
class ServiceVersion {}
class Setting {}
class SideMenuEntry {
  constructor() {
    this.disabled = false;
  }
}
class SideMenuGroup {}
class Step {
  constructor() {
    this.disabled = false;
  }
}
class TableColumn {}
class TreeItem {}
class WebVersion {}
let DmzService = /*#__PURE__*/(() => {
  class DmzService {
    constructor() {
      this.http = inject(HttpClient);
    }
    isDmz() {
      return this.http.get('https://tools.rbb-online.de/tools-service/api/dmz');
    }
    static {
      this.ɵfac = function DmzService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DmzService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DmzService,
        factory: DmzService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DmzService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
let RbbErrorHandler = /*#__PURE__*/(() => {
  class RbbErrorHandler {
    constructor() {
      this.http = inject(HttpClient);
    }
    handleError(e) {
      console.error(e);
      if (e?.message?.includes('NG0100')) {
        return;
      }
      if (e.error?.includes?.('HttpErrorResponse') && (e.message?.includes?.('0 ') || e.message?.includes?.('401 '))) {
        return;
      }
      if (e.message?.includes?.('client-registration/verify')) {
        return;
      }
      const errorMsg = {
        url: window.location.href,
        message: e?.message,
        error: e?.name ?? e?.error,
        defaultPrevented: e?.defaultPrevented,
        filename: e?.filename,
        lineno: e?.lineno,
        colno: e?.colno,
        target: e?.target?.toString(),
        currentTarget: e?.currentTarget?.toString(),
        ua: navigator.userAgent,
        browserName: getIdentifiedBrowserName ? getIdentifiedBrowserName() : null,
        path: e?.path?.map ? e?.path.map(element => element?.toString()) : e?.path ?? [],
        stack: e?.stack?.split ? e?.stack.split('\n') : e?.stack ?? [],
        outerHTMLTarget: e?.target?.outerHTML,
        outerHTMLCurrentTarget: e?.currentTarget?.outerHTML
      };
      this.http.post('https://tools.rbb-online.de/tools-service/api/error-collector', errorMsg).subscribe();
    }
    static {
      this.ɵfac = function RbbErrorHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RbbErrorHandler)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RbbErrorHandler,
        factory: RbbErrorHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RbbErrorHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HttpErrorHandlerInterceptor = /*#__PURE__*/(() => {
  class HttpErrorHandlerInterceptor {
    constructor() {
      this.browserMessagesService = inject(BrowserMessagesService);
      this.rbbTemplateConfig = inject(RbbTemplateConfig);
    }
    intercept(request, next) {
      if (this.rbbTemplateConfig.automaticErrorMessage) {
        return next.handle(request).pipe(catchError(error => {
          if (error.status !== 401) {
            this.browserMessagesService.showHttpError(error, request.method === 'GET' ? 'Daten konnten nicht geladen werden' : 'Daten konnten nicht zum Server gesendet werden');
          }
          return throwError(() => error);
        }));
      } else {
        return next.handle(request);
      }
    }
    static {
      this.ɵfac = function HttpErrorHandlerInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HttpErrorHandlerInterceptor)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HttpErrorHandlerInterceptor,
        factory: HttpErrorHandlerInterceptor.ɵfac
      });
    }
  }
  return HttpErrorHandlerInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RbbTemplateModule = /*#__PURE__*/(() => {
  class RbbTemplateModule {
    static forRoot(config) {
      registerLocaleData(localeDEDE);
      return {
        ngModule: RbbTemplateModule,
        providers: [{
          provide: RbbTemplateConfig,
          useValue: config
        }, {
          provide: LOCALE_ID,
          useValue: 'de-DE'
        }]
      };
    }
    static {
      this.ɵfac = function RbbTemplateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RbbTemplateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RbbTemplateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: ErrorHandler,
          useClass: RbbErrorHandler
        }, {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpErrorHandlerInterceptor,
          multi: true
        }, provideHttpClient(withInterceptorsFromDi())]
      });
    }
  }
  return RbbTemplateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ng-web-template-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdGroup, AdUser, BaseChartDirective, BrowserMessage, BrowserMessageType, BrowserMessagesService, ButtonConfirmDirective, ButtonConfirmType, CalendarComponent, CalendarEntry, CalendarGroup, CalendarRow, ContextMenuDirective, ContextMenuItem, ContextMenuService, CopyTooltipDirective, DmzService, DragSortDirection, DragSortDirective, ExportService, Faq, FaqComponent, FaqGroup, FaqPopoverDirective, FaqService, GroupPickerComponent, GroupService, LoaderComponent, ModalOptions, ModalRef, ModalService, MultiSelectComponent, MultiValueInputComponent, NavbarComponent, NavbarConfig, ObjectSearchPipe, PaginatorComponent, PatchNote, PatchNotesComponent, PeoplePickerComponent, ProgressComponent, RbbTemplateConfig, RbbTemplateModule, ScrollSpyDirective, SearchInputComponent, ServiceVersion, Setting, SettingComponent, SettingService, SideMenuComponent, SideMenuEntry, SideMenuGroup, SideMenuHeadlineComponent, Step, StepsCircleComponent, StepsComponent, TableColumn, TableComponent, TreeComponent, TreeItem, UserService, VersionService, WebVersion, baseColors, chartDefaults, getColor };
